import React from "react";

export const Secure = () => {
  return (
    <svg
      width="642"
      height="254"
      viewBox="0 0 642 254"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="min-w-[370px] w-[95%] md:w-[560px] md:h-[240px]"
    >
      <g clipPath="url(#clip0_905_5093)">
        <rect width="642" height="254" rx="13" fill="white" />
        <mask
          id="mask0_905_5093"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="0"
          width="643"
          height="254"
        >
          <rect
            x="-1"
            width="643"
            height="254"
            fill="url(#paint0_radial_905_5093)"
          />
        </mask>
        <g mask="url(#mask0_905_5093)">
          <path
            opacity="0.87"
            d="M7.58579 4.41421C8.36684 3.63316 9.63317 3.63317 10.4142 4.41421L11.5858 5.58579C12.3668 6.36684 12.3668 7.63317 11.5858 8.41421L10.4142 9.58579C9.63316 10.3668 8.36683 10.3668 7.58579 9.58579L6.41421 8.41421C5.63316 7.63316 5.63317 6.36683 6.41421 5.58579L7.58579 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.59"
            d="M23.5858 4.41421C24.3668 3.63316 25.6332 3.63317 26.4142 4.41421L27.5858 5.58579C28.3668 6.36684 28.3668 7.63317 27.5858 8.41421L26.4142 9.58579C25.6332 10.3668 24.3668 10.3668 23.5858 9.58579L22.4142 8.41421C21.6332 7.63316 21.6332 6.36683 22.4142 5.58579L23.5858 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M39.5858 4.41421C40.3668 3.63316 41.6332 3.63317 42.4142 4.41421L43.5858 5.58579C44.3668 6.36684 44.3668 7.63317 43.5858 8.41421L42.4142 9.58579C41.6332 10.3668 40.3668 10.3668 39.5858 9.58579L38.4142 8.41421C37.6332 7.63316 37.6332 6.36683 38.4142 5.58579L39.5858 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.37"
            d="M55.5858 4.41421C56.3668 3.63316 57.6332 3.63317 58.4142 4.41421L59.5858 5.58579C60.3668 6.36684 60.3668 7.63317 59.5858 8.41421L58.4142 9.58579C57.6332 10.3668 56.3668 10.3668 55.5858 9.58579L54.4142 8.41421C53.6332 7.63316 53.6332 6.36683 54.4142 5.58579L55.5858 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M71.5858 4.41421C72.3668 3.63316 73.6332 3.63317 74.4142 4.41421L75.5858 5.58579C76.3668 6.36684 76.3668 7.63317 75.5858 8.41421L74.4142 9.58579C73.6332 10.3668 72.3668 10.3668 71.5858 9.58579L70.4142 8.41421C69.6332 7.63316 69.6332 6.36683 70.4142 5.58579L71.5858 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M87.5858 4.41421C88.3668 3.63316 89.6332 3.63317 90.4142 4.41421L91.5858 5.58579C92.3668 6.36684 92.3668 7.63317 91.5858 8.41421L90.4142 9.58579C89.6332 10.3668 88.3668 10.3668 87.5858 9.58579L86.4142 8.41421C85.6332 7.63316 85.6332 6.36683 86.4142 5.58579L87.5858 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M103.586 4.41421C104.367 3.63316 105.633 3.63317 106.414 4.41421L107.586 5.58579C108.367 6.36684 108.367 7.63317 107.586 8.41421L106.414 9.58579C105.633 10.3668 104.367 10.3668 103.586 9.58579L102.414 8.41421C101.633 7.63316 101.633 6.36683 102.414 5.58579L103.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M119.586 4.41421C120.367 3.63316 121.633 3.63317 122.414 4.41421L123.586 5.58579C124.367 6.36684 124.367 7.63317 123.586 8.41421L122.414 9.58579C121.633 10.3668 120.367 10.3668 119.586 9.58579L118.414 8.41421C117.633 7.63316 117.633 6.36683 118.414 5.58579L119.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.2"
            d="M135.586 4.41421C136.367 3.63316 137.633 3.63317 138.414 4.41421L139.586 5.58579C140.367 6.36684 140.367 7.63317 139.586 8.41421L138.414 9.58579C137.633 10.3668 136.367 10.3668 135.586 9.58579L134.414 8.41421C133.633 7.63316 133.633 6.36683 134.414 5.58579L135.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M151.586 4.41421C152.367 3.63316 153.633 3.63317 154.414 4.41421L155.586 5.58579C156.367 6.36684 156.367 7.63317 155.586 8.41421L154.414 9.58579C153.633 10.3668 152.367 10.3668 151.586 9.58579L150.414 8.41421C149.633 7.63316 149.633 6.36683 150.414 5.58579L151.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M167.586 4.41421C168.367 3.63316 169.633 3.63317 170.414 4.41421L171.586 5.58579C172.367 6.36684 172.367 7.63317 171.586 8.41421L170.414 9.58579C169.633 10.3668 168.367 10.3668 167.586 9.58579L166.414 8.41421C165.633 7.63316 165.633 6.36683 166.414 5.58579L167.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M183.586 4.41421C184.367 3.63316 185.633 3.63317 186.414 4.41421L187.586 5.58579C188.367 6.36684 188.367 7.63317 187.586 8.41421L186.414 9.58579C185.633 10.3668 184.367 10.3668 183.586 9.58579L182.414 8.41421C181.633 7.63316 181.633 6.36683 182.414 5.58579L183.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M199.586 4.41421C200.367 3.63316 201.633 3.63317 202.414 4.41421L203.586 5.58579C204.367 6.36684 204.367 7.63317 203.586 8.41421L202.414 9.58579C201.633 10.3668 200.367 10.3668 199.586 9.58579L198.414 8.41421C197.633 7.63316 197.633 6.36683 198.414 5.58579L199.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M215.586 4.41421C216.367 3.63316 217.633 3.63317 218.414 4.41421L219.586 5.58579C220.367 6.36684 220.367 7.63317 219.586 8.41421L218.414 9.58579C217.633 10.3668 216.367 10.3668 215.586 9.58579L214.414 8.41421C213.633 7.63316 213.633 6.36683 214.414 5.58579L215.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M231.586 4.41421C232.367 3.63316 233.633 3.63317 234.414 4.41421L235.586 5.58579C236.367 6.36684 236.367 7.63317 235.586 8.41421L234.414 9.58579C233.633 10.3668 232.367 10.3668 231.586 9.58579L230.414 8.41421C229.633 7.63316 229.633 6.36683 230.414 5.58579L231.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.47"
            d="M247.586 4.41421C248.367 3.63316 249.633 3.63317 250.414 4.41421L251.586 5.58579C252.367 6.36684 252.367 7.63317 251.586 8.41421L250.414 9.58579C249.633 10.3668 248.367 10.3668 247.586 9.58579L246.414 8.41421C245.633 7.63316 245.633 6.36683 246.414 5.58579L247.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M263.586 4.41421C264.367 3.63316 265.633 3.63317 266.414 4.41421L267.586 5.58579C268.367 6.36684 268.367 7.63317 267.586 8.41421L266.414 9.58579C265.633 10.3668 264.367 10.3668 263.586 9.58579L262.414 8.41421C261.633 7.63316 261.633 6.36683 262.414 5.58579L263.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M279.586 4.41421C280.367 3.63316 281.633 3.63317 282.414 4.41421L283.586 5.58579C284.367 6.36684 284.367 7.63317 283.586 8.41421L282.414 9.58579C281.633 10.3668 280.367 10.3668 279.586 9.58579L278.414 8.41421C277.633 7.63316 277.633 6.36683 278.414 5.58579L279.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M295.586 4.41421C296.367 3.63316 297.633 3.63317 298.414 4.41421L299.586 5.58579C300.367 6.36684 300.367 7.63317 299.586 8.41421L298.414 9.58579C297.633 10.3668 296.367 10.3668 295.586 9.58579L294.414 8.41421C293.633 7.63316 293.633 6.36683 294.414 5.58579L295.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M311.586 4.41421C312.367 3.63316 313.633 3.63317 314.414 4.41421L315.586 5.58579C316.367 6.36684 316.367 7.63317 315.586 8.41421L314.414 9.58579C313.633 10.3668 312.367 10.3668 311.586 9.58579L310.414 8.41421C309.633 7.63316 309.633 6.36683 310.414 5.58579L311.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M327.586 4.41421C328.367 3.63316 329.633 3.63317 330.414 4.41421L331.586 5.58579C332.367 6.36684 332.367 7.63317 331.586 8.41421L330.414 9.58579C329.633 10.3668 328.367 10.3668 327.586 9.58579L326.414 8.41421C325.633 7.63316 325.633 6.36683 326.414 5.58579L327.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.11"
            d="M343.586 4.41421C344.367 3.63316 345.633 3.63317 346.414 4.41421L347.586 5.58579C348.367 6.36684 348.367 7.63317 347.586 8.41421L346.414 9.58579C345.633 10.3668 344.367 10.3668 343.586 9.58579L342.414 8.41421C341.633 7.63316 341.633 6.36683 342.414 5.58579L343.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M359.586 4.41421C360.367 3.63316 361.633 3.63317 362.414 4.41421L363.586 5.58579C364.367 6.36684 364.367 7.63317 363.586 8.41421L362.414 9.58579C361.633 10.3668 360.367 10.3668 359.586 9.58579L358.414 8.41421C357.633 7.63316 357.633 6.36683 358.414 5.58579L359.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.93"
            d="M375.586 4.41421C376.367 3.63316 377.633 3.63317 378.414 4.41421L379.586 5.58579C380.367 6.36684 380.367 7.63317 379.586 8.41421L378.414 9.58579C377.633 10.3668 376.367 10.3668 375.586 9.58579L374.414 8.41421C373.633 7.63316 373.633 6.36683 374.414 5.58579L375.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.67"
            d="M391.586 4.41421C392.367 3.63316 393.633 3.63317 394.414 4.41421L395.586 5.58579C396.367 6.36684 396.367 7.63317 395.586 8.41421L394.414 9.58579C393.633 10.3668 392.367 10.3668 391.586 9.58579L390.414 8.41421C389.633 7.63316 389.633 6.36683 390.414 5.58579L391.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.93"
            d="M407.586 4.41421C408.367 3.63316 409.633 3.63317 410.414 4.41421L411.586 5.58579C412.367 6.36684 412.367 7.63317 411.586 8.41421L410.414 9.58579C409.633 10.3668 408.367 10.3668 407.586 9.58579L406.414 8.41421C405.633 7.63316 405.633 6.36683 406.414 5.58579L407.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M423.586 4.41421C424.367 3.63316 425.633 3.63317 426.414 4.41421L427.586 5.58579C428.367 6.36684 428.367 7.63317 427.586 8.41421L426.414 9.58579C425.633 10.3668 424.367 10.3668 423.586 9.58579L422.414 8.41421C421.633 7.63316 421.633 6.36683 422.414 5.58579L423.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.37"
            d="M439.586 4.41421C440.367 3.63316 441.633 3.63317 442.414 4.41421L443.586 5.58579C444.367 6.36684 444.367 7.63317 443.586 8.41421L442.414 9.58579C441.633 10.3668 440.367 10.3668 439.586 9.58579L438.414 8.41421C437.633 7.63316 437.633 6.36683 438.414 5.58579L439.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M455.586 4.41421C456.367 3.63316 457.633 3.63317 458.414 4.41421L459.586 5.58579C460.367 6.36684 460.367 7.63317 459.586 8.41421L458.414 9.58579C457.633 10.3668 456.367 10.3668 455.586 9.58579L454.414 8.41421C453.633 7.63316 453.633 6.36683 454.414 5.58579L455.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M471.586 4.41421C472.367 3.63316 473.633 3.63317 474.414 4.41421L475.586 5.58579C476.367 6.36684 476.367 7.63317 475.586 8.41421L474.414 9.58579C473.633 10.3668 472.367 10.3668 471.586 9.58579L470.414 8.41421C469.633 7.63316 469.633 6.36683 470.414 5.58579L471.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M487.586 4.41421C488.367 3.63316 489.633 3.63317 490.414 4.41421L491.586 5.58579C492.367 6.36684 492.367 7.63317 491.586 8.41421L490.414 9.58579C489.633 10.3668 488.367 10.3668 487.586 9.58579L486.414 8.41421C485.633 7.63316 485.633 6.36683 486.414 5.58579L487.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M503.586 4.41421C504.367 3.63316 505.633 3.63317 506.414 4.41421L507.586 5.58579C508.367 6.36684 508.367 7.63317 507.586 8.41421L506.414 9.58579C505.633 10.3668 504.367 10.3668 503.586 9.58579L502.414 8.41421C501.633 7.63316 501.633 6.36683 502.414 5.58579L503.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M519.586 4.41421C520.367 3.63316 521.633 3.63317 522.414 4.41421L523.586 5.58579C524.367 6.36684 524.367 7.63317 523.586 8.41421L522.414 9.58579C521.633 10.3668 520.367 10.3668 519.586 9.58579L518.414 8.41421C517.633 7.63316 517.633 6.36683 518.414 5.58579L519.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M535.586 4.41421C536.367 3.63316 537.633 3.63317 538.414 4.41421L539.586 5.58579C540.367 6.36684 540.367 7.63317 539.586 8.41421L538.414 9.58579C537.633 10.3668 536.367 10.3668 535.586 9.58579L534.414 8.41421C533.633 7.63316 533.633 6.36683 534.414 5.58579L535.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M551.586 4.41421C552.367 3.63316 553.633 3.63317 554.414 4.41421L555.586 5.58579C556.367 6.36684 556.367 7.63317 555.586 8.41421L554.414 9.58579C553.633 10.3668 552.367 10.3668 551.586 9.58579L550.414 8.41421C549.633 7.63316 549.633 6.36683 550.414 5.58579L551.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.53"
            d="M567.586 4.41421C568.367 3.63316 569.633 3.63317 570.414 4.41421L571.586 5.58579C572.367 6.36684 572.367 7.63317 571.586 8.41421L570.414 9.58579C569.633 10.3668 568.367 10.3668 567.586 9.58579L566.414 8.41421C565.633 7.63316 565.633 6.36683 566.414 5.58579L567.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M583.586 4.41421C584.367 3.63316 585.633 3.63317 586.414 4.41421L587.586 5.58579C588.367 6.36684 588.367 7.63317 587.586 8.41421L586.414 9.58579C585.633 10.3668 584.367 10.3668 583.586 9.58579L582.414 8.41421C581.633 7.63316 581.633 6.36683 582.414 5.58579L583.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M599.586 4.41421C600.367 3.63316 601.633 3.63317 602.414 4.41421L603.586 5.58579C604.367 6.36684 604.367 7.63317 603.586 8.41421L602.414 9.58579C601.633 10.3668 600.367 10.3668 599.586 9.58579L598.414 8.41421C597.633 7.63316 597.633 6.36683 598.414 5.58579L599.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M615.586 4.41421C616.367 3.63316 617.633 3.63317 618.414 4.41421L619.586 5.58579C620.367 6.36684 620.367 7.63317 619.586 8.41421L618.414 9.58579C617.633 10.3668 616.367 10.3668 615.586 9.58579L614.414 8.41421C613.633 7.63316 613.633 6.36683 614.414 5.58579L615.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M631.586 4.41421C632.367 3.63316 633.633 3.63317 634.414 4.41421L635.586 5.58579C636.367 6.36684 636.367 7.63317 635.586 8.41421L634.414 9.58579C633.633 10.3668 632.367 10.3668 631.586 9.58579L630.414 8.41421C629.633 7.63316 629.633 6.36683 630.414 5.58579L631.586 4.41421Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M7.58579 20.4142C8.36684 19.6332 9.63317 19.6332 10.4142 20.4142L11.5858 21.5858C12.3668 22.3668 12.3668 23.6332 11.5858 24.4142L10.4142 25.5858C9.63316 26.3668 8.36683 26.3668 7.58579 25.5858L6.41421 24.4142C5.63316 23.6332 5.63317 22.3668 6.41421 21.5858L7.58579 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M23.5858 20.4142C24.3668 19.6332 25.6332 19.6332 26.4142 20.4142L27.5858 21.5858C28.3668 22.3668 28.3668 23.6332 27.5858 24.4142L26.4142 25.5858C25.6332 26.3668 24.3668 26.3668 23.5858 25.5858L22.4142 24.4142C21.6332 23.6332 21.6332 22.3668 22.4142 21.5858L23.5858 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M39.5858 20.4142C40.3668 19.6332 41.6332 19.6332 42.4142 20.4142L43.5858 21.5858C44.3668 22.3668 44.3668 23.6332 43.5858 24.4142L42.4142 25.5858C41.6332 26.3668 40.3668 26.3668 39.5858 25.5858L38.4142 24.4142C37.6332 23.6332 37.6332 22.3668 38.4142 21.5858L39.5858 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.37"
            d="M55.5858 20.4142C56.3668 19.6332 57.6332 19.6332 58.4142 20.4142L59.5858 21.5858C60.3668 22.3668 60.3668 23.6332 59.5858 24.4142L58.4142 25.5858C57.6332 26.3668 56.3668 26.3668 55.5858 25.5858L54.4142 24.4142C53.6332 23.6332 53.6332 22.3668 54.4142 21.5858L55.5858 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.23"
            d="M71.5858 20.4142C72.3668 19.6332 73.6332 19.6332 74.4142 20.4142L75.5858 21.5858C76.3668 22.3668 76.3668 23.6332 75.5858 24.4142L74.4142 25.5858C73.6332 26.3668 72.3668 26.3668 71.5858 25.5858L70.4142 24.4142C69.6332 23.6332 69.6332 22.3668 70.4142 21.5858L71.5858 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M87.5858 20.4142C88.3668 19.6332 89.6332 19.6332 90.4142 20.4142L91.5858 21.5858C92.3668 22.3668 92.3668 23.6332 91.5858 24.4142L90.4142 25.5858C89.6332 26.3668 88.3668 26.3668 87.5858 25.5858L86.4142 24.4142C85.6332 23.6332 85.6332 22.3668 86.4142 21.5858L87.5858 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M103.586 20.4142C104.367 19.6332 105.633 19.6332 106.414 20.4142L107.586 21.5858C108.367 22.3668 108.367 23.6332 107.586 24.4142L106.414 25.5858C105.633 26.3668 104.367 26.3668 103.586 25.5858L102.414 24.4142C101.633 23.6332 101.633 22.3668 102.414 21.5858L103.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M119.586 20.4142C120.367 19.6332 121.633 19.6332 122.414 20.4142L123.586 21.5858C124.367 22.3668 124.367 23.6332 123.586 24.4142L122.414 25.5858C121.633 26.3668 120.367 26.3668 119.586 25.5858L118.414 24.4142C117.633 23.6332 117.633 22.3668 118.414 21.5858L119.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M135.586 20.4142C136.367 19.6332 137.633 19.6332 138.414 20.4142L139.586 21.5858C140.367 22.3668 140.367 23.6332 139.586 24.4142L138.414 25.5858C137.633 26.3668 136.367 26.3668 135.586 25.5858L134.414 24.4142C133.633 23.6332 133.633 22.3668 134.414 21.5858L135.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M151.586 20.4142C152.367 19.6332 153.633 19.6332 154.414 20.4142L155.586 21.5858C156.367 22.3668 156.367 23.6332 155.586 24.4142L154.414 25.5858C153.633 26.3668 152.367 26.3668 151.586 25.5858L150.414 24.4142C149.633 23.6332 149.633 22.3668 150.414 21.5858L151.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M167.586 20.4142C168.367 19.6332 169.633 19.6332 170.414 20.4142L171.586 21.5858C172.367 22.3668 172.367 23.6332 171.586 24.4142L170.414 25.5858C169.633 26.3668 168.367 26.3668 167.586 25.5858L166.414 24.4142C165.633 23.6332 165.633 22.3668 166.414 21.5858L167.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M183.586 20.4142C184.367 19.6332 185.633 19.6332 186.414 20.4142L187.586 21.5858C188.367 22.3668 188.367 23.6332 187.586 24.4142L186.414 25.5858C185.633 26.3668 184.367 26.3668 183.586 25.5858L182.414 24.4142C181.633 23.6332 181.633 22.3668 182.414 21.5858L183.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M199.586 20.4142C200.367 19.6332 201.633 19.6332 202.414 20.4142L203.586 21.5858C204.367 22.3668 204.367 23.6332 203.586 24.4142L202.414 25.5858C201.633 26.3668 200.367 26.3668 199.586 25.5858L198.414 24.4142C197.633 23.6332 197.633 22.3668 198.414 21.5858L199.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M215.586 20.4142C216.367 19.6332 217.633 19.6332 218.414 20.4142L219.586 21.5858C220.367 22.3668 220.367 23.6332 219.586 24.4142L218.414 25.5858C217.633 26.3668 216.367 26.3668 215.586 25.5858L214.414 24.4142C213.633 23.6332 213.633 22.3668 214.414 21.5858L215.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M231.586 20.4142C232.367 19.6332 233.633 19.6332 234.414 20.4142L235.586 21.5858C236.367 22.3668 236.367 23.6332 235.586 24.4142L234.414 25.5858C233.633 26.3668 232.367 26.3668 231.586 25.5858L230.414 24.4142C229.633 23.6332 229.633 22.3668 230.414 21.5858L231.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M247.586 20.4142C248.367 19.6332 249.633 19.6332 250.414 20.4142L251.586 21.5858C252.367 22.3668 252.367 23.6332 251.586 24.4142L250.414 25.5858C249.633 26.3668 248.367 26.3668 247.586 25.5858L246.414 24.4142C245.633 23.6332 245.633 22.3668 246.414 21.5858L247.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.11"
            d="M263.586 20.4142C264.367 19.6332 265.633 19.6332 266.414 20.4142L267.586 21.5858C268.367 22.3668 268.367 23.6332 267.586 24.4142L266.414 25.5858C265.633 26.3668 264.367 26.3668 263.586 25.5858L262.414 24.4142C261.633 23.6332 261.633 22.3668 262.414 21.5858L263.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M279.586 20.4142C280.367 19.6332 281.633 19.6332 282.414 20.4142L283.586 21.5858C284.367 22.3668 284.367 23.6332 283.586 24.4142L282.414 25.5858C281.633 26.3668 280.367 26.3668 279.586 25.5858L278.414 24.4142C277.633 23.6332 277.633 22.3668 278.414 21.5858L279.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M295.586 20.4142C296.367 19.6332 297.633 19.6332 298.414 20.4142L299.586 21.5858C300.367 22.3668 300.367 23.6332 299.586 24.4142L298.414 25.5858C297.633 26.3668 296.367 26.3668 295.586 25.5858L294.414 24.4142C293.633 23.6332 293.633 22.3668 294.414 21.5858L295.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M311.586 20.4142C312.367 19.6332 313.633 19.6332 314.414 20.4142L315.586 21.5858C316.367 22.3668 316.367 23.6332 315.586 24.4142L314.414 25.5858C313.633 26.3668 312.367 26.3668 311.586 25.5858L310.414 24.4142C309.633 23.6332 309.633 22.3668 310.414 21.5858L311.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M327.586 20.4142C328.367 19.6332 329.633 19.6332 330.414 20.4142L331.586 21.5858C332.367 22.3668 332.367 23.6332 331.586 24.4142L330.414 25.5858C329.633 26.3668 328.367 26.3668 327.586 25.5858L326.414 24.4142C325.633 23.6332 325.633 22.3668 326.414 21.5858L327.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M343.586 20.4142C344.367 19.6332 345.633 19.6332 346.414 20.4142L347.586 21.5858C348.367 22.3668 348.367 23.6332 347.586 24.4142L346.414 25.5858C345.633 26.3668 344.367 26.3668 343.586 25.5858L342.414 24.4142C341.633 23.6332 341.633 22.3668 342.414 21.5858L343.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M359.586 20.4142C360.367 19.6332 361.633 19.6332 362.414 20.4142L363.586 21.5858C364.367 22.3668 364.367 23.6332 363.586 24.4142L362.414 25.5858C361.633 26.3668 360.367 26.3668 359.586 25.5858L358.414 24.4142C357.633 23.6332 357.633 22.3668 358.414 21.5858L359.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M375.586 20.4142C376.367 19.6332 377.633 19.6332 378.414 20.4142L379.586 21.5858C380.367 22.3668 380.367 23.6332 379.586 24.4142L378.414 25.5858C377.633 26.3668 376.367 26.3668 375.586 25.5858L374.414 24.4142C373.633 23.6332 373.633 22.3668 374.414 21.5858L375.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M391.586 20.4142C392.367 19.6332 393.633 19.6332 394.414 20.4142L395.586 21.5858C396.367 22.3668 396.367 23.6332 395.586 24.4142L394.414 25.5858C393.633 26.3668 392.367 26.3668 391.586 25.5858L390.414 24.4142C389.633 23.6332 389.633 22.3668 390.414 21.5858L391.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M407.586 20.4142C408.367 19.6332 409.633 19.6332 410.414 20.4142L411.586 21.5858C412.367 22.3668 412.367 23.6332 411.586 24.4142L410.414 25.5858C409.633 26.3668 408.367 26.3668 407.586 25.5858L406.414 24.4142C405.633 23.6332 405.633 22.3668 406.414 21.5858L407.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M423.586 20.4142C424.367 19.6332 425.633 19.6332 426.414 20.4142L427.586 21.5858C428.367 22.3668 428.367 23.6332 427.586 24.4142L426.414 25.5858C425.633 26.3668 424.367 26.3668 423.586 25.5858L422.414 24.4142C421.633 23.6332 421.633 22.3668 422.414 21.5858L423.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M439.586 20.4142C440.367 19.6332 441.633 19.6332 442.414 20.4142L443.586 21.5858C444.367 22.3668 444.367 23.6332 443.586 24.4142L442.414 25.5858C441.633 26.3668 440.367 26.3668 439.586 25.5858L438.414 24.4142C437.633 23.6332 437.633 22.3668 438.414 21.5858L439.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.58"
            d="M455.586 20.4142C456.367 19.6332 457.633 19.6332 458.414 20.4142L459.586 21.5858C460.367 22.3668 460.367 23.6332 459.586 24.4142L458.414 25.5858C457.633 26.3668 456.367 26.3668 455.586 25.5858L454.414 24.4142C453.633 23.6332 453.633 22.3668 454.414 21.5858L455.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.23"
            d="M471.586 20.4142C472.367 19.6332 473.633 19.6332 474.414 20.4142L475.586 21.5858C476.367 22.3668 476.367 23.6332 475.586 24.4142L474.414 25.5858C473.633 26.3668 472.367 26.3668 471.586 25.5858L470.414 24.4142C469.633 23.6332 469.633 22.3668 470.414 21.5858L471.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M487.586 20.4142C488.367 19.6332 489.633 19.6332 490.414 20.4142L491.586 21.5858C492.367 22.3668 492.367 23.6332 491.586 24.4142L490.414 25.5858C489.633 26.3668 488.367 26.3668 487.586 25.5858L486.414 24.4142C485.633 23.6332 485.633 22.3668 486.414 21.5858L487.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M503.586 20.4142C504.367 19.6332 505.633 19.6332 506.414 20.4142L507.586 21.5858C508.367 22.3668 508.367 23.6332 507.586 24.4142L506.414 25.5858C505.633 26.3668 504.367 26.3668 503.586 25.5858L502.414 24.4142C501.633 23.6332 501.633 22.3668 502.414 21.5858L503.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M519.586 20.4142C520.367 19.6332 521.633 19.6332 522.414 20.4142L523.586 21.5858C524.367 22.3668 524.367 23.6332 523.586 24.4142L522.414 25.5858C521.633 26.3668 520.367 26.3668 519.586 25.5858L518.414 24.4142C517.633 23.6332 517.633 22.3668 518.414 21.5858L519.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M535.586 20.4142C536.367 19.6332 537.633 19.6332 538.414 20.4142L539.586 21.5858C540.367 22.3668 540.367 23.6332 539.586 24.4142L538.414 25.5858C537.633 26.3668 536.367 26.3668 535.586 25.5858L534.414 24.4142C533.633 23.6332 533.633 22.3668 534.414 21.5858L535.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M551.586 20.4142C552.367 19.6332 553.633 19.6332 554.414 20.4142L555.586 21.5858C556.367 22.3668 556.367 23.6332 555.586 24.4142L554.414 25.5858C553.633 26.3668 552.367 26.3668 551.586 25.5858L550.414 24.4142C549.633 23.6332 549.633 22.3668 550.414 21.5858L551.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.63"
            d="M567.586 20.4142C568.367 19.6332 569.633 19.6332 570.414 20.4142L571.586 21.5858C572.367 22.3668 572.367 23.6332 571.586 24.4142L570.414 25.5858C569.633 26.3668 568.367 26.3668 567.586 25.5858L566.414 24.4142C565.633 23.6332 565.633 22.3668 566.414 21.5858L567.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M583.586 20.4142C584.367 19.6332 585.633 19.6332 586.414 20.4142L587.586 21.5858C588.367 22.3668 588.367 23.6332 587.586 24.4142L586.414 25.5858C585.633 26.3668 584.367 26.3668 583.586 25.5858L582.414 24.4142C581.633 23.6332 581.633 22.3668 582.414 21.5858L583.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M599.586 20.4142C600.367 19.6332 601.633 19.6332 602.414 20.4142L603.586 21.5858C604.367 22.3668 604.367 23.6332 603.586 24.4142L602.414 25.5858C601.633 26.3668 600.367 26.3668 599.586 25.5858L598.414 24.4142C597.633 23.6332 597.633 22.3668 598.414 21.5858L599.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M615.586 20.4142C616.367 19.6332 617.633 19.6332 618.414 20.4142L619.586 21.5858C620.367 22.3668 620.367 23.6332 619.586 24.4142L618.414 25.5858C617.633 26.3668 616.367 26.3668 615.586 25.5858L614.414 24.4142C613.633 23.6332 613.633 22.3668 614.414 21.5858L615.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M631.586 20.4142C632.367 19.6332 633.633 19.6332 634.414 20.4142L635.586 21.5858C636.367 22.3668 636.367 23.6332 635.586 24.4142L634.414 25.5858C633.633 26.3668 632.367 26.3668 631.586 25.5858L630.414 24.4142C629.633 23.6332 629.633 22.3668 630.414 21.5858L631.586 20.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M7.58579 36.4142C8.36684 35.6332 9.63317 35.6332 10.4142 36.4142L11.5858 37.5858C12.3668 38.3668 12.3668 39.6332 11.5858 40.4142L10.4142 41.5858C9.63316 42.3668 8.36683 42.3668 7.58579 41.5858L6.41421 40.4142C5.63316 39.6332 5.63317 38.3668 6.41421 37.5858L7.58579 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M23.5858 36.4142C24.3668 35.6332 25.6332 35.6332 26.4142 36.4142L27.5858 37.5858C28.3668 38.3668 28.3668 39.6332 27.5858 40.4142L26.4142 41.5858C25.6332 42.3668 24.3668 42.3668 23.5858 41.5858L22.4142 40.4142C21.6332 39.6332 21.6332 38.3668 22.4142 37.5858L23.5858 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.66"
            d="M39.5858 36.4142C40.3668 35.6332 41.6332 35.6332 42.4142 36.4142L43.5858 37.5858C44.3668 38.3668 44.3668 39.6332 43.5858 40.4142L42.4142 41.5858C41.6332 42.3668 40.3668 42.3668 39.5858 41.5858L38.4142 40.4142C37.6332 39.6332 37.6332 38.3668 38.4142 37.5858L39.5858 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M55.5858 36.4142C56.3668 35.6332 57.6332 35.6332 58.4142 36.4142L59.5858 37.5858C60.3668 38.3668 60.3668 39.6332 59.5858 40.4142L58.4142 41.5858C57.6332 42.3668 56.3668 42.3668 55.5858 41.5858L54.4142 40.4142C53.6332 39.6332 53.6332 38.3668 54.4142 37.5858L55.5858 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M71.5858 36.4142C72.3668 35.6332 73.6332 35.6332 74.4142 36.4142L75.5858 37.5858C76.3668 38.3668 76.3668 39.6332 75.5858 40.4142L74.4142 41.5858C73.6332 42.3668 72.3668 42.3668 71.5858 41.5858L70.4142 40.4142C69.6332 39.6332 69.6332 38.3668 70.4142 37.5858L71.5858 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M87.5858 36.4142C88.3668 35.6332 89.6332 35.6332 90.4142 36.4142L91.5858 37.5858C92.3668 38.3668 92.3668 39.6332 91.5858 40.4142L90.4142 41.5858C89.6332 42.3668 88.3668 42.3668 87.5858 41.5858L86.4142 40.4142C85.6332 39.6332 85.6332 38.3668 86.4142 37.5858L87.5858 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M103.586 36.4142C104.367 35.6332 105.633 35.6332 106.414 36.4142L107.586 37.5858C108.367 38.3668 108.367 39.6332 107.586 40.4142L106.414 41.5858C105.633 42.3668 104.367 42.3668 103.586 41.5858L102.414 40.4142C101.633 39.6332 101.633 38.3668 102.414 37.5858L103.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M119.586 36.4142C120.367 35.6332 121.633 35.6332 122.414 36.4142L123.586 37.5858C124.367 38.3668 124.367 39.6332 123.586 40.4142L122.414 41.5858C121.633 42.3668 120.367 42.3668 119.586 41.5858L118.414 40.4142C117.633 39.6332 117.633 38.3668 118.414 37.5858L119.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M135.586 36.4142C136.367 35.6332 137.633 35.6332 138.414 36.4142L139.586 37.5858C140.367 38.3668 140.367 39.6332 139.586 40.4142L138.414 41.5858C137.633 42.3668 136.367 42.3668 135.586 41.5858L134.414 40.4142C133.633 39.6332 133.633 38.3668 134.414 37.5858L135.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.16"
            d="M151.586 36.4142C152.367 35.6332 153.633 35.6332 154.414 36.4142L155.586 37.5858C156.367 38.3668 156.367 39.6332 155.586 40.4142L154.414 41.5858C153.633 42.3668 152.367 42.3668 151.586 41.5858L150.414 40.4142C149.633 39.6332 149.633 38.3668 150.414 37.5858L151.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            d="M167.586 36.4142C168.367 35.6332 169.633 35.6332 170.414 36.4142L171.586 37.5858C172.367 38.3668 172.367 39.6332 171.586 40.4142L170.414 41.5858C169.633 42.3668 168.367 42.3668 167.586 41.5858L166.414 40.4142C165.633 39.6332 165.633 38.3668 166.414 37.5858L167.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M183.586 36.4142C184.367 35.6332 185.633 35.6332 186.414 36.4142L187.586 37.5858C188.367 38.3668 188.367 39.6332 187.586 40.4142L186.414 41.5858C185.633 42.3668 184.367 42.3668 183.586 41.5858L182.414 40.4142C181.633 39.6332 181.633 38.3668 182.414 37.5858L183.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M199.586 36.4142C200.367 35.6332 201.633 35.6332 202.414 36.4142L203.586 37.5858C204.367 38.3668 204.367 39.6332 203.586 40.4142L202.414 41.5858C201.633 42.3668 200.367 42.3668 199.586 41.5858L198.414 40.4142C197.633 39.6332 197.633 38.3668 198.414 37.5858L199.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M215.586 36.4142C216.367 35.6332 217.633 35.6332 218.414 36.4142L219.586 37.5858C220.367 38.3668 220.367 39.6332 219.586 40.4142L218.414 41.5858C217.633 42.3668 216.367 42.3668 215.586 41.5858L214.414 40.4142C213.633 39.6332 213.633 38.3668 214.414 37.5858L215.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M231.586 36.4142C232.367 35.6332 233.633 35.6332 234.414 36.4142L235.586 37.5858C236.367 38.3668 236.367 39.6332 235.586 40.4142L234.414 41.5858C233.633 42.3668 232.367 42.3668 231.586 41.5858L230.414 40.4142C229.633 39.6332 229.633 38.3668 230.414 37.5858L231.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M247.586 36.4142C248.367 35.6332 249.633 35.6332 250.414 36.4142L251.586 37.5858C252.367 38.3668 252.367 39.6332 251.586 40.4142L250.414 41.5858C249.633 42.3668 248.367 42.3668 247.586 41.5858L246.414 40.4142C245.633 39.6332 245.633 38.3668 246.414 37.5858L247.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M263.586 36.4142C264.367 35.6332 265.633 35.6332 266.414 36.4142L267.586 37.5858C268.367 38.3668 268.367 39.6332 267.586 40.4142L266.414 41.5858C265.633 42.3668 264.367 42.3668 263.586 41.5858L262.414 40.4142C261.633 39.6332 261.633 38.3668 262.414 37.5858L263.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M279.586 36.4142C280.367 35.6332 281.633 35.6332 282.414 36.4142L283.586 37.5858C284.367 38.3668 284.367 39.6332 283.586 40.4142L282.414 41.5858C281.633 42.3668 280.367 42.3668 279.586 41.5858L278.414 40.4142C277.633 39.6332 277.633 38.3668 278.414 37.5858L279.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M295.586 36.4142C296.367 35.6332 297.633 35.6332 298.414 36.4142L299.586 37.5858C300.367 38.3668 300.367 39.6332 299.586 40.4142L298.414 41.5858C297.633 42.3668 296.367 42.3668 295.586 41.5858L294.414 40.4142C293.633 39.6332 293.633 38.3668 294.414 37.5858L295.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M311.586 36.4142C312.367 35.6332 313.633 35.6332 314.414 36.4142L315.586 37.5858C316.367 38.3668 316.367 39.6332 315.586 40.4142L314.414 41.5858C313.633 42.3668 312.367 42.3668 311.586 41.5858L310.414 40.4142C309.633 39.6332 309.633 38.3668 310.414 37.5858L311.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M327.586 36.4142C328.367 35.6332 329.633 35.6332 330.414 36.4142L331.586 37.5858C332.367 38.3668 332.367 39.6332 331.586 40.4142L330.414 41.5858C329.633 42.3668 328.367 42.3668 327.586 41.5858L326.414 40.4142C325.633 39.6332 325.633 38.3668 326.414 37.5858L327.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.92"
            d="M343.586 36.4142C344.367 35.6332 345.633 35.6332 346.414 36.4142L347.586 37.5858C348.367 38.3668 348.367 39.6332 347.586 40.4142L346.414 41.5858C345.633 42.3668 344.367 42.3668 343.586 41.5858L342.414 40.4142C341.633 39.6332 341.633 38.3668 342.414 37.5858L343.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.66"
            d="M359.586 36.4142C360.367 35.6332 361.633 35.6332 362.414 36.4142L363.586 37.5858C364.367 38.3668 364.367 39.6332 363.586 40.4142L362.414 41.5858C361.633 42.3668 360.367 42.3668 359.586 41.5858L358.414 40.4142C357.633 39.6332 357.633 38.3668 358.414 37.5858L359.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M375.586 36.4142C376.367 35.6332 377.633 35.6332 378.414 36.4142L379.586 37.5858C380.367 38.3668 380.367 39.6332 379.586 40.4142L378.414 41.5858C377.633 42.3668 376.367 42.3668 375.586 41.5858L374.414 40.4142C373.633 39.6332 373.633 38.3668 374.414 37.5858L375.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M391.586 36.4142C392.367 35.6332 393.633 35.6332 394.414 36.4142L395.586 37.5858C396.367 38.3668 396.367 39.6332 395.586 40.4142L394.414 41.5858C393.633 42.3668 392.367 42.3668 391.586 41.5858L390.414 40.4142C389.633 39.6332 389.633 38.3668 390.414 37.5858L391.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.66"
            d="M407.586 36.4142C408.367 35.6332 409.633 35.6332 410.414 36.4142L411.586 37.5858C412.367 38.3668 412.367 39.6332 411.586 40.4142L410.414 41.5858C409.633 42.3668 408.367 42.3668 407.586 41.5858L406.414 40.4142C405.633 39.6332 405.633 38.3668 406.414 37.5858L407.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M423.586 36.4142C424.367 35.6332 425.633 35.6332 426.414 36.4142L427.586 37.5858C428.367 38.3668 428.367 39.6332 427.586 40.4142L426.414 41.5858C425.633 42.3668 424.367 42.3668 423.586 41.5858L422.414 40.4142C421.633 39.6332 421.633 38.3668 422.414 37.5858L423.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.11"
            d="M439.586 36.4142C440.367 35.6332 441.633 35.6332 442.414 36.4142L443.586 37.5858C444.367 38.3668 444.367 39.6332 443.586 40.4142L442.414 41.5858C441.633 42.3668 440.367 42.3668 439.586 41.5858L438.414 40.4142C437.633 39.6332 437.633 38.3668 438.414 37.5858L439.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.23"
            d="M455.586 36.4142C456.367 35.6332 457.633 35.6332 458.414 36.4142L459.586 37.5858C460.367 38.3668 460.367 39.6332 459.586 40.4142L458.414 41.5858C457.633 42.3668 456.367 42.3668 455.586 41.5858L454.414 40.4142C453.633 39.6332 453.633 38.3668 454.414 37.5858L455.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M471.586 36.4142C472.367 35.6332 473.633 35.6332 474.414 36.4142L475.586 37.5858C476.367 38.3668 476.367 39.6332 475.586 40.4142L474.414 41.5858C473.633 42.3668 472.367 42.3668 471.586 41.5858L470.414 40.4142C469.633 39.6332 469.633 38.3668 470.414 37.5858L471.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.67"
            d="M487.586 36.4142C488.367 35.6332 489.633 35.6332 490.414 36.4142L491.586 37.5858C492.367 38.3668 492.367 39.6332 491.586 40.4142L490.414 41.5858C489.633 42.3668 488.367 42.3668 487.586 41.5858L486.414 40.4142C485.633 39.6332 485.633 38.3668 486.414 37.5858L487.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M503.586 36.4142C504.367 35.6332 505.633 35.6332 506.414 36.4142L507.586 37.5858C508.367 38.3668 508.367 39.6332 507.586 40.4142L506.414 41.5858C505.633 42.3668 504.367 42.3668 503.586 41.5858L502.414 40.4142C501.633 39.6332 501.633 38.3668 502.414 37.5858L503.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M519.586 36.4142C520.367 35.6332 521.633 35.6332 522.414 36.4142L523.586 37.5858C524.367 38.3668 524.367 39.6332 523.586 40.4142L522.414 41.5858C521.633 42.3668 520.367 42.3668 519.586 41.5858L518.414 40.4142C517.633 39.6332 517.633 38.3668 518.414 37.5858L519.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M535.586 36.4142C536.367 35.6332 537.633 35.6332 538.414 36.4142L539.586 37.5858C540.367 38.3668 540.367 39.6332 539.586 40.4142L538.414 41.5858C537.633 42.3668 536.367 42.3668 535.586 41.5858L534.414 40.4142C533.633 39.6332 533.633 38.3668 534.414 37.5858L535.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M551.586 36.4142C552.367 35.6332 553.633 35.6332 554.414 36.4142L555.586 37.5858C556.367 38.3668 556.367 39.6332 555.586 40.4142L554.414 41.5858C553.633 42.3668 552.367 42.3668 551.586 41.5858L550.414 40.4142C549.633 39.6332 549.633 38.3668 550.414 37.5858L551.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M567.586 36.4142C568.367 35.6332 569.633 35.6332 570.414 36.4142L571.586 37.5858C572.367 38.3668 572.367 39.6332 571.586 40.4142L570.414 41.5858C569.633 42.3668 568.367 42.3668 567.586 41.5858L566.414 40.4142C565.633 39.6332 565.633 38.3668 566.414 37.5858L567.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M583.586 36.4142C584.367 35.6332 585.633 35.6332 586.414 36.4142L587.586 37.5858C588.367 38.3668 588.367 39.6332 587.586 40.4142L586.414 41.5858C585.633 42.3668 584.367 42.3668 583.586 41.5858L582.414 40.4142C581.633 39.6332 581.633 38.3668 582.414 37.5858L583.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M599.586 36.4142C600.367 35.6332 601.633 35.6332 602.414 36.4142L603.586 37.5858C604.367 38.3668 604.367 39.6332 603.586 40.4142L602.414 41.5858C601.633 42.3668 600.367 42.3668 599.586 41.5858L598.414 40.4142C597.633 39.6332 597.633 38.3668 598.414 37.5858L599.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M615.586 36.4142C616.367 35.6332 617.633 35.6332 618.414 36.4142L619.586 37.5858C620.367 38.3668 620.367 39.6332 619.586 40.4142L618.414 41.5858C617.633 42.3668 616.367 42.3668 615.586 41.5858L614.414 40.4142C613.633 39.6332 613.633 38.3668 614.414 37.5858L615.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M631.586 36.4142C632.367 35.6332 633.633 35.6332 634.414 36.4142L635.586 37.5858C636.367 38.3668 636.367 39.6332 635.586 40.4142L634.414 41.5858C633.633 42.3668 632.367 42.3668 631.586 41.5858L630.414 40.4142C629.633 39.6332 629.633 38.3668 630.414 37.5858L631.586 36.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M7.58579 52.4142C8.36684 51.6332 9.63317 51.6332 10.4142 52.4142L11.5858 53.5858C12.3668 54.3668 12.3668 55.6332 11.5858 56.4142L10.4142 57.5858C9.63316 58.3668 8.36683 58.3668 7.58579 57.5858L6.41421 56.4142C5.63316 55.6332 5.63317 54.3668 6.41421 53.5858L7.58579 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M23.5858 52.4142C24.3668 51.6332 25.6332 51.6332 26.4142 52.4142L27.5858 53.5858C28.3668 54.3668 28.3668 55.6332 27.5858 56.4142L26.4142 57.5858C25.6332 58.3668 24.3668 58.3668 23.5858 57.5858L22.4142 56.4142C21.6332 55.6332 21.6332 54.3668 22.4142 53.5858L23.5858 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M39.5858 52.4142C40.3668 51.6332 41.6332 51.6332 42.4142 52.4142L43.5858 53.5858C44.3668 54.3668 44.3668 55.6332 43.5858 56.4142L42.4142 57.5858C41.6332 58.3668 40.3668 58.3668 39.5858 57.5858L38.4142 56.4142C37.6332 55.6332 37.6332 54.3668 38.4142 53.5858L39.5858 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M55.5858 52.4142C56.3668 51.6332 57.6332 51.6332 58.4142 52.4142L59.5858 53.5858C60.3668 54.3668 60.3668 55.6332 59.5858 56.4142L58.4142 57.5858C57.6332 58.3668 56.3668 58.3668 55.5858 57.5858L54.4142 56.4142C53.6332 55.6332 53.6332 54.3668 54.4142 53.5858L55.5858 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M71.5858 52.4142C72.3668 51.6332 73.6332 51.6332 74.4142 52.4142L75.5858 53.5858C76.3668 54.3668 76.3668 55.6332 75.5858 56.4142L74.4142 57.5858C73.6332 58.3668 72.3668 58.3668 71.5858 57.5858L70.4142 56.4142C69.6332 55.6332 69.6332 54.3668 70.4142 53.5858L71.5858 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.45"
            d="M87.5858 52.4142C88.3668 51.6332 89.6332 51.6332 90.4142 52.4142L91.5858 53.5858C92.3668 54.3668 92.3668 55.6332 91.5858 56.4142L90.4142 57.5858C89.6332 58.3668 88.3668 58.3668 87.5858 57.5858L86.4142 56.4142C85.6332 55.6332 85.6332 54.3668 86.4142 53.5858L87.5858 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M103.586 52.4142C104.367 51.6332 105.633 51.6332 106.414 52.4142L107.586 53.5858C108.367 54.3668 108.367 55.6332 107.586 56.4142L106.414 57.5858C105.633 58.3668 104.367 58.3668 103.586 57.5858L102.414 56.4142C101.633 55.6332 101.633 54.3668 102.414 53.5858L103.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M119.586 52.4142C120.367 51.6332 121.633 51.6332 122.414 52.4142L123.586 53.5858C124.367 54.3668 124.367 55.6332 123.586 56.4142L122.414 57.5858C121.633 58.3668 120.367 58.3668 119.586 57.5858L118.414 56.4142C117.633 55.6332 117.633 54.3668 118.414 53.5858L119.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M135.586 52.4142C136.367 51.6332 137.633 51.6332 138.414 52.4142L139.586 53.5858C140.367 54.3668 140.367 55.6332 139.586 56.4142L138.414 57.5858C137.633 58.3668 136.367 58.3668 135.586 57.5858L134.414 56.4142C133.633 55.6332 133.633 54.3668 134.414 53.5858L135.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M151.586 52.4142C152.367 51.6332 153.633 51.6332 154.414 52.4142L155.586 53.5858C156.367 54.3668 156.367 55.6332 155.586 56.4142L154.414 57.5858C153.633 58.3668 152.367 58.3668 151.586 57.5858L150.414 56.4142C149.633 55.6332 149.633 54.3668 150.414 53.5858L151.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M167.586 52.4142C168.367 51.6332 169.633 51.6332 170.414 52.4142L171.586 53.5858C172.367 54.3668 172.367 55.6332 171.586 56.4142L170.414 57.5858C169.633 58.3668 168.367 58.3668 167.586 57.5858L166.414 56.4142C165.633 55.6332 165.633 54.3668 166.414 53.5858L167.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M183.586 52.4142C184.367 51.6332 185.633 51.6332 186.414 52.4142L187.586 53.5858C188.367 54.3668 188.367 55.6332 187.586 56.4142L186.414 57.5858C185.633 58.3668 184.367 58.3668 183.586 57.5858L182.414 56.4142C181.633 55.6332 181.633 54.3668 182.414 53.5858L183.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M199.586 52.4142C200.367 51.6332 201.633 51.6332 202.414 52.4142L203.586 53.5858C204.367 54.3668 204.367 55.6332 203.586 56.4142L202.414 57.5858C201.633 58.3668 200.367 58.3668 199.586 57.5858L198.414 56.4142C197.633 55.6332 197.633 54.3668 198.414 53.5858L199.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M215.586 52.4142C216.367 51.6332 217.633 51.6332 218.414 52.4142L219.586 53.5858C220.367 54.3668 220.367 55.6332 219.586 56.4142L218.414 57.5858C217.633 58.3668 216.367 58.3668 215.586 57.5858L214.414 56.4142C213.633 55.6332 213.633 54.3668 214.414 53.5858L215.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M231.586 52.4142C232.367 51.6332 233.633 51.6332 234.414 52.4142L235.586 53.5858C236.367 54.3668 236.367 55.6332 235.586 56.4142L234.414 57.5858C233.633 58.3668 232.367 58.3668 231.586 57.5858L230.414 56.4142C229.633 55.6332 229.633 54.3668 230.414 53.5858L231.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.45"
            d="M247.586 52.4142C248.367 51.6332 249.633 51.6332 250.414 52.4142L251.586 53.5858C252.367 54.3668 252.367 55.6332 251.586 56.4142L250.414 57.5858C249.633 58.3668 248.367 58.3668 247.586 57.5858L246.414 56.4142C245.633 55.6332 245.633 54.3668 246.414 53.5858L247.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M263.586 52.4142C264.367 51.6332 265.633 51.6332 266.414 52.4142L267.586 53.5858C268.367 54.3668 268.367 55.6332 267.586 56.4142L266.414 57.5858C265.633 58.3668 264.367 58.3668 263.586 57.5858L262.414 56.4142C261.633 55.6332 261.633 54.3668 262.414 53.5858L263.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M279.586 52.4142C280.367 51.6332 281.633 51.6332 282.414 52.4142L283.586 53.5858C284.367 54.3668 284.367 55.6332 283.586 56.4142L282.414 57.5858C281.633 58.3668 280.367 58.3668 279.586 57.5858L278.414 56.4142C277.633 55.6332 277.633 54.3668 278.414 53.5858L279.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M295.586 52.4142C296.367 51.6332 297.633 51.6332 298.414 52.4142L299.586 53.5858C300.367 54.3668 300.367 55.6332 299.586 56.4142L298.414 57.5858C297.633 58.3668 296.367 58.3668 295.586 57.5858L294.414 56.4142C293.633 55.6332 293.633 54.3668 294.414 53.5858L295.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M311.586 52.4142C312.367 51.6332 313.633 51.6332 314.414 52.4142L315.586 53.5858C316.367 54.3668 316.367 55.6332 315.586 56.4142L314.414 57.5858C313.633 58.3668 312.367 58.3668 311.586 57.5858L310.414 56.4142C309.633 55.6332 309.633 54.3668 310.414 53.5858L311.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M327.586 52.4142C328.367 51.6332 329.633 51.6332 330.414 52.4142L331.586 53.5858C332.367 54.3668 332.367 55.6332 331.586 56.4142L330.414 57.5858C329.633 58.3668 328.367 58.3668 327.586 57.5858L326.414 56.4142C325.633 55.6332 325.633 54.3668 326.414 53.5858L327.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M343.586 52.4142C344.367 51.6332 345.633 51.6332 346.414 52.4142L347.586 53.5858C348.367 54.3668 348.367 55.6332 347.586 56.4142L346.414 57.5858C345.633 58.3668 344.367 58.3668 343.586 57.5858L342.414 56.4142C341.633 55.6332 341.633 54.3668 342.414 53.5858L343.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M359.586 52.4142C360.367 51.6332 361.633 51.6332 362.414 52.4142L363.586 53.5858C364.367 54.3668 364.367 55.6332 363.586 56.4142L362.414 57.5858C361.633 58.3668 360.367 58.3668 359.586 57.5858L358.414 56.4142C357.633 55.6332 357.633 54.3668 358.414 53.5858L359.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M375.586 52.4142C376.367 51.6332 377.633 51.6332 378.414 52.4142L379.586 53.5858C380.367 54.3668 380.367 55.6332 379.586 56.4142L378.414 57.5858C377.633 58.3668 376.367 58.3668 375.586 57.5858L374.414 56.4142C373.633 55.6332 373.633 54.3668 374.414 53.5858L375.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M391.586 52.4142C392.367 51.6332 393.633 51.6332 394.414 52.4142L395.586 53.5858C396.367 54.3668 396.367 55.6332 395.586 56.4142L394.414 57.5858C393.633 58.3668 392.367 58.3668 391.586 57.5858L390.414 56.4142C389.633 55.6332 389.633 54.3668 390.414 53.5858L391.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M407.586 52.4142C408.367 51.6332 409.633 51.6332 410.414 52.4142L411.586 53.5858C412.367 54.3668 412.367 55.6332 411.586 56.4142L410.414 57.5858C409.633 58.3668 408.367 58.3668 407.586 57.5858L406.414 56.4142C405.633 55.6332 405.633 54.3668 406.414 53.5858L407.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M423.586 52.4142C424.367 51.6332 425.633 51.6332 426.414 52.4142L427.586 53.5858C428.367 54.3668 428.367 55.6332 427.586 56.4142L426.414 57.5858C425.633 58.3668 424.367 58.3668 423.586 57.5858L422.414 56.4142C421.633 55.6332 421.633 54.3668 422.414 53.5858L423.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M439.586 52.4142C440.367 51.6332 441.633 51.6332 442.414 52.4142L443.586 53.5858C444.367 54.3668 444.367 55.6332 443.586 56.4142L442.414 57.5858C441.633 58.3668 440.367 58.3668 439.586 57.5858L438.414 56.4142C437.633 55.6332 437.633 54.3668 438.414 53.5858L439.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.74"
            d="M455.586 52.4142C456.367 51.6332 457.633 51.6332 458.414 52.4142L459.586 53.5858C460.367 54.3668 460.367 55.6332 459.586 56.4142L458.414 57.5858C457.633 58.3668 456.367 58.3668 455.586 57.5858L454.414 56.4142C453.633 55.6332 453.633 54.3668 454.414 53.5858L455.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M471.586 52.4142C472.367 51.6332 473.633 51.6332 474.414 52.4142L475.586 53.5858C476.367 54.3668 476.367 55.6332 475.586 56.4142L474.414 57.5858C473.633 58.3668 472.367 58.3668 471.586 57.5858L470.414 56.4142C469.633 55.6332 469.633 54.3668 470.414 53.5858L471.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M487.586 52.4142C488.367 51.6332 489.633 51.6332 490.414 52.4142L491.586 53.5858C492.367 54.3668 492.367 55.6332 491.586 56.4142L490.414 57.5858C489.633 58.3668 488.367 58.3668 487.586 57.5858L486.414 56.4142C485.633 55.6332 485.633 54.3668 486.414 53.5858L487.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M503.586 52.4142C504.367 51.6332 505.633 51.6332 506.414 52.4142L507.586 53.5858C508.367 54.3668 508.367 55.6332 507.586 56.4142L506.414 57.5858C505.633 58.3668 504.367 58.3668 503.586 57.5858L502.414 56.4142C501.633 55.6332 501.633 54.3668 502.414 53.5858L503.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M519.586 52.4142C520.367 51.6332 521.633 51.6332 522.414 52.4142L523.586 53.5858C524.367 54.3668 524.367 55.6332 523.586 56.4142L522.414 57.5858C521.633 58.3668 520.367 58.3668 519.586 57.5858L518.414 56.4142C517.633 55.6332 517.633 54.3668 518.414 53.5858L519.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M535.586 52.4142C536.367 51.6332 537.633 51.6332 538.414 52.4142L539.586 53.5858C540.367 54.3668 540.367 55.6332 539.586 56.4142L538.414 57.5858C537.633 58.3668 536.367 58.3668 535.586 57.5858L534.414 56.4142C533.633 55.6332 533.633 54.3668 534.414 53.5858L535.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M551.586 52.4142C552.367 51.6332 553.633 51.6332 554.414 52.4142L555.586 53.5858C556.367 54.3668 556.367 55.6332 555.586 56.4142L554.414 57.5858C553.633 58.3668 552.367 58.3668 551.586 57.5858L550.414 56.4142C549.633 55.6332 549.633 54.3668 550.414 53.5858L551.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M567.586 52.4142C568.367 51.6332 569.633 51.6332 570.414 52.4142L571.586 53.5858C572.367 54.3668 572.367 55.6332 571.586 56.4142L570.414 57.5858C569.633 58.3668 568.367 58.3668 567.586 57.5858L566.414 56.4142C565.633 55.6332 565.633 54.3668 566.414 53.5858L567.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M583.586 52.4142C584.367 51.6332 585.633 51.6332 586.414 52.4142L587.586 53.5858C588.367 54.3668 588.367 55.6332 587.586 56.4142L586.414 57.5858C585.633 58.3668 584.367 58.3668 583.586 57.5858L582.414 56.4142C581.633 55.6332 581.633 54.3668 582.414 53.5858L583.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M599.586 52.4142C600.367 51.6332 601.633 51.6332 602.414 52.4142L603.586 53.5858C604.367 54.3668 604.367 55.6332 603.586 56.4142L602.414 57.5858C601.633 58.3668 600.367 58.3668 599.586 57.5858L598.414 56.4142C597.633 55.6332 597.633 54.3668 598.414 53.5858L599.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M615.586 52.4142C616.367 51.6332 617.633 51.6332 618.414 52.4142L619.586 53.5858C620.367 54.3668 620.367 55.6332 619.586 56.4142L618.414 57.5858C617.633 58.3668 616.367 58.3668 615.586 57.5858L614.414 56.4142C613.633 55.6332 613.633 54.3668 614.414 53.5858L615.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M631.586 52.4142C632.367 51.6332 633.633 51.6332 634.414 52.4142L635.586 53.5858C636.367 54.3668 636.367 55.6332 635.586 56.4142L634.414 57.5858C633.633 58.3668 632.367 58.3668 631.586 57.5858L630.414 56.4142C629.633 55.6332 629.633 54.3668 630.414 53.5858L631.586 52.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.66"
            d="M7.58579 68.4142C8.36684 67.6332 9.63317 67.6332 10.4142 68.4142L11.5858 69.5858C12.3668 70.3668 12.3668 71.6332 11.5858 72.4142L10.4142 73.5858C9.63316 74.3668 8.36683 74.3668 7.58579 73.5858L6.41421 72.4142C5.63316 71.6332 5.63317 70.3668 6.41421 69.5858L7.58579 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M23.5858 68.4142C24.3668 67.6332 25.6332 67.6332 26.4142 68.4142L27.5858 69.5858C28.3668 70.3668 28.3668 71.6332 27.5858 72.4142L26.4142 73.5858C25.6332 74.3668 24.3668 74.3668 23.5858 73.5858L22.4142 72.4142C21.6332 71.6332 21.6332 70.3668 22.4142 69.5858L23.5858 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M39.5858 68.4142C40.3668 67.6332 41.6332 67.6332 42.4142 68.4142L43.5858 69.5858C44.3668 70.3668 44.3668 71.6332 43.5858 72.4142L42.4142 73.5858C41.6332 74.3668 40.3668 74.3668 39.5858 73.5858L38.4142 72.4142C37.6332 71.6332 37.6332 70.3668 38.4142 69.5858L39.5858 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M55.5858 68.4142C56.3668 67.6332 57.6332 67.6332 58.4142 68.4142L59.5858 69.5858C60.3668 70.3668 60.3668 71.6332 59.5858 72.4142L58.4142 73.5858C57.6332 74.3668 56.3668 74.3668 55.5858 73.5858L54.4142 72.4142C53.6332 71.6332 53.6332 70.3668 54.4142 69.5858L55.5858 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M71.5858 68.4142C72.3668 67.6332 73.6332 67.6332 74.4142 68.4142L75.5858 69.5858C76.3668 70.3668 76.3668 71.6332 75.5858 72.4142L74.4142 73.5858C73.6332 74.3668 72.3668 74.3668 71.5858 73.5858L70.4142 72.4142C69.6332 71.6332 69.6332 70.3668 70.4142 69.5858L71.5858 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M87.5858 68.4142C88.3668 67.6332 89.6332 67.6332 90.4142 68.4142L91.5858 69.5858C92.3668 70.3668 92.3668 71.6332 91.5858 72.4142L90.4142 73.5858C89.6332 74.3668 88.3668 74.3668 87.5858 73.5858L86.4142 72.4142C85.6332 71.6332 85.6332 70.3668 86.4142 69.5858L87.5858 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M103.586 68.4142C104.367 67.6332 105.633 67.6332 106.414 68.4142L107.586 69.5858C108.367 70.3668 108.367 71.6332 107.586 72.4142L106.414 73.5858C105.633 74.3668 104.367 74.3668 103.586 73.5858L102.414 72.4142C101.633 71.6332 101.633 70.3668 102.414 69.5858L103.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.62"
            d="M119.586 68.4142C120.367 67.6332 121.633 67.6332 122.414 68.4142L123.586 69.5858C124.367 70.3668 124.367 71.6332 123.586 72.4142L122.414 73.5858C121.633 74.3668 120.367 74.3668 119.586 73.5858L118.414 72.4142C117.633 71.6332 117.633 70.3668 118.414 69.5858L119.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M135.586 68.4142C136.367 67.6332 137.633 67.6332 138.414 68.4142L139.586 69.5858C140.367 70.3668 140.367 71.6332 139.586 72.4142L138.414 73.5858C137.633 74.3668 136.367 74.3668 135.586 73.5858L134.414 72.4142C133.633 71.6332 133.633 70.3668 134.414 69.5858L135.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M151.586 68.4142C152.367 67.6332 153.633 67.6332 154.414 68.4142L155.586 69.5858C156.367 70.3668 156.367 71.6332 155.586 72.4142L154.414 73.5858C153.633 74.3668 152.367 74.3668 151.586 73.5858L150.414 72.4142C149.633 71.6332 149.633 70.3668 150.414 69.5858L151.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.16"
            d="M167.586 68.4142C168.367 67.6332 169.633 67.6332 170.414 68.4142L171.586 69.5858C172.367 70.3668 172.367 71.6332 171.586 72.4142L170.414 73.5858C169.633 74.3668 168.367 74.3668 167.586 73.5858L166.414 72.4142C165.633 71.6332 165.633 70.3668 166.414 69.5858L167.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M183.586 68.4142C184.367 67.6332 185.633 67.6332 186.414 68.4142L187.586 69.5858C188.367 70.3668 188.367 71.6332 187.586 72.4142L186.414 73.5858C185.633 74.3668 184.367 74.3668 183.586 73.5858L182.414 72.4142C181.633 71.6332 181.633 70.3668 182.414 69.5858L183.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M199.586 68.4142C200.367 67.6332 201.633 67.6332 202.414 68.4142L203.586 69.5858C204.367 70.3668 204.367 71.6332 203.586 72.4142L202.414 73.5858C201.633 74.3668 200.367 74.3668 199.586 73.5858L198.414 72.4142C197.633 71.6332 197.633 70.3668 198.414 69.5858L199.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.21"
            d="M215.586 68.4142C216.367 67.6332 217.633 67.6332 218.414 68.4142L219.586 69.5858C220.367 70.3668 220.367 71.6332 219.586 72.4142L218.414 73.5858C217.633 74.3668 216.367 74.3668 215.586 73.5858L214.414 72.4142C213.633 71.6332 213.633 70.3668 214.414 69.5858L215.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.85"
            d="M231.586 68.4142C232.367 67.6332 233.633 67.6332 234.414 68.4142L235.586 69.5858C236.367 70.3668 236.367 71.6332 235.586 72.4142L234.414 73.5858C233.633 74.3668 232.367 74.3668 231.586 73.5858L230.414 72.4142C229.633 71.6332 229.633 70.3668 230.414 69.5858L231.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M247.586 68.4142C248.367 67.6332 249.633 67.6332 250.414 68.4142L251.586 69.5858C252.367 70.3668 252.367 71.6332 251.586 72.4142L250.414 73.5858C249.633 74.3668 248.367 74.3668 247.586 73.5858L246.414 72.4142C245.633 71.6332 245.633 70.3668 246.414 69.5858L247.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M263.586 68.4142C264.367 67.6332 265.633 67.6332 266.414 68.4142L267.586 69.5858C268.367 70.3668 268.367 71.6332 267.586 72.4142L266.414 73.5858C265.633 74.3668 264.367 74.3668 263.586 73.5858L262.414 72.4142C261.633 71.6332 261.633 70.3668 262.414 69.5858L263.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M279.586 68.4142C280.367 67.6332 281.633 67.6332 282.414 68.4142L283.586 69.5858C284.367 70.3668 284.367 71.6332 283.586 72.4142L282.414 73.5858C281.633 74.3668 280.367 74.3668 279.586 73.5858L278.414 72.4142C277.633 71.6332 277.633 70.3668 278.414 69.5858L279.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M295.586 68.4142C296.367 67.6332 297.633 67.6332 298.414 68.4142L299.586 69.5858C300.367 70.3668 300.367 71.6332 299.586 72.4142L298.414 73.5858C297.633 74.3668 296.367 74.3668 295.586 73.5858L294.414 72.4142C293.633 71.6332 293.633 70.3668 294.414 69.5858L295.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M311.586 68.4142C312.367 67.6332 313.633 67.6332 314.414 68.4142L315.586 69.5858C316.367 70.3668 316.367 71.6332 315.586 72.4142L314.414 73.5858C313.633 74.3668 312.367 74.3668 311.586 73.5858L310.414 72.4142C309.633 71.6332 309.633 70.3668 310.414 69.5858L311.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.66"
            d="M327.586 68.4142C328.367 67.6332 329.633 67.6332 330.414 68.4142L331.586 69.5858C332.367 70.3668 332.367 71.6332 331.586 72.4142L330.414 73.5858C329.633 74.3668 328.367 74.3668 327.586 73.5858L326.414 72.4142C325.633 71.6332 325.633 70.3668 326.414 69.5858L327.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M343.586 68.4142C344.367 67.6332 345.633 67.6332 346.414 68.4142L347.586 69.5858C348.367 70.3668 348.367 71.6332 347.586 72.4142L346.414 73.5858C345.633 74.3668 344.367 74.3668 343.586 73.5858L342.414 72.4142C341.633 71.6332 341.633 70.3668 342.414 69.5858L343.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M359.586 68.4142C360.367 67.6332 361.633 67.6332 362.414 68.4142L363.586 69.5858C364.367 70.3668 364.367 71.6332 363.586 72.4142L362.414 73.5858C361.633 74.3668 360.367 74.3668 359.586 73.5858L358.414 72.4142C357.633 71.6332 357.633 70.3668 358.414 69.5858L359.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M375.586 68.4142C376.367 67.6332 377.633 67.6332 378.414 68.4142L379.586 69.5858C380.367 70.3668 380.367 71.6332 379.586 72.4142L378.414 73.5858C377.633 74.3668 376.367 74.3668 375.586 73.5858L374.414 72.4142C373.633 71.6332 373.633 70.3668 374.414 69.5858L375.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.53"
            d="M391.586 68.4142C392.367 67.6332 393.633 67.6332 394.414 68.4142L395.586 69.5858C396.367 70.3668 396.367 71.6332 395.586 72.4142L394.414 73.5858C393.633 74.3668 392.367 74.3668 391.586 73.5858L390.414 72.4142C389.633 71.6332 389.633 70.3668 390.414 69.5858L391.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M407.586 68.4142C408.367 67.6332 409.633 67.6332 410.414 68.4142L411.586 69.5858C412.367 70.3668 412.367 71.6332 411.586 72.4142L410.414 73.5858C409.633 74.3668 408.367 74.3668 407.586 73.5858L406.414 72.4142C405.633 71.6332 405.633 70.3668 406.414 69.5858L407.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M423.586 68.4142C424.367 67.6332 425.633 67.6332 426.414 68.4142L427.586 69.5858C428.367 70.3668 428.367 71.6332 427.586 72.4142L426.414 73.5858C425.633 74.3668 424.367 74.3668 423.586 73.5858L422.414 72.4142C421.633 71.6332 421.633 70.3668 422.414 69.5858L423.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M439.586 68.4142C440.367 67.6332 441.633 67.6332 442.414 68.4142L443.586 69.5858C444.367 70.3668 444.367 71.6332 443.586 72.4142L442.414 73.5858C441.633 74.3668 440.367 74.3668 439.586 73.5858L438.414 72.4142C437.633 71.6332 437.633 70.3668 438.414 69.5858L439.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M455.586 68.4142C456.367 67.6332 457.633 67.6332 458.414 68.4142L459.586 69.5858C460.367 70.3668 460.367 71.6332 459.586 72.4142L458.414 73.5858C457.633 74.3668 456.367 74.3668 455.586 73.5858L454.414 72.4142C453.633 71.6332 453.633 70.3668 454.414 69.5858L455.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M471.586 68.4142C472.367 67.6332 473.633 67.6332 474.414 68.4142L475.586 69.5858C476.367 70.3668 476.367 71.6332 475.586 72.4142L474.414 73.5858C473.633 74.3668 472.367 74.3668 471.586 73.5858L470.414 72.4142C469.633 71.6332 469.633 70.3668 470.414 69.5858L471.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M487.586 68.4142C488.367 67.6332 489.633 67.6332 490.414 68.4142L491.586 69.5858C492.367 70.3668 492.367 71.6332 491.586 72.4142L490.414 73.5858C489.633 74.3668 488.367 74.3668 487.586 73.5858L486.414 72.4142C485.633 71.6332 485.633 70.3668 486.414 69.5858L487.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.16"
            d="M503.586 68.4142C504.367 67.6332 505.633 67.6332 506.414 68.4142L507.586 69.5858C508.367 70.3668 508.367 71.6332 507.586 72.4142L506.414 73.5858C505.633 74.3668 504.367 74.3668 503.586 73.5858L502.414 72.4142C501.633 71.6332 501.633 70.3668 502.414 69.5858L503.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.44"
            d="M519.586 68.4142C520.367 67.6332 521.633 67.6332 522.414 68.4142L523.586 69.5858C524.367 70.3668 524.367 71.6332 523.586 72.4142L522.414 73.5858C521.633 74.3668 520.367 74.3668 519.586 73.5858L518.414 72.4142C517.633 71.6332 517.633 70.3668 518.414 69.5858L519.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M535.586 68.4142C536.367 67.6332 537.633 67.6332 538.414 68.4142L539.586 69.5858C540.367 70.3668 540.367 71.6332 539.586 72.4142L538.414 73.5858C537.633 74.3668 536.367 74.3668 535.586 73.5858L534.414 72.4142C533.633 71.6332 533.633 70.3668 534.414 69.5858L535.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M551.586 68.4142C552.367 67.6332 553.633 67.6332 554.414 68.4142L555.586 69.5858C556.367 70.3668 556.367 71.6332 555.586 72.4142L554.414 73.5858C553.633 74.3668 552.367 74.3668 551.586 73.5858L550.414 72.4142C549.633 71.6332 549.633 70.3668 550.414 69.5858L551.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.58"
            d="M567.586 68.4142C568.367 67.6332 569.633 67.6332 570.414 68.4142L571.586 69.5858C572.367 70.3668 572.367 71.6332 571.586 72.4142L570.414 73.5858C569.633 74.3668 568.367 74.3668 567.586 73.5858L566.414 72.4142C565.633 71.6332 565.633 70.3668 566.414 69.5858L567.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M583.586 68.4142C584.367 67.6332 585.633 67.6332 586.414 68.4142L587.586 69.5858C588.367 70.3668 588.367 71.6332 587.586 72.4142L586.414 73.5858C585.633 74.3668 584.367 74.3668 583.586 73.5858L582.414 72.4142C581.633 71.6332 581.633 70.3668 582.414 69.5858L583.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M599.586 68.4142C600.367 67.6332 601.633 67.6332 602.414 68.4142L603.586 69.5858C604.367 70.3668 604.367 71.6332 603.586 72.4142L602.414 73.5858C601.633 74.3668 600.367 74.3668 599.586 73.5858L598.414 72.4142C597.633 71.6332 597.633 70.3668 598.414 69.5858L599.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.8"
            d="M615.586 68.4142C616.367 67.6332 617.633 67.6332 618.414 68.4142L619.586 69.5858C620.367 70.3668 620.367 71.6332 619.586 72.4142L618.414 73.5858C617.633 74.3668 616.367 74.3668 615.586 73.5858L614.414 72.4142C613.633 71.6332 613.633 70.3668 614.414 69.5858L615.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M631.586 68.4142C632.367 67.6332 633.633 67.6332 634.414 68.4142L635.586 69.5858C636.367 70.3668 636.367 71.6332 635.586 72.4142L634.414 73.5858C633.633 74.3668 632.367 74.3668 631.586 73.5858L630.414 72.4142C629.633 71.6332 629.633 70.3668 630.414 69.5858L631.586 68.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M7.58579 84.4142C8.36684 83.6332 9.63317 83.6332 10.4142 84.4142L11.5858 85.5858C12.3668 86.3668 12.3668 87.6332 11.5858 88.4142L10.4142 89.5858C9.63316 90.3668 8.36683 90.3668 7.58579 89.5858L6.41421 88.4142C5.63316 87.6332 5.63317 86.3668 6.41421 85.5858L7.58579 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M23.5858 84.4142C24.3668 83.6332 25.6332 83.6332 26.4142 84.4142L27.5858 85.5858C28.3668 86.3668 28.3668 87.6332 27.5858 88.4142L26.4142 89.5858C25.6332 90.3668 24.3668 90.3668 23.5858 89.5858L22.4142 88.4142C21.6332 87.6332 21.6332 86.3668 22.4142 85.5858L23.5858 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M39.5858 84.4142C40.3668 83.6332 41.6332 83.6332 42.4142 84.4142L43.5858 85.5858C44.3668 86.3668 44.3668 87.6332 43.5858 88.4142L42.4142 89.5858C41.6332 90.3668 40.3668 90.3668 39.5858 89.5858L38.4142 88.4142C37.6332 87.6332 37.6332 86.3668 38.4142 85.5858L39.5858 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M55.5858 84.4142C56.3668 83.6332 57.6332 83.6332 58.4142 84.4142L59.5858 85.5858C60.3668 86.3668 60.3668 87.6332 59.5858 88.4142L58.4142 89.5858C57.6332 90.3668 56.3668 90.3668 55.5858 89.5858L54.4142 88.4142C53.6332 87.6332 53.6332 86.3668 54.4142 85.5858L55.5858 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M71.5858 84.4142C72.3668 83.6332 73.6332 83.6332 74.4142 84.4142L75.5858 85.5858C76.3668 86.3668 76.3668 87.6332 75.5858 88.4142L74.4142 89.5858C73.6332 90.3668 72.3668 90.3668 71.5858 89.5858L70.4142 88.4142C69.6332 87.6332 69.6332 86.3668 70.4142 85.5858L71.5858 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M87.5858 84.4142C88.3668 83.6332 89.6332 83.6332 90.4142 84.4142L91.5858 85.5858C92.3668 86.3668 92.3668 87.6332 91.5858 88.4142L90.4142 89.5858C89.6332 90.3668 88.3668 90.3668 87.5858 89.5858L86.4142 88.4142C85.6332 87.6332 85.6332 86.3668 86.4142 85.5858L87.5858 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M103.586 84.4142C104.367 83.6332 105.633 83.6332 106.414 84.4142L107.586 85.5858C108.367 86.3668 108.367 87.6332 107.586 88.4142L106.414 89.5858C105.633 90.3668 104.367 90.3668 103.586 89.5858L102.414 88.4142C101.633 87.6332 101.633 86.3668 102.414 85.5858L103.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M119.586 84.4142C120.367 83.6332 121.633 83.6332 122.414 84.4142L123.586 85.5858C124.367 86.3668 124.367 87.6332 123.586 88.4142L122.414 89.5858C121.633 90.3668 120.367 90.3668 119.586 89.5858L118.414 88.4142C117.633 87.6332 117.633 86.3668 118.414 85.5858L119.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M135.586 84.4142C136.367 83.6332 137.633 83.6332 138.414 84.4142L139.586 85.5858C140.367 86.3668 140.367 87.6332 139.586 88.4142L138.414 89.5858C137.633 90.3668 136.367 90.3668 135.586 89.5858L134.414 88.4142C133.633 87.6332 133.633 86.3668 134.414 85.5858L135.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M151.586 84.4142C152.367 83.6332 153.633 83.6332 154.414 84.4142L155.586 85.5858C156.367 86.3668 156.367 87.6332 155.586 88.4142L154.414 89.5858C153.633 90.3668 152.367 90.3668 151.586 89.5858L150.414 88.4142C149.633 87.6332 149.633 86.3668 150.414 85.5858L151.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M167.586 84.4142C168.367 83.6332 169.633 83.6332 170.414 84.4142L171.586 85.5858C172.367 86.3668 172.367 87.6332 171.586 88.4142L170.414 89.5858C169.633 90.3668 168.367 90.3668 167.586 89.5858L166.414 88.4142C165.633 87.6332 165.633 86.3668 166.414 85.5858L167.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M183.586 84.4142C184.367 83.6332 185.633 83.6332 186.414 84.4142L187.586 85.5858C188.367 86.3668 188.367 87.6332 187.586 88.4142L186.414 89.5858C185.633 90.3668 184.367 90.3668 183.586 89.5858L182.414 88.4142C181.633 87.6332 181.633 86.3668 182.414 85.5858L183.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M199.586 84.4142C200.367 83.6332 201.633 83.6332 202.414 84.4142L203.586 85.5858C204.367 86.3668 204.367 87.6332 203.586 88.4142L202.414 89.5858C201.633 90.3668 200.367 90.3668 199.586 89.5858L198.414 88.4142C197.633 87.6332 197.633 86.3668 198.414 85.5858L199.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M215.586 84.4142C216.367 83.6332 217.633 83.6332 218.414 84.4142L219.586 85.5858C220.367 86.3668 220.367 87.6332 219.586 88.4142L218.414 89.5858C217.633 90.3668 216.367 90.3668 215.586 89.5858L214.414 88.4142C213.633 87.6332 213.633 86.3668 214.414 85.5858L215.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M231.586 84.4142C232.367 83.6332 233.633 83.6332 234.414 84.4142L235.586 85.5858C236.367 86.3668 236.367 87.6332 235.586 88.4142L234.414 89.5858C233.633 90.3668 232.367 90.3668 231.586 89.5858L230.414 88.4142C229.633 87.6332 229.633 86.3668 230.414 85.5858L231.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M247.586 84.4142C248.367 83.6332 249.633 83.6332 250.414 84.4142L251.586 85.5858C252.367 86.3668 252.367 87.6332 251.586 88.4142L250.414 89.5858C249.633 90.3668 248.367 90.3668 247.586 89.5858L246.414 88.4142C245.633 87.6332 245.633 86.3668 246.414 85.5858L247.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M263.586 84.4142C264.367 83.6332 265.633 83.6332 266.414 84.4142L267.586 85.5858C268.367 86.3668 268.367 87.6332 267.586 88.4142L266.414 89.5858C265.633 90.3668 264.367 90.3668 263.586 89.5858L262.414 88.4142C261.633 87.6332 261.633 86.3668 262.414 85.5858L263.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M279.586 84.4142C280.367 83.6332 281.633 83.6332 282.414 84.4142L283.586 85.5858C284.367 86.3668 284.367 87.6332 283.586 88.4142L282.414 89.5858C281.633 90.3668 280.367 90.3668 279.586 89.5858L278.414 88.4142C277.633 87.6332 277.633 86.3668 278.414 85.5858L279.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M295.586 84.4142C296.367 83.6332 297.633 83.6332 298.414 84.4142L299.586 85.5858C300.367 86.3668 300.367 87.6332 299.586 88.4142L298.414 89.5858C297.633 90.3668 296.367 90.3668 295.586 89.5858L294.414 88.4142C293.633 87.6332 293.633 86.3668 294.414 85.5858L295.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M311.586 84.4142C312.367 83.6332 313.633 83.6332 314.414 84.4142L315.586 85.5858C316.367 86.3668 316.367 87.6332 315.586 88.4142L314.414 89.5858C313.633 90.3668 312.367 90.3668 311.586 89.5858L310.414 88.4142C309.633 87.6332 309.633 86.3668 310.414 85.5858L311.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M327.586 84.4142C328.367 83.6332 329.633 83.6332 330.414 84.4142L331.586 85.5858C332.367 86.3668 332.367 87.6332 331.586 88.4142L330.414 89.5858C329.633 90.3668 328.367 90.3668 327.586 89.5858L326.414 88.4142C325.633 87.6332 325.633 86.3668 326.414 85.5858L327.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.92"
            d="M343.586 84.4142C344.367 83.6332 345.633 83.6332 346.414 84.4142L347.586 85.5858C348.367 86.3668 348.367 87.6332 347.586 88.4142L346.414 89.5858C345.633 90.3668 344.367 90.3668 343.586 89.5858L342.414 88.4142C341.633 87.6332 341.633 86.3668 342.414 85.5858L343.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.93"
            d="M359.586 84.4142C360.367 83.6332 361.633 83.6332 362.414 84.4142L363.586 85.5858C364.367 86.3668 364.367 87.6332 363.586 88.4142L362.414 89.5858C361.633 90.3668 360.367 90.3668 359.586 89.5858L358.414 88.4142C357.633 87.6332 357.633 86.3668 358.414 85.5858L359.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M375.586 84.4142C376.367 83.6332 377.633 83.6332 378.414 84.4142L379.586 85.5858C380.367 86.3668 380.367 87.6332 379.586 88.4142L378.414 89.5858C377.633 90.3668 376.367 90.3668 375.586 89.5858L374.414 88.4142C373.633 87.6332 373.633 86.3668 374.414 85.5858L375.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M391.586 84.4142C392.367 83.6332 393.633 83.6332 394.414 84.4142L395.586 85.5858C396.367 86.3668 396.367 87.6332 395.586 88.4142L394.414 89.5858C393.633 90.3668 392.367 90.3668 391.586 89.5858L390.414 88.4142C389.633 87.6332 389.633 86.3668 390.414 85.5858L391.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M407.586 84.4142C408.367 83.6332 409.633 83.6332 410.414 84.4142L411.586 85.5858C412.367 86.3668 412.367 87.6332 411.586 88.4142L410.414 89.5858C409.633 90.3668 408.367 90.3668 407.586 89.5858L406.414 88.4142C405.633 87.6332 405.633 86.3668 406.414 85.5858L407.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M423.586 84.4142C424.367 83.6332 425.633 83.6332 426.414 84.4142L427.586 85.5858C428.367 86.3668 428.367 87.6332 427.586 88.4142L426.414 89.5858C425.633 90.3668 424.367 90.3668 423.586 89.5858L422.414 88.4142C421.633 87.6332 421.633 86.3668 422.414 85.5858L423.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M439.586 84.4142C440.367 83.6332 441.633 83.6332 442.414 84.4142L443.586 85.5858C444.367 86.3668 444.367 87.6332 443.586 88.4142L442.414 89.5858C441.633 90.3668 440.367 90.3668 439.586 89.5858L438.414 88.4142C437.633 87.6332 437.633 86.3668 438.414 85.5858L439.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M455.586 84.4142C456.367 83.6332 457.633 83.6332 458.414 84.4142L459.586 85.5858C460.367 86.3668 460.367 87.6332 459.586 88.4142L458.414 89.5858C457.633 90.3668 456.367 90.3668 455.586 89.5858L454.414 88.4142C453.633 87.6332 453.633 86.3668 454.414 85.5858L455.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M471.586 84.4142C472.367 83.6332 473.633 83.6332 474.414 84.4142L475.586 85.5858C476.367 86.3668 476.367 87.6332 475.586 88.4142L474.414 89.5858C473.633 90.3668 472.367 90.3668 471.586 89.5858L470.414 88.4142C469.633 87.6332 469.633 86.3668 470.414 85.5858L471.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M487.586 84.4142C488.367 83.6332 489.633 83.6332 490.414 84.4142L491.586 85.5858C492.367 86.3668 492.367 87.6332 491.586 88.4142L490.414 89.5858C489.633 90.3668 488.367 90.3668 487.586 89.5858L486.414 88.4142C485.633 87.6332 485.633 86.3668 486.414 85.5858L487.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.2"
            d="M503.586 84.4142C504.367 83.6332 505.633 83.6332 506.414 84.4142L507.586 85.5858C508.367 86.3668 508.367 87.6332 507.586 88.4142L506.414 89.5858C505.633 90.3668 504.367 90.3668 503.586 89.5858L502.414 88.4142C501.633 87.6332 501.633 86.3668 502.414 85.5858L503.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M519.586 84.4142C520.367 83.6332 521.633 83.6332 522.414 84.4142L523.586 85.5858C524.367 86.3668 524.367 87.6332 523.586 88.4142L522.414 89.5858C521.633 90.3668 520.367 90.3668 519.586 89.5858L518.414 88.4142C517.633 87.6332 517.633 86.3668 518.414 85.5858L519.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M535.586 84.4142C536.367 83.6332 537.633 83.6332 538.414 84.4142L539.586 85.5858C540.367 86.3668 540.367 87.6332 539.586 88.4142L538.414 89.5858C537.633 90.3668 536.367 90.3668 535.586 89.5858L534.414 88.4142C533.633 87.6332 533.633 86.3668 534.414 85.5858L535.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M551.586 84.4142C552.367 83.6332 553.633 83.6332 554.414 84.4142L555.586 85.5858C556.367 86.3668 556.367 87.6332 555.586 88.4142L554.414 89.5858C553.633 90.3668 552.367 90.3668 551.586 89.5858L550.414 88.4142C549.633 87.6332 549.633 86.3668 550.414 85.5858L551.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.47"
            d="M567.586 84.4142C568.367 83.6332 569.633 83.6332 570.414 84.4142L571.586 85.5858C572.367 86.3668 572.367 87.6332 571.586 88.4142L570.414 89.5858C569.633 90.3668 568.367 90.3668 567.586 89.5858L566.414 88.4142C565.633 87.6332 565.633 86.3668 566.414 85.5858L567.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M583.586 84.4142C584.367 83.6332 585.633 83.6332 586.414 84.4142L587.586 85.5858C588.367 86.3668 588.367 87.6332 587.586 88.4142L586.414 89.5858C585.633 90.3668 584.367 90.3668 583.586 89.5858L582.414 88.4142C581.633 87.6332 581.633 86.3668 582.414 85.5858L583.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M599.586 84.4142C600.367 83.6332 601.633 83.6332 602.414 84.4142L603.586 85.5858C604.367 86.3668 604.367 87.6332 603.586 88.4142L602.414 89.5858C601.633 90.3668 600.367 90.3668 599.586 89.5858L598.414 88.4142C597.633 87.6332 597.633 86.3668 598.414 85.5858L599.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M615.586 84.4142C616.367 83.6332 617.633 83.6332 618.414 84.4142L619.586 85.5858C620.367 86.3668 620.367 87.6332 619.586 88.4142L618.414 89.5858C617.633 90.3668 616.367 90.3668 615.586 89.5858L614.414 88.4142C613.633 87.6332 613.633 86.3668 614.414 85.5858L615.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M631.586 84.4142C632.367 83.6332 633.633 83.6332 634.414 84.4142L635.586 85.5858C636.367 86.3668 636.367 87.6332 635.586 88.4142L634.414 89.5858C633.633 90.3668 632.367 90.3668 631.586 89.5858L630.414 88.4142C629.633 87.6332 629.633 86.3668 630.414 85.5858L631.586 84.4142Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M7.58579 100.414C8.36684 99.6332 9.63317 99.6332 10.4142 100.414L11.5858 101.586C12.3668 102.367 12.3668 103.633 11.5858 104.414L10.4142 105.586C9.63316 106.367 8.36683 106.367 7.58579 105.586L6.41421 104.414C5.63316 103.633 5.63317 102.367 6.41421 101.586L7.58579 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M23.5858 100.414C24.3668 99.6332 25.6332 99.6332 26.4142 100.414L27.5858 101.586C28.3668 102.367 28.3668 103.633 27.5858 104.414L26.4142 105.586C25.6332 106.367 24.3668 106.367 23.5858 105.586L22.4142 104.414C21.6332 103.633 21.6332 102.367 22.4142 101.586L23.5858 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M39.5858 100.414C40.3668 99.6332 41.6332 99.6332 42.4142 100.414L43.5858 101.586C44.3668 102.367 44.3668 103.633 43.5858 104.414L42.4142 105.586C41.6332 106.367 40.3668 106.367 39.5858 105.586L38.4142 104.414C37.6332 103.633 37.6332 102.367 38.4142 101.586L39.5858 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M55.5858 100.414C56.3668 99.6332 57.6332 99.6332 58.4142 100.414L59.5858 101.586C60.3668 102.367 60.3668 103.633 59.5858 104.414L58.4142 105.586C57.6332 106.367 56.3668 106.367 55.5858 105.586L54.4142 104.414C53.6332 103.633 53.6332 102.367 54.4142 101.586L55.5858 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M71.5858 100.414C72.3668 99.6332 73.6332 99.6332 74.4142 100.414L75.5858 101.586C76.3668 102.367 76.3668 103.633 75.5858 104.414L74.4142 105.586C73.6332 106.367 72.3668 106.367 71.5858 105.586L70.4142 104.414C69.6332 103.633 69.6332 102.367 70.4142 101.586L71.5858 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M87.5858 100.414C88.3668 99.6332 89.6332 99.6332 90.4142 100.414L91.5858 101.586C92.3668 102.367 92.3668 103.633 91.5858 104.414L90.4142 105.586C89.6332 106.367 88.3668 106.367 87.5858 105.586L86.4142 104.414C85.6332 103.633 85.6332 102.367 86.4142 101.586L87.5858 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M103.586 100.414C104.367 99.6332 105.633 99.6332 106.414 100.414L107.586 101.586C108.367 102.367 108.367 103.633 107.586 104.414L106.414 105.586C105.633 106.367 104.367 106.367 103.586 105.586L102.414 104.414C101.633 103.633 101.633 102.367 102.414 101.586L103.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M119.586 100.414C120.367 99.6332 121.633 99.6332 122.414 100.414L123.586 101.586C124.367 102.367 124.367 103.633 123.586 104.414L122.414 105.586C121.633 106.367 120.367 106.367 119.586 105.586L118.414 104.414C117.633 103.633 117.633 102.367 118.414 101.586L119.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M135.586 100.414C136.367 99.6332 137.633 99.6332 138.414 100.414L139.586 101.586C140.367 102.367 140.367 103.633 139.586 104.414L138.414 105.586C137.633 106.367 136.367 106.367 135.586 105.586L134.414 104.414C133.633 103.633 133.633 102.367 134.414 101.586L135.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M151.586 100.414C152.367 99.6332 153.633 99.6332 154.414 100.414L155.586 101.586C156.367 102.367 156.367 103.633 155.586 104.414L154.414 105.586C153.633 106.367 152.367 106.367 151.586 105.586L150.414 104.414C149.633 103.633 149.633 102.367 150.414 101.586L151.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M167.586 100.414C168.367 99.6332 169.633 99.6332 170.414 100.414L171.586 101.586C172.367 102.367 172.367 103.633 171.586 104.414L170.414 105.586C169.633 106.367 168.367 106.367 167.586 105.586L166.414 104.414C165.633 103.633 165.633 102.367 166.414 101.586L167.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.45"
            d="M183.586 100.414C184.367 99.6332 185.633 99.6332 186.414 100.414L187.586 101.586C188.367 102.367 188.367 103.633 187.586 104.414L186.414 105.586C185.633 106.367 184.367 106.367 183.586 105.586L182.414 104.414C181.633 103.633 181.633 102.367 182.414 101.586L183.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.85"
            d="M199.586 100.414C200.367 99.6332 201.633 99.6332 202.414 100.414L203.586 101.586C204.367 102.367 204.367 103.633 203.586 104.414L202.414 105.586C201.633 106.367 200.367 106.367 199.586 105.586L198.414 104.414C197.633 103.633 197.633 102.367 198.414 101.586L199.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M215.586 100.414C216.367 99.6332 217.633 99.6332 218.414 100.414L219.586 101.586C220.367 102.367 220.367 103.633 219.586 104.414L218.414 105.586C217.633 106.367 216.367 106.367 215.586 105.586L214.414 104.414C213.633 103.633 213.633 102.367 214.414 101.586L215.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M231.586 100.414C232.367 99.6332 233.633 99.6332 234.414 100.414L235.586 101.586C236.367 102.367 236.367 103.633 235.586 104.414L234.414 105.586C233.633 106.367 232.367 106.367 231.586 105.586L230.414 104.414C229.633 103.633 229.633 102.367 230.414 101.586L231.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M247.586 100.414C248.367 99.6332 249.633 99.6332 250.414 100.414L251.586 101.586C252.367 102.367 252.367 103.633 251.586 104.414L250.414 105.586C249.633 106.367 248.367 106.367 247.586 105.586L246.414 104.414C245.633 103.633 245.633 102.367 246.414 101.586L247.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M263.586 100.414C264.367 99.6332 265.633 99.6332 266.414 100.414L267.586 101.586C268.367 102.367 268.367 103.633 267.586 104.414L266.414 105.586C265.633 106.367 264.367 106.367 263.586 105.586L262.414 104.414C261.633 103.633 261.633 102.367 262.414 101.586L263.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M279.586 100.414C280.367 99.6332 281.633 99.6332 282.414 100.414L283.586 101.586C284.367 102.367 284.367 103.633 283.586 104.414L282.414 105.586C281.633 106.367 280.367 106.367 279.586 105.586L278.414 104.414C277.633 103.633 277.633 102.367 278.414 101.586L279.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.8"
            d="M295.586 100.414C296.367 99.6332 297.633 99.6332 298.414 100.414L299.586 101.586C300.367 102.367 300.367 103.633 299.586 104.414L298.414 105.586C297.633 106.367 296.367 106.367 295.586 105.586L294.414 104.414C293.633 103.633 293.633 102.367 294.414 101.586L295.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M311.586 100.414C312.367 99.6332 313.633 99.6332 314.414 100.414L315.586 101.586C316.367 102.367 316.367 103.633 315.586 104.414L314.414 105.586C313.633 106.367 312.367 106.367 311.586 105.586L310.414 104.414C309.633 103.633 309.633 102.367 310.414 101.586L311.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M327.586 100.414C328.367 99.6332 329.633 99.6332 330.414 100.414L331.586 101.586C332.367 102.367 332.367 103.633 331.586 104.414L330.414 105.586C329.633 106.367 328.367 106.367 327.586 105.586L326.414 104.414C325.633 103.633 325.633 102.367 326.414 101.586L327.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M343.586 100.414C344.367 99.6332 345.633 99.6332 346.414 100.414L347.586 101.586C348.367 102.367 348.367 103.633 347.586 104.414L346.414 105.586C345.633 106.367 344.367 106.367 343.586 105.586L342.414 104.414C341.633 103.633 341.633 102.367 342.414 101.586L343.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M359.586 100.414C360.367 99.6332 361.633 99.6332 362.414 100.414L363.586 101.586C364.367 102.367 364.367 103.633 363.586 104.414L362.414 105.586C361.633 106.367 360.367 106.367 359.586 105.586L358.414 104.414C357.633 103.633 357.633 102.367 358.414 101.586L359.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M375.586 100.414C376.367 99.6332 377.633 99.6332 378.414 100.414L379.586 101.586C380.367 102.367 380.367 103.633 379.586 104.414L378.414 105.586C377.633 106.367 376.367 106.367 375.586 105.586L374.414 104.414C373.633 103.633 373.633 102.367 374.414 101.586L375.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M391.586 100.414C392.367 99.6332 393.633 99.6332 394.414 100.414L395.586 101.586C396.367 102.367 396.367 103.633 395.586 104.414L394.414 105.586C393.633 106.367 392.367 106.367 391.586 105.586L390.414 104.414C389.633 103.633 389.633 102.367 390.414 101.586L391.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.71"
            d="M407.586 100.414C408.367 99.6332 409.633 99.6332 410.414 100.414L411.586 101.586C412.367 102.367 412.367 103.633 411.586 104.414L410.414 105.586C409.633 106.367 408.367 106.367 407.586 105.586L406.414 104.414C405.633 103.633 405.633 102.367 406.414 101.586L407.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M423.586 100.414C424.367 99.6332 425.633 99.6332 426.414 100.414L427.586 101.586C428.367 102.367 428.367 103.633 427.586 104.414L426.414 105.586C425.633 106.367 424.367 106.367 423.586 105.586L422.414 104.414C421.633 103.633 421.633 102.367 422.414 101.586L423.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M439.586 100.414C440.367 99.6332 441.633 99.6332 442.414 100.414L443.586 101.586C444.367 102.367 444.367 103.633 443.586 104.414L442.414 105.586C441.633 106.367 440.367 106.367 439.586 105.586L438.414 104.414C437.633 103.633 437.633 102.367 438.414 101.586L439.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M455.586 100.414C456.367 99.6332 457.633 99.6332 458.414 100.414L459.586 101.586C460.367 102.367 460.367 103.633 459.586 104.414L458.414 105.586C457.633 106.367 456.367 106.367 455.586 105.586L454.414 104.414C453.633 103.633 453.633 102.367 454.414 101.586L455.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M471.586 100.414C472.367 99.6332 473.633 99.6332 474.414 100.414L475.586 101.586C476.367 102.367 476.367 103.633 475.586 104.414L474.414 105.586C473.633 106.367 472.367 106.367 471.586 105.586L470.414 104.414C469.633 103.633 469.633 102.367 470.414 101.586L471.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M487.586 100.414C488.367 99.6332 489.633 99.6332 490.414 100.414L491.586 101.586C492.367 102.367 492.367 103.633 491.586 104.414L490.414 105.586C489.633 106.367 488.367 106.367 487.586 105.586L486.414 104.414C485.633 103.633 485.633 102.367 486.414 101.586L487.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M503.586 100.414C504.367 99.6332 505.633 99.6332 506.414 100.414L507.586 101.586C508.367 102.367 508.367 103.633 507.586 104.414L506.414 105.586C505.633 106.367 504.367 106.367 503.586 105.586L502.414 104.414C501.633 103.633 501.633 102.367 502.414 101.586L503.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M519.586 100.414C520.367 99.6332 521.633 99.6332 522.414 100.414L523.586 101.586C524.367 102.367 524.367 103.633 523.586 104.414L522.414 105.586C521.633 106.367 520.367 106.367 519.586 105.586L518.414 104.414C517.633 103.633 517.633 102.367 518.414 101.586L519.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M535.586 100.414C536.367 99.6332 537.633 99.6332 538.414 100.414L539.586 101.586C540.367 102.367 540.367 103.633 539.586 104.414L538.414 105.586C537.633 106.367 536.367 106.367 535.586 105.586L534.414 104.414C533.633 103.633 533.633 102.367 534.414 101.586L535.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M551.586 100.414C552.367 99.6332 553.633 99.6332 554.414 100.414L555.586 101.586C556.367 102.367 556.367 103.633 555.586 104.414L554.414 105.586C553.633 106.367 552.367 106.367 551.586 105.586L550.414 104.414C549.633 103.633 549.633 102.367 550.414 101.586L551.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M567.586 100.414C568.367 99.6332 569.633 99.6332 570.414 100.414L571.586 101.586C572.367 102.367 572.367 103.633 571.586 104.414L570.414 105.586C569.633 106.367 568.367 106.367 567.586 105.586L566.414 104.414C565.633 103.633 565.633 102.367 566.414 101.586L567.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.58"
            d="M583.586 100.414C584.367 99.6332 585.633 99.6332 586.414 100.414L587.586 101.586C588.367 102.367 588.367 103.633 587.586 104.414L586.414 105.586C585.633 106.367 584.367 106.367 583.586 105.586L582.414 104.414C581.633 103.633 581.633 102.367 582.414 101.586L583.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M599.586 100.414C600.367 99.6332 601.633 99.6332 602.414 100.414L603.586 101.586C604.367 102.367 604.367 103.633 603.586 104.414L602.414 105.586C601.633 106.367 600.367 106.367 599.586 105.586L598.414 104.414C597.633 103.633 597.633 102.367 598.414 101.586L599.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M615.586 100.414C616.367 99.6332 617.633 99.6332 618.414 100.414L619.586 101.586C620.367 102.367 620.367 103.633 619.586 104.414L618.414 105.586C617.633 106.367 616.367 106.367 615.586 105.586L614.414 104.414C613.633 103.633 613.633 102.367 614.414 101.586L615.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M631.586 100.414C632.367 99.6332 633.633 99.6332 634.414 100.414L635.586 101.586C636.367 102.367 636.367 103.633 635.586 104.414L634.414 105.586C633.633 106.367 632.367 106.367 631.586 105.586L630.414 104.414C629.633 103.633 629.633 102.367 630.414 101.586L631.586 100.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M7.58579 116.414C8.36684 115.633 9.63317 115.633 10.4142 116.414L11.5858 117.586C12.3668 118.367 12.3668 119.633 11.5858 120.414L10.4142 121.586C9.63316 122.367 8.36683 122.367 7.58579 121.586L6.41421 120.414C5.63316 119.633 5.63317 118.367 6.41421 117.586L7.58579 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M23.5858 116.414C24.3668 115.633 25.6332 115.633 26.4142 116.414L27.5858 117.586C28.3668 118.367 28.3668 119.633 27.5858 120.414L26.4142 121.586C25.6332 122.367 24.3668 122.367 23.5858 121.586L22.4142 120.414C21.6332 119.633 21.6332 118.367 22.4142 117.586L23.5858 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M39.5858 116.414C40.3668 115.633 41.6332 115.633 42.4142 116.414L43.5858 117.586C44.3668 118.367 44.3668 119.633 43.5858 120.414L42.4142 121.586C41.6332 122.367 40.3668 122.367 39.5858 121.586L38.4142 120.414C37.6332 119.633 37.6332 118.367 38.4142 117.586L39.5858 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M55.5858 116.414C56.3668 115.633 57.6332 115.633 58.4142 116.414L59.5858 117.586C60.3668 118.367 60.3668 119.633 59.5858 120.414L58.4142 121.586C57.6332 122.367 56.3668 122.367 55.5858 121.586L54.4142 120.414C53.6332 119.633 53.6332 118.367 54.4142 117.586L55.5858 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M71.5858 116.414C72.3668 115.633 73.6332 115.633 74.4142 116.414L75.5858 117.586C76.3668 118.367 76.3668 119.633 75.5858 120.414L74.4142 121.586C73.6332 122.367 72.3668 122.367 71.5858 121.586L70.4142 120.414C69.6332 119.633 69.6332 118.367 70.4142 117.586L71.5858 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M87.5858 116.414C88.3668 115.633 89.6332 115.633 90.4142 116.414L91.5858 117.586C92.3668 118.367 92.3668 119.633 91.5858 120.414L90.4142 121.586C89.6332 122.367 88.3668 122.367 87.5858 121.586L86.4142 120.414C85.6332 119.633 85.6332 118.367 86.4142 117.586L87.5858 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M103.586 116.414C104.367 115.633 105.633 115.633 106.414 116.414L107.586 117.586C108.367 118.367 108.367 119.633 107.586 120.414L106.414 121.586C105.633 122.367 104.367 122.367 103.586 121.586L102.414 120.414C101.633 119.633 101.633 118.367 102.414 117.586L103.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M119.586 116.414C120.367 115.633 121.633 115.633 122.414 116.414L123.586 117.586C124.367 118.367 124.367 119.633 123.586 120.414L122.414 121.586C121.633 122.367 120.367 122.367 119.586 121.586L118.414 120.414C117.633 119.633 117.633 118.367 118.414 117.586L119.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M135.586 116.414C136.367 115.633 137.633 115.633 138.414 116.414L139.586 117.586C140.367 118.367 140.367 119.633 139.586 120.414L138.414 121.586C137.633 122.367 136.367 122.367 135.586 121.586L134.414 120.414C133.633 119.633 133.633 118.367 134.414 117.586L135.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M151.586 116.414C152.367 115.633 153.633 115.633 154.414 116.414L155.586 117.586C156.367 118.367 156.367 119.633 155.586 120.414L154.414 121.586C153.633 122.367 152.367 122.367 151.586 121.586L150.414 120.414C149.633 119.633 149.633 118.367 150.414 117.586L151.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M167.586 116.414C168.367 115.633 169.633 115.633 170.414 116.414L171.586 117.586C172.367 118.367 172.367 119.633 171.586 120.414L170.414 121.586C169.633 122.367 168.367 122.367 167.586 121.586L166.414 120.414C165.633 119.633 165.633 118.367 166.414 117.586L167.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M183.586 116.414C184.367 115.633 185.633 115.633 186.414 116.414L187.586 117.586C188.367 118.367 188.367 119.633 187.586 120.414L186.414 121.586C185.633 122.367 184.367 122.367 183.586 121.586L182.414 120.414C181.633 119.633 181.633 118.367 182.414 117.586L183.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M199.586 116.414C200.367 115.633 201.633 115.633 202.414 116.414L203.586 117.586C204.367 118.367 204.367 119.633 203.586 120.414L202.414 121.586C201.633 122.367 200.367 122.367 199.586 121.586L198.414 120.414C197.633 119.633 197.633 118.367 198.414 117.586L199.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M215.586 116.414C216.367 115.633 217.633 115.633 218.414 116.414L219.586 117.586C220.367 118.367 220.367 119.633 219.586 120.414L218.414 121.586C217.633 122.367 216.367 122.367 215.586 121.586L214.414 120.414C213.633 119.633 213.633 118.367 214.414 117.586L215.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.74"
            d="M231.586 116.414C232.367 115.633 233.633 115.633 234.414 116.414L235.586 117.586C236.367 118.367 236.367 119.633 235.586 120.414L234.414 121.586C233.633 122.367 232.367 122.367 231.586 121.586L230.414 120.414C229.633 119.633 229.633 118.367 230.414 117.586L231.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M247.586 116.414C248.367 115.633 249.633 115.633 250.414 116.414L251.586 117.586C252.367 118.367 252.367 119.633 251.586 120.414L250.414 121.586C249.633 122.367 248.367 122.367 247.586 121.586L246.414 120.414C245.633 119.633 245.633 118.367 246.414 117.586L247.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M263.586 116.414C264.367 115.633 265.633 115.633 266.414 116.414L267.586 117.586C268.367 118.367 268.367 119.633 267.586 120.414L266.414 121.586C265.633 122.367 264.367 122.367 263.586 121.586L262.414 120.414C261.633 119.633 261.633 118.367 262.414 117.586L263.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M279.586 116.414C280.367 115.633 281.633 115.633 282.414 116.414L283.586 117.586C284.367 118.367 284.367 119.633 283.586 120.414L282.414 121.586C281.633 122.367 280.367 122.367 279.586 121.586L278.414 120.414C277.633 119.633 277.633 118.367 278.414 117.586L279.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M295.586 116.414C296.367 115.633 297.633 115.633 298.414 116.414L299.586 117.586C300.367 118.367 300.367 119.633 299.586 120.414L298.414 121.586C297.633 122.367 296.367 122.367 295.586 121.586L294.414 120.414C293.633 119.633 293.633 118.367 294.414 117.586L295.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.53"
            d="M311.586 116.414C312.367 115.633 313.633 115.633 314.414 116.414L315.586 117.586C316.367 118.367 316.367 119.633 315.586 120.414L314.414 121.586C313.633 122.367 312.367 122.367 311.586 121.586L310.414 120.414C309.633 119.633 309.633 118.367 310.414 117.586L311.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M327.586 116.414C328.367 115.633 329.633 115.633 330.414 116.414L331.586 117.586C332.367 118.367 332.367 119.633 331.586 120.414L330.414 121.586C329.633 122.367 328.367 122.367 327.586 121.586L326.414 120.414C325.633 119.633 325.633 118.367 326.414 117.586L327.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M343.586 116.414C344.367 115.633 345.633 115.633 346.414 116.414L347.586 117.586C348.367 118.367 348.367 119.633 347.586 120.414L346.414 121.586C345.633 122.367 344.367 122.367 343.586 121.586L342.414 120.414C341.633 119.633 341.633 118.367 342.414 117.586L343.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M359.586 116.414C360.367 115.633 361.633 115.633 362.414 116.414L363.586 117.586C364.367 118.367 364.367 119.633 363.586 120.414L362.414 121.586C361.633 122.367 360.367 122.367 359.586 121.586L358.414 120.414C357.633 119.633 357.633 118.367 358.414 117.586L359.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.59"
            d="M375.586 116.414C376.367 115.633 377.633 115.633 378.414 116.414L379.586 117.586C380.367 118.367 380.367 119.633 379.586 120.414L378.414 121.586C377.633 122.367 376.367 122.367 375.586 121.586L374.414 120.414C373.633 119.633 373.633 118.367 374.414 117.586L375.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M391.586 116.414C392.367 115.633 393.633 115.633 394.414 116.414L395.586 117.586C396.367 118.367 396.367 119.633 395.586 120.414L394.414 121.586C393.633 122.367 392.367 122.367 391.586 121.586L390.414 120.414C389.633 119.633 389.633 118.367 390.414 117.586L391.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M407.586 116.414C408.367 115.633 409.633 115.633 410.414 116.414L411.586 117.586C412.367 118.367 412.367 119.633 411.586 120.414L410.414 121.586C409.633 122.367 408.367 122.367 407.586 121.586L406.414 120.414C405.633 119.633 405.633 118.367 406.414 117.586L407.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M423.586 116.414C424.367 115.633 425.633 115.633 426.414 116.414L427.586 117.586C428.367 118.367 428.367 119.633 427.586 120.414L426.414 121.586C425.633 122.367 424.367 122.367 423.586 121.586L422.414 120.414C421.633 119.633 421.633 118.367 422.414 117.586L423.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M439.586 116.414C440.367 115.633 441.633 115.633 442.414 116.414L443.586 117.586C444.367 118.367 444.367 119.633 443.586 120.414L442.414 121.586C441.633 122.367 440.367 122.367 439.586 121.586L438.414 120.414C437.633 119.633 437.633 118.367 438.414 117.586L439.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M455.586 116.414C456.367 115.633 457.633 115.633 458.414 116.414L459.586 117.586C460.367 118.367 460.367 119.633 459.586 120.414L458.414 121.586C457.633 122.367 456.367 122.367 455.586 121.586L454.414 120.414C453.633 119.633 453.633 118.367 454.414 117.586L455.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M471.586 116.414C472.367 115.633 473.633 115.633 474.414 116.414L475.586 117.586C476.367 118.367 476.367 119.633 475.586 120.414L474.414 121.586C473.633 122.367 472.367 122.367 471.586 121.586L470.414 120.414C469.633 119.633 469.633 118.367 470.414 117.586L471.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M487.586 116.414C488.367 115.633 489.633 115.633 490.414 116.414L491.586 117.586C492.367 118.367 492.367 119.633 491.586 120.414L490.414 121.586C489.633 122.367 488.367 122.367 487.586 121.586L486.414 120.414C485.633 119.633 485.633 118.367 486.414 117.586L487.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M503.586 116.414C504.367 115.633 505.633 115.633 506.414 116.414L507.586 117.586C508.367 118.367 508.367 119.633 507.586 120.414L506.414 121.586C505.633 122.367 504.367 122.367 503.586 121.586L502.414 120.414C501.633 119.633 501.633 118.367 502.414 117.586L503.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M519.586 116.414C520.367 115.633 521.633 115.633 522.414 116.414L523.586 117.586C524.367 118.367 524.367 119.633 523.586 120.414L522.414 121.586C521.633 122.367 520.367 122.367 519.586 121.586L518.414 120.414C517.633 119.633 517.633 118.367 518.414 117.586L519.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M535.586 116.414C536.367 115.633 537.633 115.633 538.414 116.414L539.586 117.586C540.367 118.367 540.367 119.633 539.586 120.414L538.414 121.586C537.633 122.367 536.367 122.367 535.586 121.586L534.414 120.414C533.633 119.633 533.633 118.367 534.414 117.586L535.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M551.586 116.414C552.367 115.633 553.633 115.633 554.414 116.414L555.586 117.586C556.367 118.367 556.367 119.633 555.586 120.414L554.414 121.586C553.633 122.367 552.367 122.367 551.586 121.586L550.414 120.414C549.633 119.633 549.633 118.367 550.414 117.586L551.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.45"
            d="M567.586 116.414C568.367 115.633 569.633 115.633 570.414 116.414L571.586 117.586C572.367 118.367 572.367 119.633 571.586 120.414L570.414 121.586C569.633 122.367 568.367 122.367 567.586 121.586L566.414 120.414C565.633 119.633 565.633 118.367 566.414 117.586L567.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M583.586 116.414C584.367 115.633 585.633 115.633 586.414 116.414L587.586 117.586C588.367 118.367 588.367 119.633 587.586 120.414L586.414 121.586C585.633 122.367 584.367 122.367 583.586 121.586L582.414 120.414C581.633 119.633 581.633 118.367 582.414 117.586L583.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M599.586 116.414C600.367 115.633 601.633 115.633 602.414 116.414L603.586 117.586C604.367 118.367 604.367 119.633 603.586 120.414L602.414 121.586C601.633 122.367 600.367 122.367 599.586 121.586L598.414 120.414C597.633 119.633 597.633 118.367 598.414 117.586L599.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M615.586 116.414C616.367 115.633 617.633 115.633 618.414 116.414L619.586 117.586C620.367 118.367 620.367 119.633 619.586 120.414L618.414 121.586C617.633 122.367 616.367 122.367 615.586 121.586L614.414 120.414C613.633 119.633 613.633 118.367 614.414 117.586L615.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M631.586 116.414C632.367 115.633 633.633 115.633 634.414 116.414L635.586 117.586C636.367 118.367 636.367 119.633 635.586 120.414L634.414 121.586C633.633 122.367 632.367 122.367 631.586 121.586L630.414 120.414C629.633 119.633 629.633 118.367 630.414 117.586L631.586 116.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.85"
            d="M7.58579 132.414C8.36684 131.633 9.63317 131.633 10.4142 132.414L11.5858 133.586C12.3668 134.367 12.3668 135.633 11.5858 136.414L10.4142 137.586C9.63316 138.367 8.36683 138.367 7.58579 137.586L6.41421 136.414C5.63316 135.633 5.63317 134.367 6.41421 133.586L7.58579 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.37"
            d="M23.5858 132.414C24.3668 131.633 25.6332 131.633 26.4142 132.414L27.5858 133.586C28.3668 134.367 28.3668 135.633 27.5858 136.414L26.4142 137.586C25.6332 138.367 24.3668 138.367 23.5858 137.586L22.4142 136.414C21.6332 135.633 21.6332 134.367 22.4142 133.586L23.5858 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M39.5858 132.414C40.3668 131.633 41.6332 131.633 42.4142 132.414L43.5858 133.586C44.3668 134.367 44.3668 135.633 43.5858 136.414L42.4142 137.586C41.6332 138.367 40.3668 138.367 39.5858 137.586L38.4142 136.414C37.6332 135.633 37.6332 134.367 38.4142 133.586L39.5858 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M55.5858 132.414C56.3668 131.633 57.6332 131.633 58.4142 132.414L59.5858 133.586C60.3668 134.367 60.3668 135.633 59.5858 136.414L58.4142 137.586C57.6332 138.367 56.3668 138.367 55.5858 137.586L54.4142 136.414C53.6332 135.633 53.6332 134.367 54.4142 133.586L55.5858 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M71.5858 132.414C72.3668 131.633 73.6332 131.633 74.4142 132.414L75.5858 133.586C76.3668 134.367 76.3668 135.633 75.5858 136.414L74.4142 137.586C73.6332 138.367 72.3668 138.367 71.5858 137.586L70.4142 136.414C69.6332 135.633 69.6332 134.367 70.4142 133.586L71.5858 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.85"
            d="M87.5858 132.414C88.3668 131.633 89.6332 131.633 90.4142 132.414L91.5858 133.586C92.3668 134.367 92.3668 135.633 91.5858 136.414L90.4142 137.586C89.6332 138.367 88.3668 138.367 87.5858 137.586L86.4142 136.414C85.6332 135.633 85.6332 134.367 86.4142 133.586L87.5858 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M103.586 132.414C104.367 131.633 105.633 131.633 106.414 132.414L107.586 133.586C108.367 134.367 108.367 135.633 107.586 136.414L106.414 137.586C105.633 138.367 104.367 138.367 103.586 137.586L102.414 136.414C101.633 135.633 101.633 134.367 102.414 133.586L103.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M119.586 132.414C120.367 131.633 121.633 131.633 122.414 132.414L123.586 133.586C124.367 134.367 124.367 135.633 123.586 136.414L122.414 137.586C121.633 138.367 120.367 138.367 119.586 137.586L118.414 136.414C117.633 135.633 117.633 134.367 118.414 133.586L119.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M135.586 132.414C136.367 131.633 137.633 131.633 138.414 132.414L139.586 133.586C140.367 134.367 140.367 135.633 139.586 136.414L138.414 137.586C137.633 138.367 136.367 138.367 135.586 137.586L134.414 136.414C133.633 135.633 133.633 134.367 134.414 133.586L135.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M151.586 132.414C152.367 131.633 153.633 131.633 154.414 132.414L155.586 133.586C156.367 134.367 156.367 135.633 155.586 136.414L154.414 137.586C153.633 138.367 152.367 138.367 151.586 137.586L150.414 136.414C149.633 135.633 149.633 134.367 150.414 133.586L151.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M167.586 132.414C168.367 131.633 169.633 131.633 170.414 132.414L171.586 133.586C172.367 134.367 172.367 135.633 171.586 136.414L170.414 137.586C169.633 138.367 168.367 138.367 167.586 137.586L166.414 136.414C165.633 135.633 165.633 134.367 166.414 133.586L167.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M183.586 132.414C184.367 131.633 185.633 131.633 186.414 132.414L187.586 133.586C188.367 134.367 188.367 135.633 187.586 136.414L186.414 137.586C185.633 138.367 184.367 138.367 183.586 137.586L182.414 136.414C181.633 135.633 181.633 134.367 182.414 133.586L183.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M199.586 132.414C200.367 131.633 201.633 131.633 202.414 132.414L203.586 133.586C204.367 134.367 204.367 135.633 203.586 136.414L202.414 137.586C201.633 138.367 200.367 138.367 199.586 137.586L198.414 136.414C197.633 135.633 197.633 134.367 198.414 133.586L199.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M215.586 132.414C216.367 131.633 217.633 131.633 218.414 132.414L219.586 133.586C220.367 134.367 220.367 135.633 219.586 136.414L218.414 137.586C217.633 138.367 216.367 138.367 215.586 137.586L214.414 136.414C213.633 135.633 213.633 134.367 214.414 133.586L215.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M231.586 132.414C232.367 131.633 233.633 131.633 234.414 132.414L235.586 133.586C236.367 134.367 236.367 135.633 235.586 136.414L234.414 137.586C233.633 138.367 232.367 138.367 231.586 137.586L230.414 136.414C229.633 135.633 229.633 134.367 230.414 133.586L231.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M247.586 132.414C248.367 131.633 249.633 131.633 250.414 132.414L251.586 133.586C252.367 134.367 252.367 135.633 251.586 136.414L250.414 137.586C249.633 138.367 248.367 138.367 247.586 137.586L246.414 136.414C245.633 135.633 245.633 134.367 246.414 133.586L247.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M263.586 132.414C264.367 131.633 265.633 131.633 266.414 132.414L267.586 133.586C268.367 134.367 268.367 135.633 267.586 136.414L266.414 137.586C265.633 138.367 264.367 138.367 263.586 137.586L262.414 136.414C261.633 135.633 261.633 134.367 262.414 133.586L263.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M279.586 132.414C280.367 131.633 281.633 131.633 282.414 132.414L283.586 133.586C284.367 134.367 284.367 135.633 283.586 136.414L282.414 137.586C281.633 138.367 280.367 138.367 279.586 137.586L278.414 136.414C277.633 135.633 277.633 134.367 278.414 133.586L279.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M295.586 132.414C296.367 131.633 297.633 131.633 298.414 132.414L299.586 133.586C300.367 134.367 300.367 135.633 299.586 136.414L298.414 137.586C297.633 138.367 296.367 138.367 295.586 137.586L294.414 136.414C293.633 135.633 293.633 134.367 294.414 133.586L295.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M311.586 132.414C312.367 131.633 313.633 131.633 314.414 132.414L315.586 133.586C316.367 134.367 316.367 135.633 315.586 136.414L314.414 137.586C313.633 138.367 312.367 138.367 311.586 137.586L310.414 136.414C309.633 135.633 309.633 134.367 310.414 133.586L311.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M327.586 132.414C328.367 131.633 329.633 131.633 330.414 132.414L331.586 133.586C332.367 134.367 332.367 135.633 331.586 136.414L330.414 137.586C329.633 138.367 328.367 138.367 327.586 137.586L326.414 136.414C325.633 135.633 325.633 134.367 326.414 133.586L327.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M343.586 132.414C344.367 131.633 345.633 131.633 346.414 132.414L347.586 133.586C348.367 134.367 348.367 135.633 347.586 136.414L346.414 137.586C345.633 138.367 344.367 138.367 343.586 137.586L342.414 136.414C341.633 135.633 341.633 134.367 342.414 133.586L343.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M359.586 132.414C360.367 131.633 361.633 131.633 362.414 132.414L363.586 133.586C364.367 134.367 364.367 135.633 363.586 136.414L362.414 137.586C361.633 138.367 360.367 138.367 359.586 137.586L358.414 136.414C357.633 135.633 357.633 134.367 358.414 133.586L359.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M375.586 132.414C376.367 131.633 377.633 131.633 378.414 132.414L379.586 133.586C380.367 134.367 380.367 135.633 379.586 136.414L378.414 137.586C377.633 138.367 376.367 138.367 375.586 137.586L374.414 136.414C373.633 135.633 373.633 134.367 374.414 133.586L375.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M391.586 132.414C392.367 131.633 393.633 131.633 394.414 132.414L395.586 133.586C396.367 134.367 396.367 135.633 395.586 136.414L394.414 137.586C393.633 138.367 392.367 138.367 391.586 137.586L390.414 136.414C389.633 135.633 389.633 134.367 390.414 133.586L391.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M407.586 132.414C408.367 131.633 409.633 131.633 410.414 132.414L411.586 133.586C412.367 134.367 412.367 135.633 411.586 136.414L410.414 137.586C409.633 138.367 408.367 138.367 407.586 137.586L406.414 136.414C405.633 135.633 405.633 134.367 406.414 133.586L407.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M423.586 132.414C424.367 131.633 425.633 131.633 426.414 132.414L427.586 133.586C428.367 134.367 428.367 135.633 427.586 136.414L426.414 137.586C425.633 138.367 424.367 138.367 423.586 137.586L422.414 136.414C421.633 135.633 421.633 134.367 422.414 133.586L423.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M439.586 132.414C440.367 131.633 441.633 131.633 442.414 132.414L443.586 133.586C444.367 134.367 444.367 135.633 443.586 136.414L442.414 137.586C441.633 138.367 440.367 138.367 439.586 137.586L438.414 136.414C437.633 135.633 437.633 134.367 438.414 133.586L439.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.53"
            d="M455.586 132.414C456.367 131.633 457.633 131.633 458.414 132.414L459.586 133.586C460.367 134.367 460.367 135.633 459.586 136.414L458.414 137.586C457.633 138.367 456.367 138.367 455.586 137.586L454.414 136.414C453.633 135.633 453.633 134.367 454.414 133.586L455.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M471.586 132.414C472.367 131.633 473.633 131.633 474.414 132.414L475.586 133.586C476.367 134.367 476.367 135.633 475.586 136.414L474.414 137.586C473.633 138.367 472.367 138.367 471.586 137.586L470.414 136.414C469.633 135.633 469.633 134.367 470.414 133.586L471.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M487.586 132.414C488.367 131.633 489.633 131.633 490.414 132.414L491.586 133.586C492.367 134.367 492.367 135.633 491.586 136.414L490.414 137.586C489.633 138.367 488.367 138.367 487.586 137.586L486.414 136.414C485.633 135.633 485.633 134.367 486.414 133.586L487.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M503.586 132.414C504.367 131.633 505.633 131.633 506.414 132.414L507.586 133.586C508.367 134.367 508.367 135.633 507.586 136.414L506.414 137.586C505.633 138.367 504.367 138.367 503.586 137.586L502.414 136.414C501.633 135.633 501.633 134.367 502.414 133.586L503.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M519.586 132.414C520.367 131.633 521.633 131.633 522.414 132.414L523.586 133.586C524.367 134.367 524.367 135.633 523.586 136.414L522.414 137.586C521.633 138.367 520.367 138.367 519.586 137.586L518.414 136.414C517.633 135.633 517.633 134.367 518.414 133.586L519.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M535.586 132.414C536.367 131.633 537.633 131.633 538.414 132.414L539.586 133.586C540.367 134.367 540.367 135.633 539.586 136.414L538.414 137.586C537.633 138.367 536.367 138.367 535.586 137.586L534.414 136.414C533.633 135.633 533.633 134.367 534.414 133.586L535.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M551.586 132.414C552.367 131.633 553.633 131.633 554.414 132.414L555.586 133.586C556.367 134.367 556.367 135.633 555.586 136.414L554.414 137.586C553.633 138.367 552.367 138.367 551.586 137.586L550.414 136.414C549.633 135.633 549.633 134.367 550.414 133.586L551.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M567.586 132.414C568.367 131.633 569.633 131.633 570.414 132.414L571.586 133.586C572.367 134.367 572.367 135.633 571.586 136.414L570.414 137.586C569.633 138.367 568.367 138.367 567.586 137.586L566.414 136.414C565.633 135.633 565.633 134.367 566.414 133.586L567.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M583.586 132.414C584.367 131.633 585.633 131.633 586.414 132.414L587.586 133.586C588.367 134.367 588.367 135.633 587.586 136.414L586.414 137.586C585.633 138.367 584.367 138.367 583.586 137.586L582.414 136.414C581.633 135.633 581.633 134.367 582.414 133.586L583.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M599.586 132.414C600.367 131.633 601.633 131.633 602.414 132.414L603.586 133.586C604.367 134.367 604.367 135.633 603.586 136.414L602.414 137.586C601.633 138.367 600.367 138.367 599.586 137.586L598.414 136.414C597.633 135.633 597.633 134.367 598.414 133.586L599.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M615.586 132.414C616.367 131.633 617.633 131.633 618.414 132.414L619.586 133.586C620.367 134.367 620.367 135.633 619.586 136.414L618.414 137.586C617.633 138.367 616.367 138.367 615.586 137.586L614.414 136.414C613.633 135.633 613.633 134.367 614.414 133.586L615.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.26"
            d="M631.586 132.414C632.367 131.633 633.633 131.633 634.414 132.414L635.586 133.586C636.367 134.367 636.367 135.633 635.586 136.414L634.414 137.586C633.633 138.367 632.367 138.367 631.586 137.586L630.414 136.414C629.633 135.633 629.633 134.367 630.414 133.586L631.586 132.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M7.58579 148.414C8.36684 147.633 9.63317 147.633 10.4142 148.414L11.5858 149.586C12.3668 150.367 12.3668 151.633 11.5858 152.414L10.4142 153.586C9.63316 154.367 8.36683 154.367 7.58579 153.586L6.41421 152.414C5.63316 151.633 5.63317 150.367 6.41421 149.586L7.58579 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M23.5858 148.414C24.3668 147.633 25.6332 147.633 26.4142 148.414L27.5858 149.586C28.3668 150.367 28.3668 151.633 27.5858 152.414L26.4142 153.586C25.6332 154.367 24.3668 154.367 23.5858 153.586L22.4142 152.414C21.6332 151.633 21.6332 150.367 22.4142 149.586L23.5858 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M39.5858 148.414C40.3668 147.633 41.6332 147.633 42.4142 148.414L43.5858 149.586C44.3668 150.367 44.3668 151.633 43.5858 152.414L42.4142 153.586C41.6332 154.367 40.3668 154.367 39.5858 153.586L38.4142 152.414C37.6332 151.633 37.6332 150.367 38.4142 149.586L39.5858 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.85"
            d="M55.5858 148.414C56.3668 147.633 57.6332 147.633 58.4142 148.414L59.5858 149.586C60.3668 150.367 60.3668 151.633 59.5858 152.414L58.4142 153.586C57.6332 154.367 56.3668 154.367 55.5858 153.586L54.4142 152.414C53.6332 151.633 53.6332 150.367 54.4142 149.586L55.5858 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M71.5858 148.414C72.3668 147.633 73.6332 147.633 74.4142 148.414L75.5858 149.586C76.3668 150.367 76.3668 151.633 75.5858 152.414L74.4142 153.586C73.6332 154.367 72.3668 154.367 71.5858 153.586L70.4142 152.414C69.6332 151.633 69.6332 150.367 70.4142 149.586L71.5858 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M87.5858 148.414C88.3668 147.633 89.6332 147.633 90.4142 148.414L91.5858 149.586C92.3668 150.367 92.3668 151.633 91.5858 152.414L90.4142 153.586C89.6332 154.367 88.3668 154.367 87.5858 153.586L86.4142 152.414C85.6332 151.633 85.6332 150.367 86.4142 149.586L87.5858 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M103.586 148.414C104.367 147.633 105.633 147.633 106.414 148.414L107.586 149.586C108.367 150.367 108.367 151.633 107.586 152.414L106.414 153.586C105.633 154.367 104.367 154.367 103.586 153.586L102.414 152.414C101.633 151.633 101.633 150.367 102.414 149.586L103.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M119.586 148.414C120.367 147.633 121.633 147.633 122.414 148.414L123.586 149.586C124.367 150.367 124.367 151.633 123.586 152.414L122.414 153.586C121.633 154.367 120.367 154.367 119.586 153.586L118.414 152.414C117.633 151.633 117.633 150.367 118.414 149.586L119.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M135.586 148.414C136.367 147.633 137.633 147.633 138.414 148.414L139.586 149.586C140.367 150.367 140.367 151.633 139.586 152.414L138.414 153.586C137.633 154.367 136.367 154.367 135.586 153.586L134.414 152.414C133.633 151.633 133.633 150.367 134.414 149.586L135.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M151.586 148.414C152.367 147.633 153.633 147.633 154.414 148.414L155.586 149.586C156.367 150.367 156.367 151.633 155.586 152.414L154.414 153.586C153.633 154.367 152.367 154.367 151.586 153.586L150.414 152.414C149.633 151.633 149.633 150.367 150.414 149.586L151.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M167.586 148.414C168.367 147.633 169.633 147.633 170.414 148.414L171.586 149.586C172.367 150.367 172.367 151.633 171.586 152.414L170.414 153.586C169.633 154.367 168.367 154.367 167.586 153.586L166.414 152.414C165.633 151.633 165.633 150.367 166.414 149.586L167.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M183.586 148.414C184.367 147.633 185.633 147.633 186.414 148.414L187.586 149.586C188.367 150.367 188.367 151.633 187.586 152.414L186.414 153.586C185.633 154.367 184.367 154.367 183.586 153.586L182.414 152.414C181.633 151.633 181.633 150.367 182.414 149.586L183.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M199.586 148.414C200.367 147.633 201.633 147.633 202.414 148.414L203.586 149.586C204.367 150.367 204.367 151.633 203.586 152.414L202.414 153.586C201.633 154.367 200.367 154.367 199.586 153.586L198.414 152.414C197.633 151.633 197.633 150.367 198.414 149.586L199.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M215.586 148.414C216.367 147.633 217.633 147.633 218.414 148.414L219.586 149.586C220.367 150.367 220.367 151.633 219.586 152.414L218.414 153.586C217.633 154.367 216.367 154.367 215.586 153.586L214.414 152.414C213.633 151.633 213.633 150.367 214.414 149.586L215.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M231.586 148.414C232.367 147.633 233.633 147.633 234.414 148.414L235.586 149.586C236.367 150.367 236.367 151.633 235.586 152.414L234.414 153.586C233.633 154.367 232.367 154.367 231.586 153.586L230.414 152.414C229.633 151.633 229.633 150.367 230.414 149.586L231.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.16"
            d="M247.586 148.414C248.367 147.633 249.633 147.633 250.414 148.414L251.586 149.586C252.367 150.367 252.367 151.633 251.586 152.414L250.414 153.586C249.633 154.367 248.367 154.367 247.586 153.586L246.414 152.414C245.633 151.633 245.633 150.367 246.414 149.586L247.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M263.586 148.414C264.367 147.633 265.633 147.633 266.414 148.414L267.586 149.586C268.367 150.367 268.367 151.633 267.586 152.414L266.414 153.586C265.633 154.367 264.367 154.367 263.586 153.586L262.414 152.414C261.633 151.633 261.633 150.367 262.414 149.586L263.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M279.586 148.414C280.367 147.633 281.633 147.633 282.414 148.414L283.586 149.586C284.367 150.367 284.367 151.633 283.586 152.414L282.414 153.586C281.633 154.367 280.367 154.367 279.586 153.586L278.414 152.414C277.633 151.633 277.633 150.367 278.414 149.586L279.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M295.586 148.414C296.367 147.633 297.633 147.633 298.414 148.414L299.586 149.586C300.367 150.367 300.367 151.633 299.586 152.414L298.414 153.586C297.633 154.367 296.367 154.367 295.586 153.586L294.414 152.414C293.633 151.633 293.633 150.367 294.414 149.586L295.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M311.586 148.414C312.367 147.633 313.633 147.633 314.414 148.414L315.586 149.586C316.367 150.367 316.367 151.633 315.586 152.414L314.414 153.586C313.633 154.367 312.367 154.367 311.586 153.586L310.414 152.414C309.633 151.633 309.633 150.367 310.414 149.586L311.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M327.586 148.414C328.367 147.633 329.633 147.633 330.414 148.414L331.586 149.586C332.367 150.367 332.367 151.633 331.586 152.414L330.414 153.586C329.633 154.367 328.367 154.367 327.586 153.586L326.414 152.414C325.633 151.633 325.633 150.367 326.414 149.586L327.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M343.586 148.414C344.367 147.633 345.633 147.633 346.414 148.414L347.586 149.586C348.367 150.367 348.367 151.633 347.586 152.414L346.414 153.586C345.633 154.367 344.367 154.367 343.586 153.586L342.414 152.414C341.633 151.633 341.633 150.367 342.414 149.586L343.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M359.586 148.414C360.367 147.633 361.633 147.633 362.414 148.414L363.586 149.586C364.367 150.367 364.367 151.633 363.586 152.414L362.414 153.586C361.633 154.367 360.367 154.367 359.586 153.586L358.414 152.414C357.633 151.633 357.633 150.367 358.414 149.586L359.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.63"
            d="M375.586 148.414C376.367 147.633 377.633 147.633 378.414 148.414L379.586 149.586C380.367 150.367 380.367 151.633 379.586 152.414L378.414 153.586C377.633 154.367 376.367 154.367 375.586 153.586L374.414 152.414C373.633 151.633 373.633 150.367 374.414 149.586L375.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M391.586 148.414C392.367 147.633 393.633 147.633 394.414 148.414L395.586 149.586C396.367 150.367 396.367 151.633 395.586 152.414L394.414 153.586C393.633 154.367 392.367 154.367 391.586 153.586L390.414 152.414C389.633 151.633 389.633 150.367 390.414 149.586L391.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M407.586 148.414C408.367 147.633 409.633 147.633 410.414 148.414L411.586 149.586C412.367 150.367 412.367 151.633 411.586 152.414L410.414 153.586C409.633 154.367 408.367 154.367 407.586 153.586L406.414 152.414C405.633 151.633 405.633 150.367 406.414 149.586L407.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M423.586 148.414C424.367 147.633 425.633 147.633 426.414 148.414L427.586 149.586C428.367 150.367 428.367 151.633 427.586 152.414L426.414 153.586C425.633 154.367 424.367 154.367 423.586 153.586L422.414 152.414C421.633 151.633 421.633 150.367 422.414 149.586L423.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M439.586 148.414C440.367 147.633 441.633 147.633 442.414 148.414L443.586 149.586C444.367 150.367 444.367 151.633 443.586 152.414L442.414 153.586C441.633 154.367 440.367 154.367 439.586 153.586L438.414 152.414C437.633 151.633 437.633 150.367 438.414 149.586L439.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M455.586 148.414C456.367 147.633 457.633 147.633 458.414 148.414L459.586 149.586C460.367 150.367 460.367 151.633 459.586 152.414L458.414 153.586C457.633 154.367 456.367 154.367 455.586 153.586L454.414 152.414C453.633 151.633 453.633 150.367 454.414 149.586L455.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M471.586 148.414C472.367 147.633 473.633 147.633 474.414 148.414L475.586 149.586C476.367 150.367 476.367 151.633 475.586 152.414L474.414 153.586C473.633 154.367 472.367 154.367 471.586 153.586L470.414 152.414C469.633 151.633 469.633 150.367 470.414 149.586L471.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M487.586 148.414C488.367 147.633 489.633 147.633 490.414 148.414L491.586 149.586C492.367 150.367 492.367 151.633 491.586 152.414L490.414 153.586C489.633 154.367 488.367 154.367 487.586 153.586L486.414 152.414C485.633 151.633 485.633 150.367 486.414 149.586L487.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M503.586 148.414C504.367 147.633 505.633 147.633 506.414 148.414L507.586 149.586C508.367 150.367 508.367 151.633 507.586 152.414L506.414 153.586C505.633 154.367 504.367 154.367 503.586 153.586L502.414 152.414C501.633 151.633 501.633 150.367 502.414 149.586L503.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M519.586 148.414C520.367 147.633 521.633 147.633 522.414 148.414L523.586 149.586C524.367 150.367 524.367 151.633 523.586 152.414L522.414 153.586C521.633 154.367 520.367 154.367 519.586 153.586L518.414 152.414C517.633 151.633 517.633 150.367 518.414 149.586L519.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M535.586 148.414C536.367 147.633 537.633 147.633 538.414 148.414L539.586 149.586C540.367 150.367 540.367 151.633 539.586 152.414L538.414 153.586C537.633 154.367 536.367 154.367 535.586 153.586L534.414 152.414C533.633 151.633 533.633 150.367 534.414 149.586L535.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M551.586 148.414C552.367 147.633 553.633 147.633 554.414 148.414L555.586 149.586C556.367 150.367 556.367 151.633 555.586 152.414L554.414 153.586C553.633 154.367 552.367 154.367 551.586 153.586L550.414 152.414C549.633 151.633 549.633 150.367 550.414 149.586L551.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M567.586 148.414C568.367 147.633 569.633 147.633 570.414 148.414L571.586 149.586C572.367 150.367 572.367 151.633 571.586 152.414L570.414 153.586C569.633 154.367 568.367 154.367 567.586 153.586L566.414 152.414C565.633 151.633 565.633 150.367 566.414 149.586L567.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M583.586 148.414C584.367 147.633 585.633 147.633 586.414 148.414L587.586 149.586C588.367 150.367 588.367 151.633 587.586 152.414L586.414 153.586C585.633 154.367 584.367 154.367 583.586 153.586L582.414 152.414C581.633 151.633 581.633 150.367 582.414 149.586L583.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M599.586 148.414C600.367 147.633 601.633 147.633 602.414 148.414L603.586 149.586C604.367 150.367 604.367 151.633 603.586 152.414L602.414 153.586C601.633 154.367 600.367 154.367 599.586 153.586L598.414 152.414C597.633 151.633 597.633 150.367 598.414 149.586L599.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M615.586 148.414C616.367 147.633 617.633 147.633 618.414 148.414L619.586 149.586C620.367 150.367 620.367 151.633 619.586 152.414L618.414 153.586C617.633 154.367 616.367 154.367 615.586 153.586L614.414 152.414C613.633 151.633 613.633 150.367 614.414 149.586L615.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M631.586 148.414C632.367 147.633 633.633 147.633 634.414 148.414L635.586 149.586C636.367 150.367 636.367 151.633 635.586 152.414L634.414 153.586C633.633 154.367 632.367 154.367 631.586 153.586L630.414 152.414C629.633 151.633 629.633 150.367 630.414 149.586L631.586 148.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M7.58579 164.414C8.36684 163.633 9.63317 163.633 10.4142 164.414L11.5858 165.586C12.3668 166.367 12.3668 167.633 11.5858 168.414L10.4142 169.586C9.63316 170.367 8.36683 170.367 7.58579 169.586L6.41421 168.414C5.63316 167.633 5.63317 166.367 6.41421 165.586L7.58579 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.26"
            d="M23.5858 164.414C24.3668 163.633 25.6332 163.633 26.4142 164.414L27.5858 165.586C28.3668 166.367 28.3668 167.633 27.5858 168.414L26.4142 169.586C25.6332 170.367 24.3668 170.367 23.5858 169.586L22.4142 168.414C21.6332 167.633 21.6332 166.367 22.4142 165.586L23.5858 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M39.5858 164.414C40.3668 163.633 41.6332 163.633 42.4142 164.414L43.5858 165.586C44.3668 166.367 44.3668 167.633 43.5858 168.414L42.4142 169.586C41.6332 170.367 40.3668 170.367 39.5858 169.586L38.4142 168.414C37.6332 167.633 37.6332 166.367 38.4142 165.586L39.5858 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M55.5858 164.414C56.3668 163.633 57.6332 163.633 58.4142 164.414L59.5858 165.586C60.3668 166.367 60.3668 167.633 59.5858 168.414L58.4142 169.586C57.6332 170.367 56.3668 170.367 55.5858 169.586L54.4142 168.414C53.6332 167.633 53.6332 166.367 54.4142 165.586L55.5858 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M71.5858 164.414C72.3668 163.633 73.6332 163.633 74.4142 164.414L75.5858 165.586C76.3668 166.367 76.3668 167.633 75.5858 168.414L74.4142 169.586C73.6332 170.367 72.3668 170.367 71.5858 169.586L70.4142 168.414C69.6332 167.633 69.6332 166.367 70.4142 165.586L71.5858 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M87.5858 164.414C88.3668 163.633 89.6332 163.633 90.4142 164.414L91.5858 165.586C92.3668 166.367 92.3668 167.633 91.5858 168.414L90.4142 169.586C89.6332 170.367 88.3668 170.367 87.5858 169.586L86.4142 168.414C85.6332 167.633 85.6332 166.367 86.4142 165.586L87.5858 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M103.586 164.414C104.367 163.633 105.633 163.633 106.414 164.414L107.586 165.586C108.367 166.367 108.367 167.633 107.586 168.414L106.414 169.586C105.633 170.367 104.367 170.367 103.586 169.586L102.414 168.414C101.633 167.633 101.633 166.367 102.414 165.586L103.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M119.586 164.414C120.367 163.633 121.633 163.633 122.414 164.414L123.586 165.586C124.367 166.367 124.367 167.633 123.586 168.414L122.414 169.586C121.633 170.367 120.367 170.367 119.586 169.586L118.414 168.414C117.633 167.633 117.633 166.367 118.414 165.586L119.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.58"
            d="M135.586 164.414C136.367 163.633 137.633 163.633 138.414 164.414L139.586 165.586C140.367 166.367 140.367 167.633 139.586 168.414L138.414 169.586C137.633 170.367 136.367 170.367 135.586 169.586L134.414 168.414C133.633 167.633 133.633 166.367 134.414 165.586L135.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M151.586 164.414C152.367 163.633 153.633 163.633 154.414 164.414L155.586 165.586C156.367 166.367 156.367 167.633 155.586 168.414L154.414 169.586C153.633 170.367 152.367 170.367 151.586 169.586L150.414 168.414C149.633 167.633 149.633 166.367 150.414 165.586L151.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M167.586 164.414C168.367 163.633 169.633 163.633 170.414 164.414L171.586 165.586C172.367 166.367 172.367 167.633 171.586 168.414L170.414 169.586C169.633 170.367 168.367 170.367 167.586 169.586L166.414 168.414C165.633 167.633 165.633 166.367 166.414 165.586L167.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M183.586 164.414C184.367 163.633 185.633 163.633 186.414 164.414L187.586 165.586C188.367 166.367 188.367 167.633 187.586 168.414L186.414 169.586C185.633 170.367 184.367 170.367 183.586 169.586L182.414 168.414C181.633 167.633 181.633 166.367 182.414 165.586L183.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M199.586 164.414C200.367 163.633 201.633 163.633 202.414 164.414L203.586 165.586C204.367 166.367 204.367 167.633 203.586 168.414L202.414 169.586C201.633 170.367 200.367 170.367 199.586 169.586L198.414 168.414C197.633 167.633 197.633 166.367 198.414 165.586L199.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M215.586 164.414C216.367 163.633 217.633 163.633 218.414 164.414L219.586 165.586C220.367 166.367 220.367 167.633 219.586 168.414L218.414 169.586C217.633 170.367 216.367 170.367 215.586 169.586L214.414 168.414C213.633 167.633 213.633 166.367 214.414 165.586L215.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.2"
            d="M231.586 164.414C232.367 163.633 233.633 163.633 234.414 164.414L235.586 165.586C236.367 166.367 236.367 167.633 235.586 168.414L234.414 169.586C233.633 170.367 232.367 170.367 231.586 169.586L230.414 168.414C229.633 167.633 229.633 166.367 230.414 165.586L231.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.48"
            d="M247.586 164.414C248.367 163.633 249.633 163.633 250.414 164.414L251.586 165.586C252.367 166.367 252.367 167.633 251.586 168.414L250.414 169.586C249.633 170.367 248.367 170.367 247.586 169.586L246.414 168.414C245.633 167.633 245.633 166.367 246.414 165.586L247.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M263.586 164.414C264.367 163.633 265.633 163.633 266.414 164.414L267.586 165.586C268.367 166.367 268.367 167.633 267.586 168.414L266.414 169.586C265.633 170.367 264.367 170.367 263.586 169.586L262.414 168.414C261.633 167.633 261.633 166.367 262.414 165.586L263.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M279.586 164.414C280.367 163.633 281.633 163.633 282.414 164.414L283.586 165.586C284.367 166.367 284.367 167.633 283.586 168.414L282.414 169.586C281.633 170.367 280.367 170.367 279.586 169.586L278.414 168.414C277.633 167.633 277.633 166.367 278.414 165.586L279.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M295.586 164.414C296.367 163.633 297.633 163.633 298.414 164.414L299.586 165.586C300.367 166.367 300.367 167.633 299.586 168.414L298.414 169.586C297.633 170.367 296.367 170.367 295.586 169.586L294.414 168.414C293.633 167.633 293.633 166.367 294.414 165.586L295.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M311.586 164.414C312.367 163.633 313.633 163.633 314.414 164.414L315.586 165.586C316.367 166.367 316.367 167.633 315.586 168.414L314.414 169.586C313.633 170.367 312.367 170.367 311.586 169.586L310.414 168.414C309.633 167.633 309.633 166.367 310.414 165.586L311.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M327.586 164.414C328.367 163.633 329.633 163.633 330.414 164.414L331.586 165.586C332.367 166.367 332.367 167.633 331.586 168.414L330.414 169.586C329.633 170.367 328.367 170.367 327.586 169.586L326.414 168.414C325.633 167.633 325.633 166.367 326.414 165.586L327.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M343.586 164.414C344.367 163.633 345.633 163.633 346.414 164.414L347.586 165.586C348.367 166.367 348.367 167.633 347.586 168.414L346.414 169.586C345.633 170.367 344.367 170.367 343.586 169.586L342.414 168.414C341.633 167.633 341.633 166.367 342.414 165.586L343.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M359.586 164.414C360.367 163.633 361.633 163.633 362.414 164.414L363.586 165.586C364.367 166.367 364.367 167.633 363.586 168.414L362.414 169.586C361.633 170.367 360.367 170.367 359.586 169.586L358.414 168.414C357.633 167.633 357.633 166.367 358.414 165.586L359.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M375.586 164.414C376.367 163.633 377.633 163.633 378.414 164.414L379.586 165.586C380.367 166.367 380.367 167.633 379.586 168.414L378.414 169.586C377.633 170.367 376.367 170.367 375.586 169.586L374.414 168.414C373.633 167.633 373.633 166.367 374.414 165.586L375.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M391.586 164.414C392.367 163.633 393.633 163.633 394.414 164.414L395.586 165.586C396.367 166.367 396.367 167.633 395.586 168.414L394.414 169.586C393.633 170.367 392.367 170.367 391.586 169.586L390.414 168.414C389.633 167.633 389.633 166.367 390.414 165.586L391.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M407.586 164.414C408.367 163.633 409.633 163.633 410.414 164.414L411.586 165.586C412.367 166.367 412.367 167.633 411.586 168.414L410.414 169.586C409.633 170.367 408.367 170.367 407.586 169.586L406.414 168.414C405.633 167.633 405.633 166.367 406.414 165.586L407.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M423.586 164.414C424.367 163.633 425.633 163.633 426.414 164.414L427.586 165.586C428.367 166.367 428.367 167.633 427.586 168.414L426.414 169.586C425.633 170.367 424.367 170.367 423.586 169.586L422.414 168.414C421.633 167.633 421.633 166.367 422.414 165.586L423.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M439.586 164.414C440.367 163.633 441.633 163.633 442.414 164.414L443.586 165.586C444.367 166.367 444.367 167.633 443.586 168.414L442.414 169.586C441.633 170.367 440.367 170.367 439.586 169.586L438.414 168.414C437.633 167.633 437.633 166.367 438.414 165.586L439.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.2"
            d="M455.586 164.414C456.367 163.633 457.633 163.633 458.414 164.414L459.586 165.586C460.367 166.367 460.367 167.633 459.586 168.414L458.414 169.586C457.633 170.367 456.367 170.367 455.586 169.586L454.414 168.414C453.633 167.633 453.633 166.367 454.414 165.586L455.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M471.586 164.414C472.367 163.633 473.633 163.633 474.414 164.414L475.586 165.586C476.367 166.367 476.367 167.633 475.586 168.414L474.414 169.586C473.633 170.367 472.367 170.367 471.586 169.586L470.414 168.414C469.633 167.633 469.633 166.367 470.414 165.586L471.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.8"
            d="M487.586 164.414C488.367 163.633 489.633 163.633 490.414 164.414L491.586 165.586C492.367 166.367 492.367 167.633 491.586 168.414L490.414 169.586C489.633 170.367 488.367 170.367 487.586 169.586L486.414 168.414C485.633 167.633 485.633 166.367 486.414 165.586L487.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M503.586 164.414C504.367 163.633 505.633 163.633 506.414 164.414L507.586 165.586C508.367 166.367 508.367 167.633 507.586 168.414L506.414 169.586C505.633 170.367 504.367 170.367 503.586 169.586L502.414 168.414C501.633 167.633 501.633 166.367 502.414 165.586L503.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M519.586 164.414C520.367 163.633 521.633 163.633 522.414 164.414L523.586 165.586C524.367 166.367 524.367 167.633 523.586 168.414L522.414 169.586C521.633 170.367 520.367 170.367 519.586 169.586L518.414 168.414C517.633 167.633 517.633 166.367 518.414 165.586L519.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M535.586 164.414C536.367 163.633 537.633 163.633 538.414 164.414L539.586 165.586C540.367 166.367 540.367 167.633 539.586 168.414L538.414 169.586C537.633 170.367 536.367 170.367 535.586 169.586L534.414 168.414C533.633 167.633 533.633 166.367 534.414 165.586L535.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M551.586 164.414C552.367 163.633 553.633 163.633 554.414 164.414L555.586 165.586C556.367 166.367 556.367 167.633 555.586 168.414L554.414 169.586C553.633 170.367 552.367 170.367 551.586 169.586L550.414 168.414C549.633 167.633 549.633 166.367 550.414 165.586L551.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M567.586 164.414C568.367 163.633 569.633 163.633 570.414 164.414L571.586 165.586C572.367 166.367 572.367 167.633 571.586 168.414L570.414 169.586C569.633 170.367 568.367 170.367 567.586 169.586L566.414 168.414C565.633 167.633 565.633 166.367 566.414 165.586L567.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M583.586 164.414C584.367 163.633 585.633 163.633 586.414 164.414L587.586 165.586C588.367 166.367 588.367 167.633 587.586 168.414L586.414 169.586C585.633 170.367 584.367 170.367 583.586 169.586L582.414 168.414C581.633 167.633 581.633 166.367 582.414 165.586L583.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.58"
            d="M599.586 164.414C600.367 163.633 601.633 163.633 602.414 164.414L603.586 165.586C604.367 166.367 604.367 167.633 603.586 168.414L602.414 169.586C601.633 170.367 600.367 170.367 599.586 169.586L598.414 168.414C597.633 167.633 597.633 166.367 598.414 165.586L599.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M615.586 164.414C616.367 163.633 617.633 163.633 618.414 164.414L619.586 165.586C620.367 166.367 620.367 167.633 619.586 168.414L618.414 169.586C617.633 170.367 616.367 170.367 615.586 169.586L614.414 168.414C613.633 167.633 613.633 166.367 614.414 165.586L615.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M631.586 164.414C632.367 163.633 633.633 163.633 634.414 164.414L635.586 165.586C636.367 166.367 636.367 167.633 635.586 168.414L634.414 169.586C633.633 170.367 632.367 170.367 631.586 169.586L630.414 168.414C629.633 167.633 629.633 166.367 630.414 165.586L631.586 164.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M7.58579 180.414C8.36684 179.633 9.63317 179.633 10.4142 180.414L11.5858 181.586C12.3668 182.367 12.3668 183.633 11.5858 184.414L10.4142 185.586C9.63316 186.367 8.36683 186.367 7.58579 185.586L6.41421 184.414C5.63316 183.633 5.63317 182.367 6.41421 181.586L7.58579 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M23.5858 180.414C24.3668 179.633 25.6332 179.633 26.4142 180.414L27.5858 181.586C28.3668 182.367 28.3668 183.633 27.5858 184.414L26.4142 185.586C25.6332 186.367 24.3668 186.367 23.5858 185.586L22.4142 184.414C21.6332 183.633 21.6332 182.367 22.4142 181.586L23.5858 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M39.5858 180.414C40.3668 179.633 41.6332 179.633 42.4142 180.414L43.5858 181.586C44.3668 182.367 44.3668 183.633 43.5858 184.414L42.4142 185.586C41.6332 186.367 40.3668 186.367 39.5858 185.586L38.4142 184.414C37.6332 183.633 37.6332 182.367 38.4142 181.586L39.5858 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.62"
            d="M55.5858 180.414C56.3668 179.633 57.6332 179.633 58.4142 180.414L59.5858 181.586C60.3668 182.367 60.3668 183.633 59.5858 184.414L58.4142 185.586C57.6332 186.367 56.3668 186.367 55.5858 185.586L54.4142 184.414C53.6332 183.633 53.6332 182.367 54.4142 181.586L55.5858 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.12"
            d="M71.5858 180.414C72.3668 179.633 73.6332 179.633 74.4142 180.414L75.5858 181.586C76.3668 182.367 76.3668 183.633 75.5858 184.414L74.4142 185.586C73.6332 186.367 72.3668 186.367 71.5858 185.586L70.4142 184.414C69.6332 183.633 69.6332 182.367 70.4142 181.586L71.5858 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M87.5858 180.414C88.3668 179.633 89.6332 179.633 90.4142 180.414L91.5858 181.586C92.3668 182.367 92.3668 183.633 91.5858 184.414L90.4142 185.586C89.6332 186.367 88.3668 186.367 87.5858 185.586L86.4142 184.414C85.6332 183.633 85.6332 182.367 86.4142 181.586L87.5858 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.63"
            d="M103.586 180.414C104.367 179.633 105.633 179.633 106.414 180.414L107.586 181.586C108.367 182.367 108.367 183.633 107.586 184.414L106.414 185.586C105.633 186.367 104.367 186.367 103.586 185.586L102.414 184.414C101.633 183.633 101.633 182.367 102.414 181.586L103.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M119.586 180.414C120.367 179.633 121.633 179.633 122.414 180.414L123.586 181.586C124.367 182.367 124.367 183.633 123.586 184.414L122.414 185.586C121.633 186.367 120.367 186.367 119.586 185.586L118.414 184.414C117.633 183.633 117.633 182.367 118.414 181.586L119.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M135.586 180.414C136.367 179.633 137.633 179.633 138.414 180.414L139.586 181.586C140.367 182.367 140.367 183.633 139.586 184.414L138.414 185.586C137.633 186.367 136.367 186.367 135.586 185.586L134.414 184.414C133.633 183.633 133.633 182.367 134.414 181.586L135.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M151.586 180.414C152.367 179.633 153.633 179.633 154.414 180.414L155.586 181.586C156.367 182.367 156.367 183.633 155.586 184.414L154.414 185.586C153.633 186.367 152.367 186.367 151.586 185.586L150.414 184.414C149.633 183.633 149.633 182.367 150.414 181.586L151.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M167.586 180.414C168.367 179.633 169.633 179.633 170.414 180.414L171.586 181.586C172.367 182.367 172.367 183.633 171.586 184.414L170.414 185.586C169.633 186.367 168.367 186.367 167.586 185.586L166.414 184.414C165.633 183.633 165.633 182.367 166.414 181.586L167.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M183.586 180.414C184.367 179.633 185.633 179.633 186.414 180.414L187.586 181.586C188.367 182.367 188.367 183.633 187.586 184.414L186.414 185.586C185.633 186.367 184.367 186.367 183.586 185.586L182.414 184.414C181.633 183.633 181.633 182.367 182.414 181.586L183.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.8"
            d="M199.586 180.414C200.367 179.633 201.633 179.633 202.414 180.414L203.586 181.586C204.367 182.367 204.367 183.633 203.586 184.414L202.414 185.586C201.633 186.367 200.367 186.367 199.586 185.586L198.414 184.414C197.633 183.633 197.633 182.367 198.414 181.586L199.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M215.586 180.414C216.367 179.633 217.633 179.633 218.414 180.414L219.586 181.586C220.367 182.367 220.367 183.633 219.586 184.414L218.414 185.586C217.633 186.367 216.367 186.367 215.586 185.586L214.414 184.414C213.633 183.633 213.633 182.367 214.414 181.586L215.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M231.586 180.414C232.367 179.633 233.633 179.633 234.414 180.414L235.586 181.586C236.367 182.367 236.367 183.633 235.586 184.414L234.414 185.586C233.633 186.367 232.367 186.367 231.586 185.586L230.414 184.414C229.633 183.633 229.633 182.367 230.414 181.586L231.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M247.586 180.414C248.367 179.633 249.633 179.633 250.414 180.414L251.586 181.586C252.367 182.367 252.367 183.633 251.586 184.414L250.414 185.586C249.633 186.367 248.367 186.367 247.586 185.586L246.414 184.414C245.633 183.633 245.633 182.367 246.414 181.586L247.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.11"
            d="M263.586 180.414C264.367 179.633 265.633 179.633 266.414 180.414L267.586 181.586C268.367 182.367 268.367 183.633 267.586 184.414L266.414 185.586C265.633 186.367 264.367 186.367 263.586 185.586L262.414 184.414C261.633 183.633 261.633 182.367 262.414 181.586L263.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M279.586 180.414C280.367 179.633 281.633 179.633 282.414 180.414L283.586 181.586C284.367 182.367 284.367 183.633 283.586 184.414L282.414 185.586C281.633 186.367 280.367 186.367 279.586 185.586L278.414 184.414C277.633 183.633 277.633 182.367 278.414 181.586L279.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.11"
            d="M295.586 180.414C296.367 179.633 297.633 179.633 298.414 180.414L299.586 181.586C300.367 182.367 300.367 183.633 299.586 184.414L298.414 185.586C297.633 186.367 296.367 186.367 295.586 185.586L294.414 184.414C293.633 183.633 293.633 182.367 294.414 181.586L295.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M311.586 180.414C312.367 179.633 313.633 179.633 314.414 180.414L315.586 181.586C316.367 182.367 316.367 183.633 315.586 184.414L314.414 185.586C313.633 186.367 312.367 186.367 311.586 185.586L310.414 184.414C309.633 183.633 309.633 182.367 310.414 181.586L311.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.17"
            d="M327.586 180.414C328.367 179.633 329.633 179.633 330.414 180.414L331.586 181.586C332.367 182.367 332.367 183.633 331.586 184.414L330.414 185.586C329.633 186.367 328.367 186.367 327.586 185.586L326.414 184.414C325.633 183.633 325.633 182.367 326.414 181.586L327.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.74"
            d="M343.586 180.414C344.367 179.633 345.633 179.633 346.414 180.414L347.586 181.586C348.367 182.367 348.367 183.633 347.586 184.414L346.414 185.586C345.633 186.367 344.367 186.367 343.586 185.586L342.414 184.414C341.633 183.633 341.633 182.367 342.414 181.586L343.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M359.586 180.414C360.367 179.633 361.633 179.633 362.414 180.414L363.586 181.586C364.367 182.367 364.367 183.633 363.586 184.414L362.414 185.586C361.633 186.367 360.367 186.367 359.586 185.586L358.414 184.414C357.633 183.633 357.633 182.367 358.414 181.586L359.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M375.586 180.414C376.367 179.633 377.633 179.633 378.414 180.414L379.586 181.586C380.367 182.367 380.367 183.633 379.586 184.414L378.414 185.586C377.633 186.367 376.367 186.367 375.586 185.586L374.414 184.414C373.633 183.633 373.633 182.367 374.414 181.586L375.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M391.586 180.414C392.367 179.633 393.633 179.633 394.414 180.414L395.586 181.586C396.367 182.367 396.367 183.633 395.586 184.414L394.414 185.586C393.633 186.367 392.367 186.367 391.586 185.586L390.414 184.414C389.633 183.633 389.633 182.367 390.414 181.586L391.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M407.586 180.414C408.367 179.633 409.633 179.633 410.414 180.414L411.586 181.586C412.367 182.367 412.367 183.633 411.586 184.414L410.414 185.586C409.633 186.367 408.367 186.367 407.586 185.586L406.414 184.414C405.633 183.633 405.633 182.367 406.414 181.586L407.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.62"
            d="M423.586 180.414C424.367 179.633 425.633 179.633 426.414 180.414L427.586 181.586C428.367 182.367 428.367 183.633 427.586 184.414L426.414 185.586C425.633 186.367 424.367 186.367 423.586 185.586L422.414 184.414C421.633 183.633 421.633 182.367 422.414 181.586L423.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M439.586 180.414C440.367 179.633 441.633 179.633 442.414 180.414L443.586 181.586C444.367 182.367 444.367 183.633 443.586 184.414L442.414 185.586C441.633 186.367 440.367 186.367 439.586 185.586L438.414 184.414C437.633 183.633 437.633 182.367 438.414 181.586L439.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M455.586 180.414C456.367 179.633 457.633 179.633 458.414 180.414L459.586 181.586C460.367 182.367 460.367 183.633 459.586 184.414L458.414 185.586C457.633 186.367 456.367 186.367 455.586 185.586L454.414 184.414C453.633 183.633 453.633 182.367 454.414 181.586L455.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M471.586 180.414C472.367 179.633 473.633 179.633 474.414 180.414L475.586 181.586C476.367 182.367 476.367 183.633 475.586 184.414L474.414 185.586C473.633 186.367 472.367 186.367 471.586 185.586L470.414 184.414C469.633 183.633 469.633 182.367 470.414 181.586L471.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M487.586 180.414C488.367 179.633 489.633 179.633 490.414 180.414L491.586 181.586C492.367 182.367 492.367 183.633 491.586 184.414L490.414 185.586C489.633 186.367 488.367 186.367 487.586 185.586L486.414 184.414C485.633 183.633 485.633 182.367 486.414 181.586L487.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M503.586 180.414C504.367 179.633 505.633 179.633 506.414 180.414L507.586 181.586C508.367 182.367 508.367 183.633 507.586 184.414L506.414 185.586C505.633 186.367 504.367 186.367 503.586 185.586L502.414 184.414C501.633 183.633 501.633 182.367 502.414 181.586L503.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M519.586 180.414C520.367 179.633 521.633 179.633 522.414 180.414L523.586 181.586C524.367 182.367 524.367 183.633 523.586 184.414L522.414 185.586C521.633 186.367 520.367 186.367 519.586 185.586L518.414 184.414C517.633 183.633 517.633 182.367 518.414 181.586L519.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M535.586 180.414C536.367 179.633 537.633 179.633 538.414 180.414L539.586 181.586C540.367 182.367 540.367 183.633 539.586 184.414L538.414 185.586C537.633 186.367 536.367 186.367 535.586 185.586L534.414 184.414C533.633 183.633 533.633 182.367 534.414 181.586L535.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M551.586 180.414C552.367 179.633 553.633 179.633 554.414 180.414L555.586 181.586C556.367 182.367 556.367 183.633 555.586 184.414L554.414 185.586C553.633 186.367 552.367 186.367 551.586 185.586L550.414 184.414C549.633 183.633 549.633 182.367 550.414 181.586L551.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M567.586 180.414C568.367 179.633 569.633 179.633 570.414 180.414L571.586 181.586C572.367 182.367 572.367 183.633 571.586 184.414L570.414 185.586C569.633 186.367 568.367 186.367 567.586 185.586L566.414 184.414C565.633 183.633 565.633 182.367 566.414 181.586L567.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M583.586 180.414C584.367 179.633 585.633 179.633 586.414 180.414L587.586 181.586C588.367 182.367 588.367 183.633 587.586 184.414L586.414 185.586C585.633 186.367 584.367 186.367 583.586 185.586L582.414 184.414C581.633 183.633 581.633 182.367 582.414 181.586L583.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M599.586 180.414C600.367 179.633 601.633 179.633 602.414 180.414L603.586 181.586C604.367 182.367 604.367 183.633 603.586 184.414L602.414 185.586C601.633 186.367 600.367 186.367 599.586 185.586L598.414 184.414C597.633 183.633 597.633 182.367 598.414 181.586L599.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M615.586 180.414C616.367 179.633 617.633 179.633 618.414 180.414L619.586 181.586C620.367 182.367 620.367 183.633 619.586 184.414L618.414 185.586C617.633 186.367 616.367 186.367 615.586 185.586L614.414 184.414C613.633 183.633 613.633 182.367 614.414 181.586L615.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M631.586 180.414C632.367 179.633 633.633 179.633 634.414 180.414L635.586 181.586C636.367 182.367 636.367 183.633 635.586 184.414L634.414 185.586C633.633 186.367 632.367 186.367 631.586 185.586L630.414 184.414C629.633 183.633 629.633 182.367 630.414 181.586L631.586 180.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.93"
            d="M7.58579 196.414C8.36684 195.633 9.63317 195.633 10.4142 196.414L11.5858 197.586C12.3668 198.367 12.3668 199.633 11.5858 200.414L10.4142 201.586C9.63316 202.367 8.36683 202.367 7.58579 201.586L6.41421 200.414C5.63316 199.633 5.63317 198.367 6.41421 197.586L7.58579 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M23.5858 196.414C24.3668 195.633 25.6332 195.633 26.4142 196.414L27.5858 197.586C28.3668 198.367 28.3668 199.633 27.5858 200.414L26.4142 201.586C25.6332 202.367 24.3668 202.367 23.5858 201.586L22.4142 200.414C21.6332 199.633 21.6332 198.367 22.4142 197.586L23.5858 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M39.5858 196.414C40.3668 195.633 41.6332 195.633 42.4142 196.414L43.5858 197.586C44.3668 198.367 44.3668 199.633 43.5858 200.414L42.4142 201.586C41.6332 202.367 40.3668 202.367 39.5858 201.586L38.4142 200.414C37.6332 199.633 37.6332 198.367 38.4142 197.586L39.5858 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.44"
            d="M55.5858 196.414C56.3668 195.633 57.6332 195.633 58.4142 196.414L59.5858 197.586C60.3668 198.367 60.3668 199.633 59.5858 200.414L58.4142 201.586C57.6332 202.367 56.3668 202.367 55.5858 201.586L54.4142 200.414C53.6332 199.633 53.6332 198.367 54.4142 197.586L55.5858 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M71.5858 196.414C72.3668 195.633 73.6332 195.633 74.4142 196.414L75.5858 197.586C76.3668 198.367 76.3668 199.633 75.5858 200.414L74.4142 201.586C73.6332 202.367 72.3668 202.367 71.5858 201.586L70.4142 200.414C69.6332 199.633 69.6332 198.367 70.4142 197.586L71.5858 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M87.5858 196.414C88.3668 195.633 89.6332 195.633 90.4142 196.414L91.5858 197.586C92.3668 198.367 92.3668 199.633 91.5858 200.414L90.4142 201.586C89.6332 202.367 88.3668 202.367 87.5858 201.586L86.4142 200.414C85.6332 199.633 85.6332 198.367 86.4142 197.586L87.5858 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.82"
            d="M103.586 196.414C104.367 195.633 105.633 195.633 106.414 196.414L107.586 197.586C108.367 198.367 108.367 199.633 107.586 200.414L106.414 201.586C105.633 202.367 104.367 202.367 103.586 201.586L102.414 200.414C101.633 199.633 101.633 198.367 102.414 197.586L103.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.25"
            d="M119.586 196.414C120.367 195.633 121.633 195.633 122.414 196.414L123.586 197.586C124.367 198.367 124.367 199.633 123.586 200.414L122.414 201.586C121.633 202.367 120.367 202.367 119.586 201.586L118.414 200.414C117.633 199.633 117.633 198.367 118.414 197.586L119.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M135.586 196.414C136.367 195.633 137.633 195.633 138.414 196.414L139.586 197.586C140.367 198.367 140.367 199.633 139.586 200.414L138.414 201.586C137.633 202.367 136.367 202.367 135.586 201.586L134.414 200.414C133.633 199.633 133.633 198.367 134.414 197.586L135.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M151.586 196.414C152.367 195.633 153.633 195.633 154.414 196.414L155.586 197.586C156.367 198.367 156.367 199.633 155.586 200.414L154.414 201.586C153.633 202.367 152.367 202.367 151.586 201.586L150.414 200.414C149.633 199.633 149.633 198.367 150.414 197.586L151.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M167.586 196.414C168.367 195.633 169.633 195.633 170.414 196.414L171.586 197.586C172.367 198.367 172.367 199.633 171.586 200.414L170.414 201.586C169.633 202.367 168.367 202.367 167.586 201.586L166.414 200.414C165.633 199.633 165.633 198.367 166.414 197.586L167.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.55"
            d="M183.586 196.414C184.367 195.633 185.633 195.633 186.414 196.414L187.586 197.586C188.367 198.367 188.367 199.633 187.586 200.414L186.414 201.586C185.633 202.367 184.367 202.367 183.586 201.586L182.414 200.414C181.633 199.633 181.633 198.367 182.414 197.586L183.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.94"
            d="M199.586 196.414C200.367 195.633 201.633 195.633 202.414 196.414L203.586 197.586C204.367 198.367 204.367 199.633 203.586 200.414L202.414 201.586C201.633 202.367 200.367 202.367 199.586 201.586L198.414 200.414C197.633 199.633 197.633 198.367 198.414 197.586L199.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M215.586 196.414C216.367 195.633 217.633 195.633 218.414 196.414L219.586 197.586C220.367 198.367 220.367 199.633 219.586 200.414L218.414 201.586C217.633 202.367 216.367 202.367 215.586 201.586L214.414 200.414C213.633 199.633 213.633 198.367 214.414 197.586L215.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.21"
            d="M231.586 196.414C232.367 195.633 233.633 195.633 234.414 196.414L235.586 197.586C236.367 198.367 236.367 199.633 235.586 200.414L234.414 201.586C233.633 202.367 232.367 202.367 231.586 201.586L230.414 200.414C229.633 199.633 229.633 198.367 230.414 197.586L231.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.29"
            d="M247.586 196.414C248.367 195.633 249.633 195.633 250.414 196.414L251.586 197.586C252.367 198.367 252.367 199.633 251.586 200.414L250.414 201.586C249.633 202.367 248.367 202.367 247.586 201.586L246.414 200.414C245.633 199.633 245.633 198.367 246.414 197.586L247.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.19"
            d="M263.586 196.414C264.367 195.633 265.633 195.633 266.414 196.414L267.586 197.586C268.367 198.367 268.367 199.633 267.586 200.414L266.414 201.586C265.633 202.367 264.367 202.367 263.586 201.586L262.414 200.414C261.633 199.633 261.633 198.367 262.414 197.586L263.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.77"
            d="M279.586 196.414C280.367 195.633 281.633 195.633 282.414 196.414L283.586 197.586C284.367 198.367 284.367 199.633 283.586 200.414L282.414 201.586C281.633 202.367 280.367 202.367 279.586 201.586L278.414 200.414C277.633 199.633 277.633 198.367 278.414 197.586L279.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.21"
            d="M295.586 196.414C296.367 195.633 297.633 195.633 298.414 196.414L299.586 197.586C300.367 198.367 300.367 199.633 299.586 200.414L298.414 201.586C297.633 202.367 296.367 202.367 295.586 201.586L294.414 200.414C293.633 199.633 293.633 198.367 294.414 197.586L295.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M311.586 196.414C312.367 195.633 313.633 195.633 314.414 196.414L315.586 197.586C316.367 198.367 316.367 199.633 315.586 200.414L314.414 201.586C313.633 202.367 312.367 202.367 311.586 201.586L310.414 200.414C309.633 199.633 309.633 198.367 310.414 197.586L311.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M327.586 196.414C328.367 195.633 329.633 195.633 330.414 196.414L331.586 197.586C332.367 198.367 332.367 199.633 331.586 200.414L330.414 201.586C329.633 202.367 328.367 202.367 327.586 201.586L326.414 200.414C325.633 199.633 325.633 198.367 326.414 197.586L327.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M343.586 196.414C344.367 195.633 345.633 195.633 346.414 196.414L347.586 197.586C348.367 198.367 348.367 199.633 347.586 200.414L346.414 201.586C345.633 202.367 344.367 202.367 343.586 201.586L342.414 200.414C341.633 199.633 341.633 198.367 342.414 197.586L343.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M359.586 196.414C360.367 195.633 361.633 195.633 362.414 196.414L363.586 197.586C364.367 198.367 364.367 199.633 363.586 200.414L362.414 201.586C361.633 202.367 360.367 202.367 359.586 201.586L358.414 200.414C357.633 199.633 357.633 198.367 358.414 197.586L359.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.74"
            d="M375.586 196.414C376.367 195.633 377.633 195.633 378.414 196.414L379.586 197.586C380.367 198.367 380.367 199.633 379.586 200.414L378.414 201.586C377.633 202.367 376.367 202.367 375.586 201.586L374.414 200.414C373.633 199.633 373.633 198.367 374.414 197.586L375.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M391.586 196.414C392.367 195.633 393.633 195.633 394.414 196.414L395.586 197.586C396.367 198.367 396.367 199.633 395.586 200.414L394.414 201.586C393.633 202.367 392.367 202.367 391.586 201.586L390.414 200.414C389.633 199.633 389.633 198.367 390.414 197.586L391.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.69"
            d="M407.586 196.414C408.367 195.633 409.633 195.633 410.414 196.414L411.586 197.586C412.367 198.367 412.367 199.633 411.586 200.414L410.414 201.586C409.633 202.367 408.367 202.367 407.586 201.586L406.414 200.414C405.633 199.633 405.633 198.367 406.414 197.586L407.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M423.586 196.414C424.367 195.633 425.633 195.633 426.414 196.414L427.586 197.586C428.367 198.367 428.367 199.633 427.586 200.414L426.414 201.586C425.633 202.367 424.367 202.367 423.586 201.586L422.414 200.414C421.633 199.633 421.633 198.367 422.414 197.586L423.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M439.586 196.414C440.367 195.633 441.633 195.633 442.414 196.414L443.586 197.586C444.367 198.367 444.367 199.633 443.586 200.414L442.414 201.586C441.633 202.367 440.367 202.367 439.586 201.586L438.414 200.414C437.633 199.633 437.633 198.367 438.414 197.586L439.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.83"
            d="M455.586 196.414C456.367 195.633 457.633 195.633 458.414 196.414L459.586 197.586C460.367 198.367 460.367 199.633 459.586 200.414L458.414 201.586C457.633 202.367 456.367 202.367 455.586 201.586L454.414 200.414C453.633 199.633 453.633 198.367 454.414 197.586L455.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M471.586 196.414C472.367 195.633 473.633 195.633 474.414 196.414L475.586 197.586C476.367 198.367 476.367 199.633 475.586 200.414L474.414 201.586C473.633 202.367 472.367 202.367 471.586 201.586L470.414 200.414C469.633 199.633 469.633 198.367 470.414 197.586L471.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M487.586 196.414C488.367 195.633 489.633 195.633 490.414 196.414L491.586 197.586C492.367 198.367 492.367 199.633 491.586 200.414L490.414 201.586C489.633 202.367 488.367 202.367 487.586 201.586L486.414 200.414C485.633 199.633 485.633 198.367 486.414 197.586L487.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M503.586 196.414C504.367 195.633 505.633 195.633 506.414 196.414L507.586 197.586C508.367 198.367 508.367 199.633 507.586 200.414L506.414 201.586C505.633 202.367 504.367 202.367 503.586 201.586L502.414 200.414C501.633 199.633 501.633 198.367 502.414 197.586L503.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M519.586 196.414C520.367 195.633 521.633 195.633 522.414 196.414L523.586 197.586C524.367 198.367 524.367 199.633 523.586 200.414L522.414 201.586C521.633 202.367 520.367 202.367 519.586 201.586L518.414 200.414C517.633 199.633 517.633 198.367 518.414 197.586L519.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M535.586 196.414C536.367 195.633 537.633 195.633 538.414 196.414L539.586 197.586C540.367 198.367 540.367 199.633 539.586 200.414L538.414 201.586C537.633 202.367 536.367 202.367 535.586 201.586L534.414 200.414C533.633 199.633 533.633 198.367 534.414 197.586L535.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M551.586 196.414C552.367 195.633 553.633 195.633 554.414 196.414L555.586 197.586C556.367 198.367 556.367 199.633 555.586 200.414L554.414 201.586C553.633 202.367 552.367 202.367 551.586 201.586L550.414 200.414C549.633 199.633 549.633 198.367 550.414 197.586L551.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M567.586 196.414C568.367 195.633 569.633 195.633 570.414 196.414L571.586 197.586C572.367 198.367 572.367 199.633 571.586 200.414L570.414 201.586C569.633 202.367 568.367 202.367 567.586 201.586L566.414 200.414C565.633 199.633 565.633 198.367 566.414 197.586L567.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M583.586 196.414C584.367 195.633 585.633 195.633 586.414 196.414L587.586 197.586C588.367 198.367 588.367 199.633 587.586 200.414L586.414 201.586C585.633 202.367 584.367 202.367 583.586 201.586L582.414 200.414C581.633 199.633 581.633 198.367 582.414 197.586L583.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.1"
            d="M599.586 196.414C600.367 195.633 601.633 195.633 602.414 196.414L603.586 197.586C604.367 198.367 604.367 199.633 603.586 200.414L602.414 201.586C601.633 202.367 600.367 202.367 599.586 201.586L598.414 200.414C597.633 199.633 597.633 198.367 598.414 197.586L599.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M615.586 196.414C616.367 195.633 617.633 195.633 618.414 196.414L619.586 197.586C620.367 198.367 620.367 199.633 619.586 200.414L618.414 201.586C617.633 202.367 616.367 202.367 615.586 201.586L614.414 200.414C613.633 199.633 613.633 198.367 614.414 197.586L615.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M631.586 196.414C632.367 195.633 633.633 195.633 634.414 196.414L635.586 197.586C636.367 198.367 636.367 199.633 635.586 200.414L634.414 201.586C633.633 202.367 632.367 202.367 631.586 201.586L630.414 200.414C629.633 199.633 629.633 198.367 630.414 197.586L631.586 196.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M7.58579 212.414C8.36684 211.633 9.63317 211.633 10.4142 212.414L11.5858 213.586C12.3668 214.367 12.3668 215.633 11.5858 216.414L10.4142 217.586C9.63316 218.367 8.36683 218.367 7.58579 217.586L6.41421 216.414C5.63316 215.633 5.63317 214.367 6.41421 213.586L7.58579 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M23.5858 212.414C24.3668 211.633 25.6332 211.633 26.4142 212.414L27.5858 213.586C28.3668 214.367 28.3668 215.633 27.5858 216.414L26.4142 217.586C25.6332 218.367 24.3668 218.367 23.5858 217.586L22.4142 216.414C21.6332 215.633 21.6332 214.367 22.4142 213.586L23.5858 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M39.5858 212.414C40.3668 211.633 41.6332 211.633 42.4142 212.414L43.5858 213.586C44.3668 214.367 44.3668 215.633 43.5858 216.414L42.4142 217.586C41.6332 218.367 40.3668 218.367 39.5858 217.586L38.4142 216.414C37.6332 215.633 37.6332 214.367 38.4142 213.586L39.5858 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M55.5858 212.414C56.3668 211.633 57.6332 211.633 58.4142 212.414L59.5858 213.586C60.3668 214.367 60.3668 215.633 59.5858 216.414L58.4142 217.586C57.6332 218.367 56.3668 218.367 55.5858 217.586L54.4142 216.414C53.6332 215.633 53.6332 214.367 54.4142 213.586L55.5858 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M71.5858 212.414C72.3668 211.633 73.6332 211.633 74.4142 212.414L75.5858 213.586C76.3668 214.367 76.3668 215.633 75.5858 216.414L74.4142 217.586C73.6332 218.367 72.3668 218.367 71.5858 217.586L70.4142 216.414C69.6332 215.633 69.6332 214.367 70.4142 213.586L71.5858 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M87.5858 212.414C88.3668 211.633 89.6332 211.633 90.4142 212.414L91.5858 213.586C92.3668 214.367 92.3668 215.633 91.5858 216.414L90.4142 217.586C89.6332 218.367 88.3668 218.367 87.5858 217.586L86.4142 216.414C85.6332 215.633 85.6332 214.367 86.4142 213.586L87.5858 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.54"
            d="M103.586 212.414C104.367 211.633 105.633 211.633 106.414 212.414L107.586 213.586C108.367 214.367 108.367 215.633 107.586 216.414L106.414 217.586C105.633 218.367 104.367 218.367 103.586 217.586L102.414 216.414C101.633 215.633 101.633 214.367 102.414 213.586L103.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.68"
            d="M119.586 212.414C120.367 211.633 121.633 211.633 122.414 212.414L123.586 213.586C124.367 214.367 124.367 215.633 123.586 216.414L122.414 217.586C121.633 218.367 120.367 218.367 119.586 217.586L118.414 216.414C117.633 215.633 117.633 214.367 118.414 213.586L119.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M135.586 212.414C136.367 211.633 137.633 211.633 138.414 212.414L139.586 213.586C140.367 214.367 140.367 215.633 139.586 216.414L138.414 217.586C137.633 218.367 136.367 218.367 135.586 217.586L134.414 216.414C133.633 215.633 133.633 214.367 134.414 213.586L135.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.56"
            d="M151.586 212.414C152.367 211.633 153.633 211.633 154.414 212.414L155.586 213.586C156.367 214.367 156.367 215.633 155.586 216.414L154.414 217.586C153.633 218.367 152.367 218.367 151.586 217.586L150.414 216.414C149.633 215.633 149.633 214.367 150.414 213.586L151.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M167.586 212.414C168.367 211.633 169.633 211.633 170.414 212.414L171.586 213.586C172.367 214.367 172.367 215.633 171.586 216.414L170.414 217.586C169.633 218.367 168.367 218.367 167.586 217.586L166.414 216.414C165.633 215.633 165.633 214.367 166.414 213.586L167.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M183.586 212.414C184.367 211.633 185.633 211.633 186.414 212.414L187.586 213.586C188.367 214.367 188.367 215.633 187.586 216.414L186.414 217.586C185.633 218.367 184.367 218.367 183.586 217.586L182.414 216.414C181.633 215.633 181.633 214.367 182.414 213.586L183.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M199.586 212.414C200.367 211.633 201.633 211.633 202.414 212.414L203.586 213.586C204.367 214.367 204.367 215.633 203.586 216.414L202.414 217.586C201.633 218.367 200.367 218.367 199.586 217.586L198.414 216.414C197.633 215.633 197.633 214.367 198.414 213.586L199.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.26"
            d="M215.586 212.414C216.367 211.633 217.633 211.633 218.414 212.414L219.586 213.586C220.367 214.367 220.367 215.633 219.586 216.414L218.414 217.586C217.633 218.367 216.367 218.367 215.586 217.586L214.414 216.414C213.633 215.633 213.633 214.367 214.414 213.586L215.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.53"
            d="M231.586 212.414C232.367 211.633 233.633 211.633 234.414 212.414L235.586 213.586C236.367 214.367 236.367 215.633 235.586 216.414L234.414 217.586C233.633 218.367 232.367 218.367 231.586 217.586L230.414 216.414C229.633 215.633 229.633 214.367 230.414 213.586L231.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M247.586 212.414C248.367 211.633 249.633 211.633 250.414 212.414L251.586 213.586C252.367 214.367 252.367 215.633 251.586 216.414L250.414 217.586C249.633 218.367 248.367 218.367 247.586 217.586L246.414 216.414C245.633 215.633 245.633 214.367 246.414 213.586L247.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M263.586 212.414C264.367 211.633 265.633 211.633 266.414 212.414L267.586 213.586C268.367 214.367 268.367 215.633 267.586 216.414L266.414 217.586C265.633 218.367 264.367 218.367 263.586 217.586L262.414 216.414C261.633 215.633 261.633 214.367 262.414 213.586L263.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.44"
            d="M279.586 212.414C280.367 211.633 281.633 211.633 282.414 212.414L283.586 213.586C284.367 214.367 284.367 215.633 283.586 216.414L282.414 217.586C281.633 218.367 280.367 218.367 279.586 217.586L278.414 216.414C277.633 215.633 277.633 214.367 278.414 213.586L279.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            d="M295.586 212.414C296.367 211.633 297.633 211.633 298.414 212.414L299.586 213.586C300.367 214.367 300.367 215.633 299.586 216.414L298.414 217.586C297.633 218.367 296.367 218.367 295.586 217.586L294.414 216.414C293.633 215.633 293.633 214.367 294.414 213.586L295.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.84"
            d="M311.586 212.414C312.367 211.633 313.633 211.633 314.414 212.414L315.586 213.586C316.367 214.367 316.367 215.633 315.586 216.414L314.414 217.586C313.633 218.367 312.367 218.367 311.586 217.586L310.414 216.414C309.633 215.633 309.633 214.367 310.414 213.586L311.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M327.586 212.414C328.367 211.633 329.633 211.633 330.414 212.414L331.586 213.586C332.367 214.367 332.367 215.633 331.586 216.414L330.414 217.586C329.633 218.367 328.367 218.367 327.586 217.586L326.414 216.414C325.633 215.633 325.633 214.367 326.414 213.586L327.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M343.586 212.414C344.367 211.633 345.633 211.633 346.414 212.414L347.586 213.586C348.367 214.367 348.367 215.633 347.586 216.414L346.414 217.586C345.633 218.367 344.367 218.367 343.586 217.586L342.414 216.414C341.633 215.633 341.633 214.367 342.414 213.586L343.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.67"
            d="M359.586 212.414C360.367 211.633 361.633 211.633 362.414 212.414L363.586 213.586C364.367 214.367 364.367 215.633 363.586 216.414L362.414 217.586C361.633 218.367 360.367 218.367 359.586 217.586L358.414 216.414C357.633 215.633 357.633 214.367 358.414 213.586L359.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M375.586 212.414C376.367 211.633 377.633 211.633 378.414 212.414L379.586 213.586C380.367 214.367 380.367 215.633 379.586 216.414L378.414 217.586C377.633 218.367 376.367 218.367 375.586 217.586L374.414 216.414C373.633 215.633 373.633 214.367 374.414 213.586L375.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M391.586 212.414C392.367 211.633 393.633 211.633 394.414 212.414L395.586 213.586C396.367 214.367 396.367 215.633 395.586 216.414L394.414 217.586C393.633 218.367 392.367 218.367 391.586 217.586L390.414 216.414C389.633 215.633 389.633 214.367 390.414 213.586L391.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.7"
            d="M407.586 212.414C408.367 211.633 409.633 211.633 410.414 212.414L411.586 213.586C412.367 214.367 412.367 215.633 411.586 216.414L410.414 217.586C409.633 218.367 408.367 218.367 407.586 217.586L406.414 216.414C405.633 215.633 405.633 214.367 406.414 213.586L407.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M423.586 212.414C424.367 211.633 425.633 211.633 426.414 212.414L427.586 213.586C428.367 214.367 428.367 215.633 427.586 216.414L426.414 217.586C425.633 218.367 424.367 218.367 423.586 217.586L422.414 216.414C421.633 215.633 421.633 214.367 422.414 213.586L423.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.96"
            d="M439.586 212.414C440.367 211.633 441.633 211.633 442.414 212.414L443.586 213.586C444.367 214.367 444.367 215.633 443.586 216.414L442.414 217.586C441.633 218.367 440.367 218.367 439.586 217.586L438.414 216.414C437.633 215.633 437.633 214.367 438.414 213.586L439.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.18"
            d="M455.586 212.414C456.367 211.633 457.633 211.633 458.414 212.414L459.586 213.586C460.367 214.367 460.367 215.633 459.586 216.414L458.414 217.586C457.633 218.367 456.367 218.367 455.586 217.586L454.414 216.414C453.633 215.633 453.633 214.367 454.414 213.586L455.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M471.586 212.414C472.367 211.633 473.633 211.633 474.414 212.414L475.586 213.586C476.367 214.367 476.367 215.633 475.586 216.414L474.414 217.586C473.633 218.367 472.367 218.367 471.586 217.586L470.414 216.414C469.633 215.633 469.633 214.367 470.414 213.586L471.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M487.586 212.414C488.367 211.633 489.633 211.633 490.414 212.414L491.586 213.586C492.367 214.367 492.367 215.633 491.586 216.414L490.414 217.586C489.633 218.367 488.367 218.367 487.586 217.586L486.414 216.414C485.633 215.633 485.633 214.367 486.414 213.586L487.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.9"
            d="M503.586 212.414C504.367 211.633 505.633 211.633 506.414 212.414L507.586 213.586C508.367 214.367 508.367 215.633 507.586 216.414L506.414 217.586C505.633 218.367 504.367 218.367 503.586 217.586L502.414 216.414C501.633 215.633 501.633 214.367 502.414 213.586L503.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M519.586 212.414C520.367 211.633 521.633 211.633 522.414 212.414L523.586 213.586C524.367 214.367 524.367 215.633 523.586 216.414L522.414 217.586C521.633 218.367 520.367 218.367 519.586 217.586L518.414 216.414C517.633 215.633 517.633 214.367 518.414 213.586L519.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M535.586 212.414C536.367 211.633 537.633 211.633 538.414 212.414L539.586 213.586C540.367 214.367 540.367 215.633 539.586 216.414L538.414 217.586C537.633 218.367 536.367 218.367 535.586 217.586L534.414 216.414C533.633 215.633 533.633 214.367 534.414 213.586L535.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M551.586 212.414C552.367 211.633 553.633 211.633 554.414 212.414L555.586 213.586C556.367 214.367 556.367 215.633 555.586 216.414L554.414 217.586C553.633 218.367 552.367 218.367 551.586 217.586L550.414 216.414C549.633 215.633 549.633 214.367 550.414 213.586L551.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M567.586 212.414C568.367 211.633 569.633 211.633 570.414 212.414L571.586 213.586C572.367 214.367 572.367 215.633 571.586 216.414L570.414 217.586C569.633 218.367 568.367 218.367 567.586 217.586L566.414 216.414C565.633 215.633 565.633 214.367 566.414 213.586L567.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M583.586 212.414C584.367 211.633 585.633 211.633 586.414 212.414L587.586 213.586C588.367 214.367 588.367 215.633 587.586 216.414L586.414 217.586C585.633 218.367 584.367 218.367 583.586 217.586L582.414 216.414C581.633 215.633 581.633 214.367 582.414 213.586L583.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M599.586 212.414C600.367 211.633 601.633 211.633 602.414 212.414L603.586 213.586C604.367 214.367 604.367 215.633 603.586 216.414L602.414 217.586C601.633 218.367 600.367 218.367 599.586 217.586L598.414 216.414C597.633 215.633 597.633 214.367 598.414 213.586L599.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.27"
            d="M615.586 212.414C616.367 211.633 617.633 211.633 618.414 212.414L619.586 213.586C620.367 214.367 620.367 215.633 619.586 216.414L618.414 217.586C617.633 218.367 616.367 218.367 615.586 217.586L614.414 216.414C613.633 215.633 613.633 214.367 614.414 213.586L615.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M631.586 212.414C632.367 211.633 633.633 211.633 634.414 212.414L635.586 213.586C636.367 214.367 636.367 215.633 635.586 216.414L634.414 217.586C633.633 218.367 632.367 218.367 631.586 217.586L630.414 216.414C629.633 215.633 629.633 214.367 630.414 213.586L631.586 212.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M7.58579 228.414C8.36684 227.633 9.63317 227.633 10.4142 228.414L11.5858 229.586C12.3668 230.367 12.3668 231.633 11.5858 232.414L10.4142 233.586C9.63316 234.367 8.36683 234.367 7.58579 233.586L6.41421 232.414C5.63316 231.633 5.63317 230.367 6.41421 229.586L7.58579 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.4"
            d="M23.5858 228.414C24.3668 227.633 25.6332 227.633 26.4142 228.414L27.5858 229.586C28.3668 230.367 28.3668 231.633 27.5858 232.414L26.4142 233.586C25.6332 234.367 24.3668 234.367 23.5858 233.586L22.4142 232.414C21.6332 231.633 21.6332 230.367 22.4142 229.586L23.5858 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M39.5858 228.414C40.3668 227.633 41.6332 227.633 42.4142 228.414L43.5858 229.586C44.3668 230.367 44.3668 231.633 43.5858 232.414L42.4142 233.586C41.6332 234.367 40.3668 234.367 39.5858 233.586L38.4142 232.414C37.6332 231.633 37.6332 230.367 38.4142 229.586L39.5858 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.81"
            d="M55.5858 228.414C56.3668 227.633 57.6332 227.633 58.4142 228.414L59.5858 229.586C60.3668 230.367 60.3668 231.633 59.5858 232.414L58.4142 233.586C57.6332 234.367 56.3668 234.367 55.5858 233.586L54.4142 232.414C53.6332 231.633 53.6332 230.367 54.4142 229.586L55.5858 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M71.5858 228.414C72.3668 227.633 73.6332 227.633 74.4142 228.414L75.5858 229.586C76.3668 230.367 76.3668 231.633 75.5858 232.414L74.4142 233.586C73.6332 234.367 72.3668 234.367 71.5858 233.586L70.4142 232.414C69.6332 231.633 69.6332 230.367 70.4142 229.586L71.5858 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M87.5858 228.414C88.3668 227.633 89.6332 227.633 90.4142 228.414L91.5858 229.586C92.3668 230.367 92.3668 231.633 91.5858 232.414L90.4142 233.586C89.6332 234.367 88.3668 234.367 87.5858 233.586L86.4142 232.414C85.6332 231.633 85.6332 230.367 86.4142 229.586L87.5858 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M103.586 228.414C104.367 227.633 105.633 227.633 106.414 228.414L107.586 229.586C108.367 230.367 108.367 231.633 107.586 232.414L106.414 233.586C105.633 234.367 104.367 234.367 103.586 233.586L102.414 232.414C101.633 231.633 101.633 230.367 102.414 229.586L103.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M119.586 228.414C120.367 227.633 121.633 227.633 122.414 228.414L123.586 229.586C124.367 230.367 124.367 231.633 123.586 232.414L122.414 233.586C121.633 234.367 120.367 234.367 119.586 233.586L118.414 232.414C117.633 231.633 117.633 230.367 118.414 229.586L119.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.89"
            d="M135.586 228.414C136.367 227.633 137.633 227.633 138.414 228.414L139.586 229.586C140.367 230.367 140.367 231.633 139.586 232.414L138.414 233.586C137.633 234.367 136.367 234.367 135.586 233.586L134.414 232.414C133.633 231.633 133.633 230.367 134.414 229.586L135.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M151.586 228.414C152.367 227.633 153.633 227.633 154.414 228.414L155.586 229.586C156.367 230.367 156.367 231.633 155.586 232.414L154.414 233.586C153.633 234.367 152.367 234.367 151.586 233.586L150.414 232.414C149.633 231.633 149.633 230.367 150.414 229.586L151.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M167.586 228.414C168.367 227.633 169.633 227.633 170.414 228.414L171.586 229.586C172.367 230.367 172.367 231.633 171.586 232.414L170.414 233.586C169.633 234.367 168.367 234.367 167.586 233.586L166.414 232.414C165.633 231.633 165.633 230.367 166.414 229.586L167.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M183.586 228.414C184.367 227.633 185.633 227.633 186.414 228.414L187.586 229.586C188.367 230.367 188.367 231.633 187.586 232.414L186.414 233.586C185.633 234.367 184.367 234.367 183.586 233.586L182.414 232.414C181.633 231.633 181.633 230.367 182.414 229.586L183.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M199.586 228.414C200.367 227.633 201.633 227.633 202.414 228.414L203.586 229.586C204.367 230.367 204.367 231.633 203.586 232.414L202.414 233.586C201.633 234.367 200.367 234.367 199.586 233.586L198.414 232.414C197.633 231.633 197.633 230.367 198.414 229.586L199.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.73"
            d="M215.586 228.414C216.367 227.633 217.633 227.633 218.414 228.414L219.586 229.586C220.367 230.367 220.367 231.633 219.586 232.414L218.414 233.586C217.633 234.367 216.367 234.367 215.586 233.586L214.414 232.414C213.633 231.633 213.633 230.367 214.414 229.586L215.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.75"
            d="M231.586 228.414C232.367 227.633 233.633 227.633 234.414 228.414L235.586 229.586C236.367 230.367 236.367 231.633 235.586 232.414L234.414 233.586C233.633 234.367 232.367 234.367 231.586 233.586L230.414 232.414C229.633 231.633 229.633 230.367 230.414 229.586L231.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M247.586 228.414C248.367 227.633 249.633 227.633 250.414 228.414L251.586 229.586C252.367 230.367 252.367 231.633 251.586 232.414L250.414 233.586C249.633 234.367 248.367 234.367 247.586 233.586L246.414 232.414C245.633 231.633 245.633 230.367 246.414 229.586L247.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.65"
            d="M263.586 228.414C264.367 227.633 265.633 227.633 266.414 228.414L267.586 229.586C268.367 230.367 268.367 231.633 267.586 232.414L266.414 233.586C265.633 234.367 264.367 234.367 263.586 233.586L262.414 232.414C261.633 231.633 261.633 230.367 262.414 229.586L263.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.26"
            d="M279.586 228.414C280.367 227.633 281.633 227.633 282.414 228.414L283.586 229.586C284.367 230.367 284.367 231.633 283.586 232.414L282.414 233.586C281.633 234.367 280.367 234.367 279.586 233.586L278.414 232.414C277.633 231.633 277.633 230.367 278.414 229.586L279.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M295.586 228.414C296.367 227.633 297.633 227.633 298.414 228.414L299.586 229.586C300.367 230.367 300.367 231.633 299.586 232.414L298.414 233.586C297.633 234.367 296.367 234.367 295.586 233.586L294.414 232.414C293.633 231.633 293.633 230.367 294.414 229.586L295.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M311.586 228.414C312.367 227.633 313.633 227.633 314.414 228.414L315.586 229.586C316.367 230.367 316.367 231.633 315.586 232.414L314.414 233.586C313.633 234.367 312.367 234.367 311.586 233.586L310.414 232.414C309.633 231.633 309.633 230.367 310.414 229.586L311.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.39"
            d="M327.586 228.414C328.367 227.633 329.633 227.633 330.414 228.414L331.586 229.586C332.367 230.367 332.367 231.633 331.586 232.414L330.414 233.586C329.633 234.367 328.367 234.367 327.586 233.586L326.414 232.414C325.633 231.633 325.633 230.367 326.414 229.586L327.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M343.586 228.414C344.367 227.633 345.633 227.633 346.414 228.414L347.586 229.586C348.367 230.367 348.367 231.633 347.586 232.414L346.414 233.586C345.633 234.367 344.367 234.367 343.586 233.586L342.414 232.414C341.633 231.633 341.633 230.367 342.414 229.586L343.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M359.586 228.414C360.367 227.633 361.633 227.633 362.414 228.414L363.586 229.586C364.367 230.367 364.367 231.633 363.586 232.414L362.414 233.586C361.633 234.367 360.367 234.367 359.586 233.586L358.414 232.414C357.633 231.633 357.633 230.367 358.414 229.586L359.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M375.586 228.414C376.367 227.633 377.633 227.633 378.414 228.414L379.586 229.586C380.367 230.367 380.367 231.633 379.586 232.414L378.414 233.586C377.633 234.367 376.367 234.367 375.586 233.586L374.414 232.414C373.633 231.633 373.633 230.367 374.414 229.586L375.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.13"
            d="M391.586 228.414C392.367 227.633 393.633 227.633 394.414 228.414L395.586 229.586C396.367 230.367 396.367 231.633 395.586 232.414L394.414 233.586C393.633 234.367 392.367 234.367 391.586 233.586L390.414 232.414C389.633 231.633 389.633 230.367 390.414 229.586L391.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.42"
            d="M407.586 228.414C408.367 227.633 409.633 227.633 410.414 228.414L411.586 229.586C412.367 230.367 412.367 231.633 411.586 232.414L410.414 233.586C409.633 234.367 408.367 234.367 407.586 233.586L406.414 232.414C405.633 231.633 405.633 230.367 406.414 229.586L407.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.72"
            d="M423.586 228.414C424.367 227.633 425.633 227.633 426.414 228.414L427.586 229.586C428.367 230.367 428.367 231.633 427.586 232.414L426.414 233.586C425.633 234.367 424.367 234.367 423.586 233.586L422.414 232.414C421.633 231.633 421.633 230.367 422.414 229.586L423.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.16"
            d="M439.586 228.414C440.367 227.633 441.633 227.633 442.414 228.414L443.586 229.586C444.367 230.367 444.367 231.633 443.586 232.414L442.414 233.586C441.633 234.367 440.367 234.367 439.586 233.586L438.414 232.414C437.633 231.633 437.633 230.367 438.414 229.586L439.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.61"
            d="M455.586 228.414C456.367 227.633 457.633 227.633 458.414 228.414L459.586 229.586C460.367 230.367 460.367 231.633 459.586 232.414L458.414 233.586C457.633 234.367 456.367 234.367 455.586 233.586L454.414 232.414C453.633 231.633 453.633 230.367 454.414 229.586L455.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.8"
            d="M471.586 228.414C472.367 227.633 473.633 227.633 474.414 228.414L475.586 229.586C476.367 230.367 476.367 231.633 475.586 232.414L474.414 233.586C473.633 234.367 472.367 234.367 471.586 233.586L470.414 232.414C469.633 231.633 469.633 230.367 470.414 229.586L471.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.87"
            d="M487.586 228.414C488.367 227.633 489.633 227.633 490.414 228.414L491.586 229.586C492.367 230.367 492.367 231.633 491.586 232.414L490.414 233.586C489.633 234.367 488.367 234.367 487.586 233.586L486.414 232.414C485.633 231.633 485.633 230.367 486.414 229.586L487.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.14"
            d="M503.586 228.414C504.367 227.633 505.633 227.633 506.414 228.414L507.586 229.586C508.367 230.367 508.367 231.633 507.586 232.414L506.414 233.586C505.633 234.367 504.367 234.367 503.586 233.586L502.414 232.414C501.633 231.633 501.633 230.367 502.414 229.586L503.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.35"
            d="M519.586 228.414C520.367 227.633 521.633 227.633 522.414 228.414L523.586 229.586C524.367 230.367 524.367 231.633 523.586 232.414L522.414 233.586C521.633 234.367 520.367 234.367 519.586 233.586L518.414 232.414C517.633 231.633 517.633 230.367 518.414 229.586L519.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.24"
            d="M535.586 228.414C536.367 227.633 537.633 227.633 538.414 228.414L539.586 229.586C540.367 230.367 540.367 231.633 539.586 232.414L538.414 233.586C537.633 234.367 536.367 234.367 535.586 233.586L534.414 232.414C533.633 231.633 533.633 230.367 534.414 229.586L535.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.22"
            d="M551.586 228.414C552.367 227.633 553.633 227.633 554.414 228.414L555.586 229.586C556.367 230.367 556.367 231.633 555.586 232.414L554.414 233.586C553.633 234.367 552.367 234.367 551.586 233.586L550.414 232.414C549.633 231.633 549.633 230.367 550.414 229.586L551.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.88"
            d="M567.586 228.414C568.367 227.633 569.633 227.633 570.414 228.414L571.586 229.586C572.367 230.367 572.367 231.633 571.586 232.414L570.414 233.586C569.633 234.367 568.367 234.367 567.586 233.586L566.414 232.414C565.633 231.633 565.633 230.367 566.414 229.586L567.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.98"
            d="M583.586 228.414C584.367 227.633 585.633 227.633 586.414 228.414L587.586 229.586C588.367 230.367 588.367 231.633 587.586 232.414L586.414 233.586C585.633 234.367 584.367 234.367 583.586 233.586L582.414 232.414C581.633 231.633 581.633 230.367 582.414 229.586L583.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M599.586 228.414C600.367 227.633 601.633 227.633 602.414 228.414L603.586 229.586C604.367 230.367 604.367 231.633 603.586 232.414L602.414 233.586C601.633 234.367 600.367 234.367 599.586 233.586L598.414 232.414C597.633 231.633 597.633 230.367 598.414 229.586L599.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.64"
            d="M615.586 228.414C616.367 227.633 617.633 227.633 618.414 228.414L619.586 229.586C620.367 230.367 620.367 231.633 619.586 232.414L618.414 233.586C617.633 234.367 616.367 234.367 615.586 233.586L614.414 232.414C613.633 231.633 613.633 230.367 614.414 229.586L615.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.67"
            d="M631.586 228.414C632.367 227.633 633.633 227.633 634.414 228.414L635.586 229.586C636.367 230.367 636.367 231.633 635.586 232.414L634.414 233.586C633.633 234.367 632.367 234.367 631.586 233.586L630.414 232.414C629.633 231.633 629.633 230.367 630.414 229.586L631.586 228.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.36"
            d="M7.58579 244.414C8.36684 243.633 9.63317 243.633 10.4142 244.414L11.5858 245.586C12.3668 246.367 12.3668 247.633 11.5858 248.414L10.4142 249.586C9.63316 250.367 8.36683 250.367 7.58579 249.586L6.41421 248.414C5.63316 247.633 5.63317 246.367 6.41421 245.586L7.58579 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M23.5858 244.414C24.3668 243.633 25.6332 243.633 26.4142 244.414L27.5858 245.586C28.3668 246.367 28.3668 247.633 27.5858 248.414L26.4142 249.586C25.6332 250.367 24.3668 250.367 23.5858 249.586L22.4142 248.414C21.6332 247.633 21.6332 246.367 22.4142 245.586L23.5858 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.34"
            d="M39.5858 244.414C40.3668 243.633 41.6332 243.633 42.4142 244.414L43.5858 245.586C44.3668 246.367 44.3668 247.633 43.5858 248.414L42.4142 249.586C41.6332 250.367 40.3668 250.367 39.5858 249.586L38.4142 248.414C37.6332 247.633 37.6332 246.367 38.4142 245.586L39.5858 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.97"
            d="M55.5858 244.414C56.3668 243.633 57.6332 243.633 58.4142 244.414L59.5858 245.586C60.3668 246.367 60.3668 247.633 59.5858 248.414L58.4142 249.586C57.6332 250.367 56.3668 250.367 55.5858 249.586L54.4142 248.414C53.6332 247.633 53.6332 246.367 54.4142 245.586L55.5858 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.78"
            d="M71.5858 244.414C72.3668 243.633 73.6332 243.633 74.4142 244.414L75.5858 245.586C76.3668 246.367 76.3668 247.633 75.5858 248.414L74.4142 249.586C73.6332 250.367 72.3668 250.367 71.5858 249.586L70.4142 248.414C69.6332 247.633 69.6332 246.367 70.4142 245.586L71.5858 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.2"
            d="M87.5858 244.414C88.3668 243.633 89.6332 243.633 90.4142 244.414L91.5858 245.586C92.3668 246.367 92.3668 247.633 91.5858 248.414L90.4142 249.586C89.6332 250.367 88.3668 250.367 87.5858 249.586L86.4142 248.414C85.6332 247.633 85.6332 246.367 86.4142 245.586L87.5858 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.86"
            d="M103.586 244.414C104.367 243.633 105.633 243.633 106.414 244.414L107.586 245.586C108.367 246.367 108.367 247.633 107.586 248.414L106.414 249.586C105.633 250.367 104.367 250.367 103.586 249.586L102.414 248.414C101.633 247.633 101.633 246.367 102.414 245.586L103.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M119.586 244.414C120.367 243.633 121.633 243.633 122.414 244.414L123.586 245.586C124.367 246.367 124.367 247.633 123.586 248.414L122.414 249.586C121.633 250.367 120.367 250.367 119.586 249.586L118.414 248.414C117.633 247.633 117.633 246.367 118.414 245.586L119.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.57"
            d="M135.586 244.414C136.367 243.633 137.633 243.633 138.414 244.414L139.586 245.586C140.367 246.367 140.367 247.633 139.586 248.414L138.414 249.586C137.633 250.367 136.367 250.367 135.586 249.586L134.414 248.414C133.633 247.633 133.633 246.367 134.414 245.586L135.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.62"
            d="M151.586 244.414C152.367 243.633 153.633 243.633 154.414 244.414L155.586 245.586C156.367 246.367 156.367 247.633 155.586 248.414L154.414 249.586C153.633 250.367 152.367 250.367 151.586 249.586L150.414 248.414C149.633 247.633 149.633 246.367 150.414 245.586L151.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.46"
            d="M167.586 244.414C168.367 243.633 169.633 243.633 170.414 244.414L171.586 245.586C172.367 246.367 172.367 247.633 171.586 248.414L170.414 249.586C169.633 250.367 168.367 250.367 167.586 249.586L166.414 248.414C165.633 247.633 165.633 246.367 166.414 245.586L167.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.41"
            d="M183.586 244.414C184.367 243.633 185.633 243.633 186.414 244.414L187.586 245.586C188.367 246.367 188.367 247.633 187.586 248.414L186.414 249.586C185.633 250.367 184.367 250.367 183.586 249.586L182.414 248.414C181.633 247.633 181.633 246.367 182.414 245.586L183.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.47"
            d="M199.586 244.414C200.367 243.633 201.633 243.633 202.414 244.414L203.586 245.586C204.367 246.367 204.367 247.633 203.586 248.414L202.414 249.586C201.633 250.367 200.367 250.367 199.586 249.586L198.414 248.414C197.633 247.633 197.633 246.367 198.414 245.586L199.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M215.586 244.414C216.367 243.633 217.633 243.633 218.414 244.414L219.586 245.586C220.367 246.367 220.367 247.633 219.586 248.414L218.414 249.586C217.633 250.367 216.367 250.367 215.586 249.586L214.414 248.414C213.633 247.633 213.633 246.367 214.414 245.586L215.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.51"
            d="M231.586 244.414C232.367 243.633 233.633 243.633 234.414 244.414L235.586 245.586C236.367 246.367 236.367 247.633 235.586 248.414L234.414 249.586C233.633 250.367 232.367 250.367 231.586 249.586L230.414 248.414C229.633 247.633 229.633 246.367 230.414 245.586L231.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.43"
            d="M247.586 244.414C248.367 243.633 249.633 243.633 250.414 244.414L251.586 245.586C252.367 246.367 252.367 247.633 251.586 248.414L250.414 249.586C249.633 250.367 248.367 250.367 247.586 249.586L246.414 248.414C245.633 247.633 245.633 246.367 246.414 245.586L247.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.63"
            d="M263.586 244.414C264.367 243.633 265.633 243.633 266.414 244.414L267.586 245.586C268.367 246.367 268.367 247.633 267.586 248.414L266.414 249.586C265.633 250.367 264.367 250.367 263.586 249.586L262.414 248.414C261.633 247.633 261.633 246.367 262.414 245.586L263.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M279.586 244.414C280.367 243.633 281.633 243.633 282.414 244.414L283.586 245.586C284.367 246.367 284.367 247.633 283.586 248.414L282.414 249.586C281.633 250.367 280.367 250.367 279.586 249.586L278.414 248.414C277.633 247.633 277.633 246.367 278.414 245.586L279.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.89"
            d="M295.586 244.414C296.367 243.633 297.633 243.633 298.414 244.414L299.586 245.586C300.367 246.367 300.367 247.633 299.586 248.414L298.414 249.586C297.633 250.367 296.367 250.367 295.586 249.586L294.414 248.414C293.633 247.633 293.633 246.367 294.414 245.586L295.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.5"
            d="M311.586 244.414C312.367 243.633 313.633 243.633 314.414 244.414L315.586 245.586C316.367 246.367 316.367 247.633 315.586 248.414L314.414 249.586C313.633 250.367 312.367 250.367 311.586 249.586L310.414 248.414C309.633 247.633 309.633 246.367 310.414 245.586L311.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M327.586 244.414C328.367 243.633 329.633 243.633 330.414 244.414L331.586 245.586C332.367 246.367 332.367 247.633 331.586 248.414L330.414 249.586C329.633 250.367 328.367 250.367 327.586 249.586L326.414 248.414C325.633 247.633 325.633 246.367 326.414 245.586L327.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.95"
            d="M343.586 244.414C344.367 243.633 345.633 243.633 346.414 244.414L347.586 245.586C348.367 246.367 348.367 247.633 347.586 248.414L346.414 249.586C345.633 250.367 344.367 250.367 343.586 249.586L342.414 248.414C341.633 247.633 341.633 246.367 342.414 245.586L343.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.91"
            d="M359.586 244.414C360.367 243.633 361.633 243.633 362.414 244.414L363.586 245.586C364.367 246.367 364.367 247.633 363.586 248.414L362.414 249.586C361.633 250.367 360.367 250.367 359.586 249.586L358.414 248.414C357.633 247.633 357.633 246.367 358.414 245.586L359.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.1"
            d="M375.586 244.414C376.367 243.633 377.633 243.633 378.414 244.414L379.586 245.586C380.367 246.367 380.367 247.633 379.586 248.414L378.414 249.586C377.633 250.367 376.367 250.367 375.586 249.586L374.414 248.414C373.633 247.633 373.633 246.367 374.414 245.586L375.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.32"
            d="M391.586 244.414C392.367 243.633 393.633 243.633 394.414 244.414L395.586 245.586C396.367 246.367 396.367 247.633 395.586 248.414L394.414 249.586C393.633 250.367 392.367 250.367 391.586 249.586L390.414 248.414C389.633 247.633 389.633 246.367 390.414 245.586L391.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M407.586 244.414C408.367 243.633 409.633 243.633 410.414 244.414L411.586 245.586C412.367 246.367 412.367 247.633 411.586 248.414L410.414 249.586C409.633 250.367 408.367 250.367 407.586 249.586L406.414 248.414C405.633 247.633 405.633 246.367 406.414 245.586L407.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.45"
            d="M423.586 244.414C424.367 243.633 425.633 243.633 426.414 244.414L427.586 245.586C428.367 246.367 428.367 247.633 427.586 248.414L426.414 249.586C425.633 250.367 424.367 250.367 423.586 249.586L422.414 248.414C421.633 247.633 421.633 246.367 422.414 245.586L423.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.3"
            d="M439.586 244.414C440.367 243.633 441.633 243.633 442.414 244.414L443.586 245.586C444.367 246.367 444.367 247.633 443.586 248.414L442.414 249.586C441.633 250.367 440.367 250.367 439.586 249.586L438.414 248.414C437.633 247.633 437.633 246.367 438.414 245.586L439.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.76"
            d="M455.586 244.414C456.367 243.633 457.633 243.633 458.414 244.414L459.586 245.586C460.367 246.367 460.367 247.633 459.586 248.414L458.414 249.586C457.633 250.367 456.367 250.367 455.586 249.586L454.414 248.414C453.633 247.633 453.633 246.367 454.414 245.586L455.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.49"
            d="M471.586 244.414C472.367 243.633 473.633 243.633 474.414 244.414L475.586 245.586C476.367 246.367 476.367 247.633 475.586 248.414L474.414 249.586C473.633 250.367 472.367 250.367 471.586 249.586L470.414 248.414C469.633 247.633 469.633 246.367 470.414 245.586L471.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.28"
            d="M487.586 244.414C488.367 243.633 489.633 243.633 490.414 244.414L491.586 245.586C492.367 246.367 492.367 247.633 491.586 248.414L490.414 249.586C489.633 250.367 488.367 250.367 487.586 249.586L486.414 248.414C485.633 247.633 485.633 246.367 486.414 245.586L487.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.15"
            d="M503.586 244.414C504.367 243.633 505.633 243.633 506.414 244.414L507.586 245.586C508.367 246.367 508.367 247.633 507.586 248.414L506.414 249.586C505.633 250.367 504.367 250.367 503.586 249.586L502.414 248.414C501.633 247.633 501.633 246.367 502.414 245.586L503.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.33"
            d="M519.586 244.414C520.367 243.633 521.633 243.633 522.414 244.414L523.586 245.586C524.367 246.367 524.367 247.633 523.586 248.414L522.414 249.586C521.633 250.367 520.367 250.367 519.586 249.586L518.414 248.414C517.633 247.633 517.633 246.367 518.414 245.586L519.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M535.586 244.414C536.367 243.633 537.633 243.633 538.414 244.414L539.586 245.586C540.367 246.367 540.367 247.633 539.586 248.414L538.414 249.586C537.633 250.367 536.367 250.367 535.586 249.586L534.414 248.414C533.633 247.633 533.633 246.367 534.414 245.586L535.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.99"
            d="M551.586 244.414C552.367 243.633 553.633 243.633 554.414 244.414L555.586 245.586C556.367 246.367 556.367 247.633 555.586 248.414L554.414 249.586C553.633 250.367 552.367 250.367 551.586 249.586L550.414 248.414C549.633 247.633 549.633 246.367 550.414 245.586L551.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.31"
            d="M567.586 244.414C568.367 243.633 569.633 243.633 570.414 244.414L571.586 245.586C572.367 246.367 572.367 247.633 571.586 248.414L570.414 249.586C569.633 250.367 568.367 250.367 567.586 249.586L566.414 248.414C565.633 247.633 565.633 246.367 566.414 245.586L567.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.38"
            d="M583.586 244.414C584.367 243.633 585.633 243.633 586.414 244.414L587.586 245.586C588.367 246.367 588.367 247.633 587.586 248.414L586.414 249.586C585.633 250.367 584.367 250.367 583.586 249.586L582.414 248.414C581.633 247.633 581.633 246.367 582.414 245.586L583.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.52"
            d="M599.586 244.414C600.367 243.633 601.633 243.633 602.414 244.414L603.586 245.586C604.367 246.367 604.367 247.633 603.586 248.414L602.414 249.586C601.633 250.367 600.367 250.367 599.586 249.586L598.414 248.414C597.633 247.633 597.633 246.367 598.414 245.586L599.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.79"
            d="M615.586 244.414C616.367 243.633 617.633 243.633 618.414 244.414L619.586 245.586C620.367 246.367 620.367 247.633 619.586 248.414L618.414 249.586C617.633 250.367 616.367 250.367 615.586 249.586L614.414 248.414C613.633 247.633 613.633 246.367 614.414 245.586L615.586 244.414Z"
            fill="#C5CAFF"
          />
          <path
            opacity="0.6"
            d="M631.586 244.414C632.367 243.633 633.633 243.633 634.414 244.414L635.586 245.586C636.367 246.367 636.367 247.633 635.586 248.414L634.414 249.586C633.633 250.367 632.367 250.367 631.586 249.586L630.414 248.414C629.633 247.633 629.633 246.367 630.414 245.586L631.586 244.414Z"
            fill="#C5CAFF"
          />
        </g>
        <g filter="url(#filter0_ddd_905_5093)">
          <rect
            x="281.5"
            y="87.5"
            width="79"
            height="79"
            rx="13"
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x="281"
            y="87"
            width="80"
            height="80"
            rx="13.5"
            stroke="#C5CAFF"
            shapeRendering="crispEdges"
          />
          <g clipPath="url(#clip1_905_5093)">
            <path
              d="M323.292 127C323.292 128.26 324.323 129.292 325.583 129.292H332.138C331.106 133.233 327.554 136.167 323.292 136.167C318.227 136.167 314.125 132.065 314.125 127C314.125 121.935 318.227 117.833 323.292 117.833C327.554 117.833 331.106 120.767 332.138 124.708H325.583C324.323 124.708 323.292 125.74 323.292 127ZM348.5 115.542V138.458C348.5 143.156 345.658 147.167 341.625 148.954V152.208C341.625 153.469 340.594 154.5 339.333 154.5C338.073 154.5 337.042 153.469 337.042 152.208V149.917H304.958V152.208C304.958 153.469 303.927 154.5 302.667 154.5C301.406 154.5 300.375 153.469 300.375 152.208V148.954C296.342 147.19 293.5 143.156 293.5 138.458H298.083C299.344 138.458 300.375 137.427 300.375 136.167C300.375 134.906 299.344 133.875 298.083 133.875H293.5V120.125H298.083C299.344 120.125 300.375 119.094 300.375 117.833C300.375 116.573 299.344 115.542 298.083 115.542H293.5C293.5 109.217 298.633 104.083 304.958 104.083H337.042C343.367 104.083 348.5 109.217 348.5 115.542ZM337.042 127C337.042 119.415 330.877 113.25 323.292 113.25C315.706 113.25 309.542 119.415 309.542 127C309.542 134.585 315.706 140.75 323.292 140.75C330.877 140.75 337.042 134.585 337.042 127Z"
              fill="#4854D9"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddd_905_5093"
          x="260.5"
          y="76.5"
          width="121"
          height="121"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_905_5093"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_905_5093"
            result="effect2_dropShadow_905_5093"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_905_5093"
            result="effect3_dropShadow_905_5093"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_905_5093"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_905_5093"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(325.476 127.33) rotate(-0.0597114) scale(316.525 248.377)"
        >
          <stop offset="0.125549" stopColor="#737373" stopOpacity="0" />
          <stop offset="0.25" stopColor="#D9D9D9" />
          <stop offset="0.5" stopColor="#737373" stopOpacity="0" />
          <stop offset="0.75" stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_905_5093">
          <rect width="642" height="254" rx="13" fill="white" />
        </clipPath>
        <clipPath id="clip1_905_5093">
          <rect
            width="55"
            height="55"
            fill="white"
            transform="translate(293.5 99.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
